webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return register; });
/* unused harmony export userId */
/* unused harmony export authToken */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return account; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return accountService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





// Point to development environment
// let apiKey = 'J1DWJi6L4710H5opgtgFo40fqQhQTMgwITmOAdPFmj5V70E52cDg478DSdrTy10R'
// let apiRoot = 'https://api.haitipay.com/v1-dev'

var apiKey = 'J1DWJi6L4710H5opgtgFo40fqQhQTMgwITmOAdPFmj5V70E52cDg478DSdrTy10R';
var apiRoot = 'https://api.haitipay.com/v1';

var userId = localStorage.getItem('userId');
var authToken = localStorage.getItem('authToken');

var accountService = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

var register = function register(payload) {
  var url = apiRoot + '/accounts';
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, payload, {
    headers: {
      authorization: apiKey
    }
  });
};

var login = function login(credentials) {
  var url = apiRoot + '/accounts/login';
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, credentials, {
    headers: {
      authorization: apiKey
    }
  });
};

var HTTP = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: apiRoot,
  headers: {
    authorization: apiKey
  }
});

function account(userId, authToken) {
  var url = '/accounts/' + userId + '?access_token=' + authToken;
  return HTTP.get(url).then(function (response) {
    return response.data;
  });
}



/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return count; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return service; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getShipping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return totalAmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_CART_ITEMS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);


var MAX_CART_ITEMS = 20;
var store = localStorage;
var service = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

var getOrder = function getOrder() {
  var order = void 0;
  try {
    var data = store.getItem('order');
    order = JSON.parse(data);
    // console.log('Order', data)
    // if (!data || data !== 'undefined') {
    //   order = JSON.parse(data)
    //   localStorage.removeItem('order')
    // }
  } catch (e) {
    console.error(e);
  }
  return order;
};

var getItems = function getItems() {
  var items = [];
  try {
    var _record = getOrder(); // store.getItem('order')
    if (!_record) return { items: items, length: items.length };
    var order = _record;
    if (!order.products) return;
    order.products.map(function (item) {
      if (item.image_url.split(':').length < 2) {
        item.image_url = 'http://' + item.image_url;
      }
      items.push(item);
    });
  } catch (e) {
    console.error(e);
  }
  return { items: items, length: items.length };
};

var getShipping = function getShipping() {
  var shipping = {};
  try {
    var _record = getOrder(); // store.getItem('order')
    if (!_record) return {};
    var order = _record;
    shipping = order.shipping;
  } catch (e) {
    console.error(e);
  }
  return shipping;
};

var count = function count() {
  return getItems().length;
};

var totalAmount = function totalAmount() {
  var total = 0;
  var items = getItems().items;
  var shipping = getShipping();
  items.forEach(function (item) {
    if (isNaN(item.price)) return;
    total = total + parseInt(item.price);
  });
  if (shipping.shipping_total) {
    total = total + shipping.shipping_total;
  }
  return total;
};



/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOGGED_OUT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGIN_SUCCESSFUL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AVATAR_IMG_UPDATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SHOPPING_CART_UPDATED; });
var LOGGED_OUT = 'logged_out';
var LOGIN_SUCCESSFUL = 'login_successful';
var AVATAR_IMG_UPDATED = 'avatar_img_updated';
var SHOPPING_CART_UPDATED = 'shopping_cart_updated';



/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mastercard.5e04be4.jpg";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/visas.d6e9e9a.jpg";

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6cf4e18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__ = __webpack_require__(223);
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d6cf4e18_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_Login_js__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a0ea72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(262);
function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47a0ea72"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_Login_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47a0ea72_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_Signup_js__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68018880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(274);
function injectStyle (ssrContext) {
  __webpack_require__(263)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68018880"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_Signup_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68018880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cards_vue__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f7498e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cards_vue__ = __webpack_require__(335);
function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65f7498e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65f7498e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(231);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7d4fc1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(230);
function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7d4fc1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */,
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PreLoader__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Navbar_vue__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContactUs__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FooterSection__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollto__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_phone_number_input__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_phone_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_phone_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_phone_number_input_dist_vue_phone_number_input_css__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_phone_number_input_dist_vue_phone_number_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_phone_number_input_dist_vue_phone_number_input_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import SideBar from '@/components/SideBar'




// import { OfflineIndicator } from 'vue-online'



// var VueScrollTo = require('vue-scrollto')
// import VueLoadersCss from 'vue-loaders-css'
// Vue.use(VueLoadersCss)
// import {Snotify} from 'vue-snotify'
// import {SnotifyService} from 'vue-snotify'
// Vue.use(Snotify) // 2. Use Snotify

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vue-phone-number-input', __WEBPACK_IMPORTED_MODULE_6_vue_phone_number_input___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_scrollto___default.a, {
  container: 'body',
  duration: 2000,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      loggedIn: false,
      authToken: null
    };
  },

  computed: {
    online: function online() {
      // return VueOnline.isOnline
      // return
      // SnotifyService.success('Example title!', 'Example body content', {
      //   timeout: 2000,
      //   showProgressBar: false,
      //   closeOnClick: false,
      //   pauseOnHover: true
      // })
    }
  },
  mounted: function mounted() {
    var token = localStorage.getItem('authToken');
    // console.log('Token', token)
    if (!token) return;
    this.loggedIn = true;
    this.authToken = token;
  },

  components: {
    PreLoader: __WEBPACK_IMPORTED_MODULE_1__components_PreLoader__["a" /* default */],
    // SideBar,
    Navbar: __WEBPACK_IMPORTED_MODULE_2__components_Navbar_vue__["a" /* default */],
    ContactUs: __WEBPACK_IMPORTED_MODULE_3__components_ContactUs__["a" /* default */],
    // OfflineIndicator,
    // VueLoadersCss,
    FooterSection: __WEBPACK_IMPORTED_MODULE_4__components_FooterSection__["a" /* default */]
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreLoader_vue__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb2499b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreLoader_vue__ = __webpack_require__(200);
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PreLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb2499b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PreLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['loading']
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{attrs:{"id":"pageloader"}},[_vm._m(0,false,false)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-item"},[_c('img',{staticClass:"loading",attrs:{"src":"/static/img/other/puff.svg","alt":"page loader"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bee1e48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(222);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bee1e48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bee1e48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_account_services__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__events__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import CartPopover from './CartPopover'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar',
  // components: {CartPopover},
  data: function data() {
    return {
      loggedIn: false,
      cartItems: Object(__WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["b" /* count */])(),
      currency: 'HTG',
      maxCartItems: __WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["a" /* MAX_CART_ITEMS */],
      marginleft: -900,
      toggle: false,
      avatarUrl: null
    };
  },
  beforeMount: function beforeMount() {
    var authToken = localStorage.getItem('authToken');
    var avatarUrl = localStorage.getItem('avatarUrl');
    var defaultAvatarUrl = '/static/img/default_avatar.png';

    if (authToken) this.loggedIn = true;

    if (!avatarUrl || !avatarUrl.length) {
      this.avatarUrl = defaultAvatarUrl;
    } else {
      this.avatarUrl = avatarUrl;
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["f" /* service */].$on(__WEBPACK_IMPORTED_MODULE_2__events__["c" /* SHOPPING_CART_UPDATED */], function () {
      _this.cartItems = Object(__WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["b" /* count */])();
    });
    __WEBPACK_IMPORTED_MODULE_1__services_account_services__["c" /* accountService */].$on(__WEBPACK_IMPORTED_MODULE_2__events__["b" /* LOGIN_SUCCESSFUL */], function (avatarUrl) {
      var defaultAvatarUrl = '/static/img/default_avatar.png';
      if (!avatarUrl) avatarUrl = defaultAvatarUrl;
      _this.loggedIn = true;
      _this.avatarUrl = avatarUrl;
    });
    __WEBPACK_IMPORTED_MODULE_1__services_account_services__["c" /* accountService */].$on(__WEBPACK_IMPORTED_MODULE_2__events__["a" /* AVATAR_IMG_UPDATED */], function () {
      var avatar = localStorage.getItem('avatarUrl');
      _this.avatarUrl = avatar;
    });
  },

  methods: {
    togglePopover: function togglePopover() {
      // window.$('.cart-popover').toggleClass('hidden')
    },
    logout: function logout() {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userId');
      localStorage.removeItem('ttl');
      localStorage.removeItem('avatarUrl');
      location.reload();
    }
  },
  props: []
});

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar"},[_c('nav',{staticClass:"navbar navbar-pacific navbar-mp megamenu navbar-fixed-top"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"navbar-header"},[_c('router-link',{attrs:{"to":{ path: '/' }}},[_c('img',{staticClass:"img-responsive hidden-xs",staticStyle:{"width":"68px","margin-top":"4px"},attrs:{"src":"/static/img/logo/haitipay.png"}})]),_vm._v(" "),_c('button',{staticClass:"navbar-toggle",class:{hideOnMobile: _vm.loggedIn},staticStyle:{"float":"left"},attrs:{"type":"button","data-toggle":"collapse","data-target":".navbar-main-collapse"}},[_c('i',{staticClass:"fa fa-fw fa-bars"})])],1),_vm._v(" "),_c('div',{staticClass:"shopping-cart pull-right",attrs:{"id":"cart"}},[_c('router-link',{staticStyle:{"border-bottom":"0px solid #ffffff","margin-right":"8em"},attrs:{"to":"/checkout"}},[_c('span',{staticClass:"fa fa-fw fa-shopping-cart fa-2x",attrs:{"aria-hidden":"true"}}),_vm._v(" "),(_vm.cartItems > 0)?_c('span',{staticClass:"badge",attrs:{"id":"badge"}},[_vm._v(_vm._s(_vm.cartItems))]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"navbar-collapse collapse navbar-main-collapse"},[_c('ul',{staticClass:"nav navbar-nav"},[(!_vm.loggedIn)?_c('li',[_c('router-link',{staticClass:"color-light",attrs:{"to":{ path: '/login' }}},[_vm._v("Login")])],1):_vm._e()])])])]),_vm._v(" "),(_vm.loggedIn)?_c('div',{staticClass:"toggle-sidebar"},[_vm._m(0,false,false)]):_vm._e(),_vm._v(" "),(_vm.loggedIn)?_c('div',{staticClass:"user",staticStyle:{"z-index":"900000000","margin-right":"0.4em"}},[_c('div',{staticClass:"dropdown user-image"},[_c('a',{attrs:{"id":"toggle-user-menu","data-target":"#","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{attrs:{"src":_vm.avatarUrl,"width":"50","height":"50"}})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu nv-dropdown",attrs:{"id":"user-menu","aria-labelledby":"toggle-user-menu"}},[_c('li',[_c('router-link',{attrs:{"to":"/account"}},[_c('i',{staticClass:"fa fa-fw fa-user",attrs:{"aria-hidden":"true"}}),_vm._v(" My Account\n        ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/account/edit"}},[_c('i',{staticClass:"fa fa-fw fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v(" Edit Profile\n        ")])],1),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.logout($event)}}},[_c('i',{staticClass:"fa fa-fw fa-sign-out",attrs:{"aria-hidden":"true"}}),_vm._v(" Log Out\n        ")])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"hidden-md hidden-lg",attrs:{"id":"toggle-sidebar","href":"javascript:void(0)"}},[_c('i',{staticClass:"fa fa-fw fa-bars",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt100 pb100 bg-grad-stellar",attrs:{"id":"contact"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 mb50"},[_c('h1',{staticClass:"font-size-normal color-light"},[_c('small',{staticClass:"color-light"},[_vm._v("Contact Us")]),_vm._v(" Drop Us a Message\n            ")]),_vm._v(" "),_c('h5',{staticClass:"color-light"},[_vm._v("Feel free to contact us. Our staff will reply any message"),_c('br'),_vm._v("as soon as possible.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-3 col-xs-12"},[_c('span',{staticClass:"icon-map color-light el-icon2x"}),_vm._v(" "),_c('h5',{staticClass:"color-light"},[_c('strong',[_vm._v("Address")])]),_vm._v(" "),_c('p',{staticClass:"color-light"},[_vm._v("\n              Ritz Kinam II, Suite #12, Rue Panamericaine"),_c('br'),_vm._v("\n              Pétion-Ville, Haiti\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-3 col-xs-6"},[_c('span',{staticClass:"icon-megaphone color-light el-icon2x"}),_vm._v(" "),_c('h5',{staticClass:"color-light"},[_c('strong',[_vm._v("Phone")])]),_vm._v(" "),_c('p',{staticClass:"color-light"},[_vm._v("(+509) 2299 4343")])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-3 col-xs-6"},[_c('span',{staticClass:"icon-envelope color-light el-icon2x"}),_vm._v(" "),_c('h5',{staticClass:"color-light"},[_c('strong',[_vm._v("Email")])]),_vm._v(" "),_c('p',{staticClass:"color-light"},[_vm._v("info@haitipay.ht")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"contact contact-us-one"},[_c('div',{staticClass:"col-sm-12 col-xs-12 text-center mb20"},[_c('h4',{staticClass:"pb25 bb-solid-1 text-uppercase"},[_vm._v("\n              Get in Touch\n              "),_c('small',{staticClass:"text-lowercase"},[_vm._v("Please complete the form and we will get back to you.")])])]),_vm._v(" "),_c('form',{attrs:{"name":"contactform","id":"contactForm","method":"post","action":"assets/php/send.php"}},[_c('div',{staticClass:"form-group col-md-6 col-sm-6 col-xs-12"},[_c('input',{staticClass:"input-md input-rounded form-control",attrs:{"type":"text","name":"senderName","id":"senderName","placeholder":"fullname","maxlength":"100","required":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6 col-sm-6 col-xs-12"},[_c('input',{staticClass:"input-md input-rounded form-control",attrs:{"type":"email","name":"senderEmail","id":"senderEmail","placeholder":"email address","maxlength":"100","required":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6 col-sm-6 col-xs-12"},[_c('input',{staticClass:"input-md input-rounded form-control",attrs:{"type":"url","name":"senderWebsite","id":"senderWebsite","placeholder":"http://","maxlength":"100"}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6 col-sm-6 col-xs-12"},[_c('input',{staticClass:"input-md input-rounded form-control",attrs:{"type":"text","name":"senderHuman","id":"senderHuman","placeholder":"","required":""}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"checkHuman_a","id":"checkHuman_a"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"checkHuman_b","id":"checkHuman_b"}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 col-sm-12 col-xs-12"},[_c('textarea',{staticClass:"form-control",attrs:{"name":"message","id":"message","rows":"7","required":""}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 col-sm-12 col-xs-12"},[_c('button',{staticClass:"button button-md button-block button-grad-stellar",attrs:{"type":"submit","name":"sendMessage","id":"sendMessage"}},[_vm._v("Send Message")])]),_vm._v(" "),_c('div',{staticClass:"statusMessage sending-message",attrs:{"id":"sendingMessage"}},[_c('p',[_vm._v("Sending your message. Please wait...")])]),_vm._v(" "),_c('div',{staticClass:"statusMessage success-message",attrs:{"id":"successMessage"}},[_c('p',[_vm._v("Thanks for sending your message! We'll get back to you shortly.")])]),_vm._v(" "),_c('div',{staticClass:"statusMessage failure-message",attrs:{"id":"failureMessage"}},[_c('p',[_vm._v("There was a problem sending your message. Please try again.")])]),_vm._v(" "),_c('div',{staticClass:"statusMessage",attrs:{"id":"incompleteMessage"}},[_c('p',[_vm._v("Please complete all the fields in the form before sending.")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterSection_vue__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1ad6b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterSection_vue__ = __webpack_require__(227);
function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f1ad6b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterSection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f1ad6b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterSection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      about: "The HaitiPay Platform is a high capacity transaction processing, switching, electronic money and stored value account management system that can be integrated with a broad range of external systems including banks, ATMs, point of sale terminals, mobile phones, web portals, point of sale systems, prepaid and post-paid billing systems, and telecommunications infrastructure"
    };
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-two bg-gray pt50",attrs:{"id":"footer"}},[_c('div',{staticClass:"container-fluid bb-solid-1"}),_vm._v(" "),_c('div',{staticClass:"container-fluid pt20"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-6 col-xs-6 pull-left"},[_c('p',[_vm._v("Copyright ©2018 "),_c('router-link',{attrs:{"to":{ path: '/contact-us' }}},[_vm._v("HaitiPay SA")]),_vm._v(". All rights reserved.")],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6 col-xs-6 pull-right"},[_c('p',{staticClass:"text-right"},[_c('router-link',{staticClass:"mr20",attrs:{"to":{ path: '/privacy-policy' }}},[_vm._v("Privacy Policy\n            ")]),_vm._v(" "),_c('router-link',{staticClass:"mr20",attrs:{"to":{ path: '/tos' }}},[_vm._v("Term of Use")]),_vm._v(" "),_c('router-link',{staticClass:"mr50",attrs:{"to":{ path: '/coockies-policy' }}},[_vm._v("Coockies Policy")])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 228 */,
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"container"}},[_c('div',{staticClass:"row"},[_c('navbar'),_vm._v(" "),_c('router-view',{attrs:{"loggedIn":_vm.loggedIn}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('footer-section',{staticClass:"hidden-xs"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Payments_Payments_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Checkout_Checkout_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Login_Login_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Signup_Signup_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PageNotFound_PageNotFound_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Account_Account_vue__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Account_EditProfile_vue__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Account_LinkAccount__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Account_Transactions__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Account_Verification__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Wallets_Wallets__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Cards_Cards__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ResetPassword_ResetPassword__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_CoockiesPolicy__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_PrivacyPolicy__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TermsAndConditions__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_ContactUs__ = __webpack_require__(44);




















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: 'Payments',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Payments_Payments_vue__["a" /* default */],
  meta: {
    title: 'Payments'
  }
}, {
  path: '/checkout',
  name: 'Checkout',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Checkout_Checkout_vue__["a" /* default */],
  meta: {
    title: 'Checkout'
  }
}, {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Login_Login_vue__["a" /* default */],
  meta: {
    title: 'Login'
  }
}, {
  path: '/signup',
  name: 'Signup',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Signup_Signup_vue__["a" /* default */],
  meta: {
    title: 'Signup'
  }
}, {
  path: '/account',
  name: 'Account',
  component: __WEBPACK_IMPORTED_MODULE_7__components_Account_Account_vue__["a" /* default */],
  meta: {
    title: 'Account'
  }
}, {
  path: '/account/link',
  name: 'LinkAccount',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Account_LinkAccount__["a" /* default */],
  meta: {
    title: 'Link Wallet'
  }
}, {
  path: '/account/link/wallets',
  name: 'Wallets',
  component: __WEBPACK_IMPORTED_MODULE_12__components_Wallets_Wallets__["a" /* default */],
  meta: {
    title: 'Wallets'
  }
}, {
  path: '/account/verification',
  name: 'Verification',
  component: __WEBPACK_IMPORTED_MODULE_11__components_Account_Verification__["a" /* default */],
  meta: {
    title: 'Account Verification'
  }
}, {
  path: '/account/link/cards',
  name: 'Cards',
  component: __WEBPACK_IMPORTED_MODULE_13__components_Cards_Cards__["a" /* default */],
  meta: {
    title: 'Credit Cards'
  }
}, {
  path: '/account/edit',
  name: 'EditProfile',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Account_EditProfile_vue__["a" /* default */],
  meta: {
    title: 'Edit Profile'
  }
}, {
  path: '/account/transactions',
  name: 'Transactions',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Account_Transactions__["a" /* default */],
  meta: {
    title: 'Transaction History'
  }
}, {
  path: '/account/reset-password',
  name: 'ResetPassword',
  component: __WEBPACK_IMPORTED_MODULE_14__components_ResetPassword_ResetPassword__["a" /* default */],
  meta: {
    title: 'Reset Password'
  }
}, {
  path: '/coockies-policy',
  name: 'CoockiesPolicy',
  component: __WEBPACK_IMPORTED_MODULE_15__components_CoockiesPolicy__["a" /* default */],
  meta: {
    title: 'Coockies Policy'
  }
}, {
  path: '/privacy-policy',
  name: 'PrivacyPolicy',
  component: __WEBPACK_IMPORTED_MODULE_16__components_PrivacyPolicy__["a" /* default */],
  meta: {
    title: 'Privacy Policy'
  }
}, {
  path: '/tos',
  name: 'TermsAndConditions',
  component: __WEBPACK_IMPORTED_MODULE_17__components_TermsAndConditions__["a" /* default */],
  meta: {
    title: 'Terms Of Service'
  }
}, {
  path: '/contact-us',
  name: 'ContactUs',
  component: __WEBPACK_IMPORTED_MODULE_18__components_ContactUs__["a" /* default */],
  meta: {
    title: 'HaitiPay - Contact Us'
  }
}, {
  path: '*',
  name: 'Not Found',
  component: __WEBPACK_IMPORTED_MODULE_6__components_PageNotFound_PageNotFound_vue__["a" /* default */],
  meta: {
    title: 'Page Not Found'
  }
}];

var options = {
  mode: 'history',
  routes: routes
};

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */](options);

router.beforeEach(function (to, from, next) {
  var pageTitle = to.meta.title;
  if (to.query.b) pageTitle += ' - ' + to.query.b;
  document.title = pageTitle;
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_Payments_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0803674_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__ = __webpack_require__(240);
function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_Payments_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0803674_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Payments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: true
    };
  },

  methods: {},
  mounted: function mounted() {
    window.localStorage.removeItem('order'); // Remove existing order item
    var urlData = __WEBPACK_IMPORTED_MODULE_0_query_string__["parseUrl"](window.location.href);
    var order = urlData.query['x.order.data'];
    window.localStorage.setItem('order', order);
    this.$router.push({ path: 'checkout' });
  },

  props: []
});

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"panel-body row-fluid",staticStyle:{"text-align":"center","margin-top":"250px","margin-bottom":"200px"},attrs:{"id":"loading"}},[_c('svg',{staticClass:"spinner",attrs:{"width":"45px","height":"45px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_Checkout_js__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef76aa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(242)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_Checkout_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ef76aa8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepIndicator__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PaymentMethods_PaymentMethods_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransactionSummary_TransactionSummary_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Login_Login_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Signup_Signup_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Redirect_Redirect_vue__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_shopping_cart__ = __webpack_require__(17);








/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      products: [],
      cartItems: [],
      currency: 'HTG',
      totalAmount: 0,
      steps: 4,
      activeStep: 1,
      showSignupForm: false,
      redirectUrl: '',
      stepLabels: ['Summary', 'Login', 'Payment', 'Done'],
      showLabel: true
    };
  },

  components: {
    StepIndicator: __WEBPACK_IMPORTED_MODULE_0__StepIndicator__["a" /* default */],
    TransactionSummary: __WEBPACK_IMPORTED_MODULE_2__TransactionSummary_TransactionSummary_vue__["a" /* default */],
    Login: __WEBPACK_IMPORTED_MODULE_3__Login_Login_vue__["a" /* default */],
    Signup: __WEBPACK_IMPORTED_MODULE_4__Signup_Signup_vue__["a" /* default */],
    PaymentMethods: __WEBPACK_IMPORTED_MODULE_1__PaymentMethods_PaymentMethods_vue__["a" /* default */],
    Redirect: __WEBPACK_IMPORTED_MODULE_5__Redirect_Redirect_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.$scrollTo('#top', 1000);
  },
  beforeMount: function beforeMount() {
    // let order = JSON.parse(localStorage.getItem('order'))
    this.products = Object(__WEBPACK_IMPORTED_MODULE_6__services_shopping_cart__["c" /* getItems */])();
    this.totalAmount = Object(__WEBPACK_IMPORTED_MODULE_6__services_shopping_cart__["g" /* totalAmount */])();
    this.cartItems = Object(__WEBPACK_IMPORTED_MODULE_6__services_shopping_cart__["c" /* getItems */])().length;
    // let prevRoute = localStorage.getItem('previousRoute')
    // WORKAROUND: Resolve token from localStorage to
    // fix `loggedIn` variable always equals `false` bug
    // let authToken = localStorage.getItem('authToken')
    // if (prevRoute === '/checkout' && authToken) {
    //   this.activeStep = 3
    // }
  },

  methods: {},
  props: ['loggedIn']
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepIndicator_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76806159_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepIndicator_vue__ = __webpack_require__(247);
function injectStyle (ssrContext) {
  __webpack_require__(245)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76806159"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StepIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76806159_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StepIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      bars: this.steps - 1
    };
  },

  props: ['steps', 'activeStep', 'labels', 'showLabel', 'cartItems', 'shouldCheckCartItems']
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper pl50 pr50 mb50",class:{'items-4' : (_vm.steps > 3), 'items-5' : (_vm.steps > 4)},staticStyle:{"position":"relative","top":"16px"}},[(_vm.shouldCheckCartItems)?_c('div',[_c('div',{staticClass:"indicators"},_vm._l((_vm.steps),function(step){return _c('span',{key:step},[_c('label',{staticClass:"step",class:{'active' : (step === _vm.activeStep && _vm.cartItems > 0) || (_vm.activeStep > step && _vm.cartItems > 0)}},[_vm._v("\n          "+_vm._s(step)+"\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.showLabel)?_c('label',{staticClass:"step-label",class:{'active' : (step === _vm.activeStep && _vm.cartItems > 0) || (_vm.activeStep > step && _vm.cartItems > 0) }},[_vm._v("\n          "+_vm._s(_vm.labels[--step])+"\n        ")]):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"bars"},_vm._l((_vm.bars),function(step){return _c('div',{key:step,class:{'active' : (_vm.activeStep - step >= 1)}})}))]):_vm._e(),_vm._v(" "),(!_vm.shouldCheckCartItems)?_c('div',[_c('div',{staticClass:"indicators"},_vm._l((_vm.steps),function(step){return _c('span',{key:step},[_c('label',{staticClass:"step",class:{'active' : (step === _vm.activeStep) || (_vm.activeStep > step)}},[_vm._v("\n          "+_vm._s(step)+"\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.showLabel)?_c('label',{staticClass:"step-label",class:{'active' : (step === _vm.activeStep) || (_vm.activeStep > step) }},[_vm._v("\n          "+_vm._s(_vm.labels[--step])+"\n        ")]):_vm._e()])})),_vm._v(" "),_c('div',{staticClass:"bars"},_vm._l((_vm.bars),function(step){return _c('div',{key:step,class:{'active' : (_vm.activeStep - step >= 1)}})}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_PaymentMethods_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_174ec683_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethods_vue__ = __webpack_require__(253);
function injectStyle (ssrContext) {
  __webpack_require__(249)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-174ec683"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_PaymentMethods_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_174ec683_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentMethods_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_account_services_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ladda__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ladda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_ladda__);

// import axios from 'axios'








__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue2_filters___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'vue-ladda': __WEBPACK_IMPORTED_MODULE_6_vue_ladda___default.a
  },
  data: function data() {
    return {
      paymentMethods: {},
      loading: true,
      load: false,
      load1: false,
      load2: false,
      hasNoPayment: false,
      hasPayment: false,
      url: '',
      method: '',
      lcphone: '',
      lcpin: '',
      selectedMethodId: 0,
      rate: '',
      total: Object(__WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__["g" /* totalAmount */])(),
      currency: ''
    };
  },
  mounted: function mounted() {
    this.currency = Object(__WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__["d" /* getOrder */])().currency;
    this.getPaymentMethod();
    this.getRate();
  },

  methods: {
    getPaymentMethod: function getPaymentMethod() {
      var _this = this;

      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      var app = this;
      var url = '/accounts/' + userId + '/paymentMethods?access_token=' + token;
      __WEBPACK_IMPORTED_MODULE_3__services_account_services_js__["a" /* HTTP */].get(url).then(function (response) {
        app.paymentMethods = response.data;
        if (response.data.wallets.length === 0 & response.data.cards.length === 0 & response.data.banks.length === 0 & response.data.gifts.length === 0) {
          app.hasNoPayment = true;
          app.hasPayment = false;
          app.loading = false;
        } else {
          var wallets = response.data.wallets;
          if (wallets.length > 0) {
            wallets.forEach(function (wallet) {
              wallet.last4 = wallet.phoneNumber.substr(7, 12);
            });
          }
          app.hasPayment = true;
          app.loading = false;
        }
        console.log(response.data);
      }).catch(function (error) {
        console.error('Error', error);
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Error', 'Your session has expired. You will be redirected to login page to continue', 'error').then(function (result) {
          localStorage.removeItem('authToken');
          localStorage.removeItem('userId');
          _this.$router.push('/login');
        });
      });
    },
    makePayment: function makePayment() {
      if (this.method.provider === 'lajancash') {
        // Show the modal to enter PIN Code for authorization
        $('#pin_lajancash').modal();
      } else {
        // Show modal rate
        $('#rate').modal();
      }
    },
    getRate: function getRate() {
      var _this2 = this;

      var url = '/exchange-rates/1';
      __WEBPACK_IMPORTED_MODULE_3__services_account_services_js__["a" /* HTTP */].get(url).then(function (response) {
        _this2.rate = response.data.rates.HTG;
        console.log(response.data.rates.HTG);
      });
    },
    lajanCashPayment: function lajanCashPayment() {
      this.load2 = true;
      var cart = Object(__WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__["d" /* getOrder */])();
      var redirectUrl = cart.returnUrl;
      var userId = localStorage.getItem('userId');
      var _total = Object(__WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__["g" /* totalAmount */])();
      var order = {
        'payment': {
          'phoneNumber': this.method.phoneNumber,
          'provider': this.method.provider,
          'credentials': {
            'pincode': this.lcpin
          }
        },
        'items': Object(__WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__["c" /* getItems */])().items,
        'total': Math.round(_total * this.rate),
        'currency': 'htg',
        'accountId': userId,
        'merchantId': cart.merchantId,
        'orderId': cart.orderId
      };
      console.log('LAJANCASH_ORDER', order);
      __WEBPACK_IMPORTED_MODULE_3__services_account_services_js__["a" /* HTTP */].post('/payments', order).then(function (response) {
        console.log('Payment response', response);
        console.log(response.status);
        $('#pin_lajancash').modal('hide');
        if (!response.data.charge.paid) {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Payment failed', response.data.payment.outcome, 'error');
        } else {
          var _cart = [];
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Success', 'Your order has been submitted successfuly. You will be redirected to merchant website', 'success').then(function (redirect) {
            console.log('Redirect url', redirectUrl);
            location.replace(redirectUrl);
            localStorage.removeItem('order');
          });
        }
      });
    },
    otherPayment: function otherPayment() {
      this.load1 = true;
      var cart = Object(__WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__["d" /* getOrder */])();
      var redirectUrl = cart.returnUrl;
      var userId = localStorage.getItem('userId');
      var order = {
        'payment': this.method,
        'items': Object(__WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__["c" /* getItems */])().items,
        'total': Object(__WEBPACK_IMPORTED_MODULE_1__services_shopping_cart__["g" /* totalAmount */])(),
        'currency': cart.currency || 'htg',
        'accountId': userId,
        'merchantId': cart.merchantId,
        'orderId': cart.orderId
      };
      console.log('OTHER_PAYMENT', order);
      __WEBPACK_IMPORTED_MODULE_3__services_account_services_js__["a" /* HTTP */].post('/payments', order).then(function (response) {
        $('#rate').modal('hide');
        console.log('Payment response', response);
        if (response.data.charge.paid) {
          console.log(response.status);
          var _cart2 = [];
          localStorage.setItem('cart', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_cart2));
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Success', 'Your order has been submitted successfuly. You will be redirected to merchant website', 'success').then(function (redirect) {
            console.log('Redirect url', redirectUrl);
            location.replace(redirectUrl);
            localStorage.removeItem('order');
          });
        }
        if (response.data.status === 'payment_failed') {
          console.log(response.data.status);
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Error!', 'We are sorry, but your payment can\'t be process now', 'error');
        }
      }).catch(function (error) {
        console.error('Error', error);
        $('#rate').modal('hide');
        var errorMessage = 'Payment can\'t be processed now.';
        if (error.message === 'Unknown client account') {
          errorMessage = errorMessage + ' Your card was not charged.';
        } else {
          errorMessage = errorMessage + '. Your card was declined.';
        }
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Error', errorMessage, 'error').then(function (result) {
          location.reload();
        });
      });
    },
    selectedMethod: function selectedMethod(id) {
      this.selectedMethodId = id;
    }
  }
});

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-md-offset-2 col-lg-offset-2 col-xs-12 col-md-9 col-lg-9 mb30"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"row border-top border-bottom"},[(_vm.loading)?_c('div',{staticClass:"panel-body row-fluid",staticStyle:{"text-align":"center","margin-bottom":"50px"},attrs:{"id":"loading"}},[_c('svg',{staticClass:"spinner",attrs:{"width":"45px","height":"45px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNoPayment),expression:"hasNoPayment"}],staticClass:"col-xs-12 col-md-12 no-spacing box-container"},[_c('h4',{staticStyle:{"text-align":"center","color":"#3dace1"}},[_vm._v("No payment method found, Link an account")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/account/link/cards"}},[_c('div',{staticClass:"col-xs-12 col-md-6 no-spacing"},[_c('div',{staticClass:"box"},[_c('span',[_c('i',{staticClass:"fa fa-credit-card fa-5x"})]),_vm._v(" "),_c('p',[_vm._v("Credit Card")])])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/account/link/wallets"}},[_c('div',{staticClass:"col-xs-12 col-md-6 no-spacing"},[_c('div',{staticClass:"box"},[_c('span',[_c('i',{staticClass:"fa fa-mobile fa-5x"})]),_vm._v(" "),_c('p',[_vm._v("Mobile Wallet")])])])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasPayment),expression:"hasPayment"}]},[_c('div',{attrs:{"id":"paymentOptions"}},[_c('h4',{staticStyle:{"text-align":"center","color":"#3dace1"}},[_vm._v("Select a payment method")]),_vm._v(" "),_c('ul',[_vm._l((_vm.paymentMethods.wallets),function(wallet){return _c('li',{key:wallet.id,class:{ 'selected' : (wallet.id === _vm.selectedMethodId) },on:{"click":function($event){_vm.selectedMethod(wallet.id)}}},[_c('span',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.method),expression:"method"}],attrs:{"type":"radio","name":"method"},domProps:{"value":wallet,"checked":_vm._q(_vm.method,wallet)},on:{"change":function($event){_vm.method=wallet}}}),_c('label'),_vm._v(" "),_vm._m(1,true,false),_vm._v(" "),_c('span',{staticClass:"balance",staticStyle:{"color":"black"}},[_vm._v("\n                  **** "+_vm._s(wallet.last4)+" |\n                  "+_vm._s(_vm._f("currency")(wallet.balance.htg,'HTG '))+"\n                ")])])])}),_vm._v(" "),_vm._l((_vm.paymentMethods.cards),function(creditCard){return _c('li',{key:creditCard.id,class:{ 'selected' : (creditCard.id === _vm.selectedMethodId) },on:{"click":function($event){_vm.selectedMethod(creditCard.id)}}},[_c('span',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.method),expression:"method"}],attrs:{"type":"radio","name":"method"},domProps:{"value":creditCard,"checked":_vm._q(_vm.method,creditCard)},on:{"change":function($event){_vm.method=creditCard}}}),_c('label'),_vm._v(" "),_c('span',{staticClass:"details mobile"},[(creditCard.brand == 'MasterCard')?_c('img',{staticClass:"img-responsive",staticStyle:{"display":"inline","margin-top":"-7px"},attrs:{"src":__webpack_require__(26),"width":"80","height":"50"}}):_c('img',{staticClass:"img-responsive",staticStyle:{"display":"inline","margin-top":"-7px"},attrs:{"src":__webpack_require__(27),"width":"75","height":"45"}}),_vm._v(" "),_c('div',{staticClass:"pull-right balance"},[_vm._v("**** "+_vm._s(creditCard.last4))])])])])}),_vm._v(" "),_vm._l((_vm.paymentMethods.banks),function(bank){return _c('li',{key:bank.id,class:{ 'selected' : (bank.id === _vm.selectedMethodId) },on:{"click":function($event){_vm.selectedMethod(bank.id)}}},[_c('span',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.method),expression:"method"}],attrs:{"type":"radio","name":"method"},domProps:{"value":bank,"checked":_vm._q(_vm.method,bank)},on:{"change":function($event){_vm.method=bank}}}),_c('label'),_vm._v(" "),_c('span',{staticClass:"details"},[_c('img',{staticClass:"img-responsive",staticStyle:{"display":"inline","margin-top":"-15px"},attrs:{"src":__webpack_require__(254),"width":"70","height":"45"}}),_vm._v(" "),_c('div',{staticClass:"pull-right balance",staticStyle:{"display":"inline"}},[_vm._v("\n                    "+_vm._s(bank.bank_name)+" "),_c('br'),_vm._v("\n                    ****"),_c('span',[_vm._v(" "+_vm._s(bank.last4))])])])])])})],2)])]),_vm._v(" "),(_vm.method)?_c('vue-ladda',{attrs:{"loading":_vm.load,"data-style":"expand-right"},on:{"click":_vm.makePayment}},[_c('strong',{staticStyle:{"font-size":"18px"}},[_vm._v("Pay now »")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"pin_lajancash","data-easein":"pulse","tabindex":"-1","role":"dialog","aria-labelledby":"addbankLabel","aria-hidden":"false"}},[_c('form',{staticClass:"payment",on:{"~submit":function($event){$event.preventDefault();_vm.lajanCashPayment($event)}}},[_c('div',{staticClass:"modal-header",staticStyle:{"text-align":"center","margin-top":"0"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("X")]),_vm._v(" "),_c('div',{staticClass:"lock"},[_c('svg',{attrs:{"version":"1.1","id":"lock_1_","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"100px","height":"100px","viewBox":"0 -154.521 500 650","enable-background":"new 0 -154.521 500 650","xml:space":"preserve"}},[_c('path',{staticClass:"keyhole",attrs:{"id":"keyhole","d":"M250.001,270.188c-27.36,0-49.619,22.259-49.619,49.619c0,13.569,5.64,26.689,15.486,36.026v44.8\n                        c0,18.821,15.313,34.134,34.134,34.134s34.134-15.313,34.134-34.134v-44.8c9.842-9.331,15.485-22.454,15.485-36.026\n                        C299.619,292.447,277.359,270.188,250.001,270.188z M267.558,338.436c-4.737,4.464-7.454,10.703-7.454,17.119v45.079\n                        c0,5.571-4.531,10.103-10.103,10.103c-5.57,0-10.103-4.531-10.103-10.103v-45.079c0-6.415-2.717-12.653-7.451-17.116\n                        c-5.183-4.886-8.036-11.502-8.036-18.631c0-14.108,11.479-25.588,25.588-25.588s25.588,11.479,25.588,25.588\n                        C275.589,326.937,272.735,333.553,267.558,338.436z"}}),_vm._v(" "),_c('path',{staticClass:"hook",attrs:{"id":"hook","d":"M166.028,112.907c0-46.439,37.782-84.222,84.222-84.222c46.438,0,84.221,37.782,84.221,84.222v94.011\n                        l23.694,0.059v-94.07c0-59.508-48.409-107.919-107.914-107.919c-59.506,0-107.918,48.411-107.918,107.919v93.534l23.695,0.059\n                        V112.907z"}}),_vm._v(" "),_c('path',{attrs:{"id":"body","d":"M334.221,205.585H165.778 M142.083,205.585h-35.54C86.945,205.585,71,221.531,71,241.129V460.97\n                        c0,19.596,15.945,35.541,35.543,35.541h286.916c19.599,0,35.541-15.945,35.541-35.541V241.13c0-19.599-15.942-35.544-35.541-35.544\n                        h-35.544 M405.307,460.971c0,6.531-5.317,11.848-11.848,11.848H106.543c-6.533,0-11.85-5.315-11.85-11.848V241.13\n                        c0-6.533,5.316-11.847,11.85-11.847h286.916c6.53,0,11.848,5.313,11.848,11.847V460.971z"}})])]),_vm._v(" "),_c('h3',[_vm._v("\n                      Please enter your PIN code for phone number +"+_vm._s(_vm.method.phoneNumber)+"\n                    ")]),_vm._v(" "),_c('h4',[_vm._v("\n                      Your account will be charged"),_c('br'),_vm._v(" "),_c('strong',{staticStyle:{"color":"#3dace1"}},[_vm._v(_vm._s(_vm._f("currency")(Math.round(_vm.total * _vm.rate),'HTG '))+" plus a service fee of "+_vm._s(_vm._f("currency")(Math.round((_vm.total * 0.05) * _vm.rate),'HTG '))+"\n                      ")])]),_vm._v(" "),_c('h5',[_vm._v("\n                      Transaction total: "+_vm._s(_vm._f("currency")(Math.round((_vm.total * _vm.rate) + ((_vm.total * _vm.rate) * 0.05)),'HTG '))+"\n                    ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lcpin),expression:"lcpin"}],staticClass:"form-control align-center",staticStyle:{"height":"50px","text-align":"center","font-family":"text-security-disc"},attrs:{"type":"tel","placeholder":"Your PIN","required":"required","maxlength":"4"},domProps:{"value":(_vm.lcpin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lcpin=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"blueButton",staticStyle:{"display":"left","margin-right":"10px"},attrs:{"data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"blueButton",attrs:{"type":"submit","id":"load"}},[_vm._v("Make Payment")]),_vm._v(" "),(_vm.load2)?_c('div',{staticStyle:{"display":"inline","padding-top":"5px"},attrs:{"id":"loading"}},[_c('svg',{staticClass:"spinner",attrs:{"width":"35px","height":"35px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"modal",staticStyle:{"margin-top":"100px"},attrs:{"data-easein":"pulse","id":"rate","role":"dialog"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h4',[_vm._v("Your credit card will be charged"),_c('br'),_vm._v(" "),(_vm.currency.toUpperCase() === 'HTG')?_c('strong',{staticStyle:{"color":"#3dace1"}},[_vm._v("USD "+_vm._s((_vm.total / _vm.rate).toFixed(2))+"\n                      plus a service fee of USD "+_vm._s((((_vm.total / _vm.rate) * 0.05) + 0.50).toFixed(2))+"\n                    ")]):_vm._e(),_vm._v(" "),(_vm.currency.toUpperCase() !== 'HTG')?_c('strong',{staticStyle:{"color":"#3dace1"}},[_vm._v(" "+_vm._s(_vm._f("uppercase")(_vm.currency))+" "+_vm._s(_vm.total.toFixed(2))+"\n                      plus a service fee of "+_vm._s(_vm._f("uppercase")(_vm.currency))+" "+_vm._s(((_vm.total  * 0.05) + 0.50).toFixed(2))+"\n                    ")]):_vm._e()]),_vm._v(" "),(_vm.currency.toUpperCase() === 'HTG')?_c('h5',[_vm._v(" Exchange rate: 1 USD = "+_vm._s(_vm._f("currency")(_vm.rate,'HTG ')))]):_vm._e(),_vm._v(" "),(_vm.currency.toUpperCase() === 'HTG')?_c('h5',[_vm._v("\n                    Transaction total: USD "+_vm._s(((_vm.total / _vm.rate) + ((_vm.total / _vm.rate) * 0.05) + 0.50).toFixed(2))+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.currency.toUpperCase() !== 'HTG')?_c('h5',[_vm._v("\n                    Transaction total: "+_vm._s(_vm._f("uppercase")(_vm.currency))+" "+_vm._s((_vm.total + (_vm.total * 0.05) + 0.50).toFixed(2))+"\n                  ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"blueButton",staticStyle:{"display":"left","margin-right":"10px"},attrs:{"data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"blueButton",on:{"click":_vm.otherPayment}},[_vm._v("Confirm Payment")]),_vm._v(" "),(_vm.load1)?_c('div',{staticStyle:{"display":"inline"},attrs:{"id":"loading"}},[_c('svg',{staticClass:"spinner",attrs:{"width":"35px","height":"35px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_vm._e()])])])])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row pb10"},[_c('div',{staticClass:"col-xs-12 col-md-12"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"details mobile"},[_c('img',{staticClass:"img-responsive",staticStyle:{"display":"inline","margin-top":"-20px"},attrs:{"src":__webpack_require__(13),"width":"90","height":"60"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header",staticStyle:{"background-color":"#f7f7f7"}},[_c('button',{staticClass:"close",staticStyle:{"font-size":"25px"},attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("×")]),_vm._v(" "),_c('div',[_c('img',{staticClass:"img-responsive img-center",staticStyle:{"width":"90px","margin-left":"auto","margin-right":"auto"},attrs:{"src":__webpack_require__(255)}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_TransactionSummary_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d350ba9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionSummary_vue__ = __webpack_require__(259);
function injectStyle (ssrContext) {
  __webpack_require__(257)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d350ba9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_TransactionSummary_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d350ba9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__ = __webpack_require__(17);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [],
      shipping: {},
      totalAmount: 0,
      currency: '',
      maxItems: __WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["a" /* MAX_CART_ITEMS */]
    };
  },
  mounted: function mounted() {
    var order = Object(__WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["d" /* getOrder */])();
    this.items = Object(__WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["c" /* getItems */])().items;
    if (order) this.currency = order.currency;else this.currency = 'htg';
    this.shipping = Object(__WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["e" /* getShipping */])();
    this.totalAmount = Object(__WEBPACK_IMPORTED_MODULE_0__services_shopping_cart__["g" /* totalAmount */])();
  },

  methods: {
    nextStep: function nextStep() {
      if (this.$parent.loggedIn) {
        this.$parent.activeStep += 2;
      } else {
        this.$parent.activeStep++;
      }
    }
  },
  filters: {
    uppercase: function uppercase(val) {
      if (!val) return console.warn('Val is null or undefined');
      return val.toString().toUpperCase();
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"col-md-offset-1 col-lg-offset-1 col-md-10 col-lg-10 mb30"},[(_vm.items.length > 0)?_c('h2',[_vm._v("Review")]):_vm._e(),_vm._v(" "),(_vm.items.length > 0)?_c('p',{staticClass:"mb30"},[_vm._v("\n        A summary of your shopping cart before we proceed to the next steps.\n      ")]):_vm._e(),_vm._v(" "),(_vm.items.length > 0)?_c('table',{staticClass:"table"},[_vm._m(0,false,false),_vm._v(" "),_c('tbody',{attrs:{"id":"cart-summary"}},[_vm._l((_vm.items),function(item){return _c('tr',{key:item.id},[_c('td',{attrs:{"width":"38"}},[(item.image_url.split('/').length > 2)?_c('img',{attrs:{"src":item.image_url,"width":"42"}}):_vm._e()]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(item.item_quantity)+" x "+_vm._s(item.product_name))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v("\n              "+_vm._s(_vm._f("uppercase")(_vm.currency))+" "+_vm._s(item.price.toFixed(2))+"\n            ")])])}),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Shipping")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.shipping.description))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v("\n              "+_vm._s(_vm._f("uppercase")(_vm.currency))+" "+_vm._s(_vm.shipping.shipping_total.toFixed(2) || 0)+"\n            ")])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v("Total")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_vm._v("\n              "+_vm._s(_vm._f("uppercase")(_vm.currency))+" "+_vm._s(_vm.totalAmount.toFixed(2))+"\n            ")])]),_vm._v(" "),_c('tr',{staticClass:"button-row m0 p0 mt50 pt50"},[_c('td',{attrs:{"colspan":"4"}},[_c('div',{staticClass:"checkout"},[_c('button',{staticClass:"button-o button-lg button-blue hover-fade btn-block",on:{"click":_vm.nextStep}},[_vm._v("\n                  Next »\n                ")])])])])],2)]):_vm._e(),_vm._v(" "),(_vm.items.length === 0)?_c('div',{staticStyle:{"text-align":"center"},attrs:{"id":"emptyCart"}},[_vm._m(1,false,false),_vm._v(" "),_c('h5',{staticClass:"font-montserrat"},[_vm._v("\n          Your shopping cart is empty."),_c('br'),_vm._v("\n          Add up to "+_vm._s(_vm.maxItems)+" items to it\n        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-lg btn-block btn-primary",attrs:{"href":"https://haitipay-marketplace.netlify.com"}},[_vm._v("\n          Go to Marketplace »\n        ")]),_vm._v(" "),_c('div',{staticClass:"pb40"})]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Product")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("Price")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"color":"#ddd","margin-top":"40px","margin-bottom":"0"}},[_c('i',{staticClass:"fa fa-magic fa-2x"}),_vm._v(" "),_c('i',{staticClass:"fa fa-shopping-basket fa-4x"}),_vm._v(" "),_c('i',{staticClass:"fa fa-star"}),_vm._v(" "),_c('i',{staticClass:"fa fa-star",staticStyle:{"position":"relative","top":"-10px"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_account_services__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ladda__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ladda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ladda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events__ = __webpack_require__(25);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'vue-ladda': __WEBPACK_IMPORTED_MODULE_1_vue_ladda___default.a
  },
  data: function data() {
    return {
      credentials: {},
      loginError: false,
      loading: false,
      loading1: false,
      login: true,
      forgetPass: false
    };
  },
  beforeMount: function beforeMount() {
    // let prevRoute = localStorage.getItem('previousRoute')
    // if (prevRoute === '/login') {
    //   this.$router.push('/')
    // }
  },

  methods: {
    previousStep: function previousStep() {
      this.$parent.activeStep--;
    },
    signin: function signin() {
      var _this = this;

      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_0__services_account_services__["d" /* login */])(this.credentials).then(function (result) {
        localStorage.setItem('authToken', result.data.id);
        localStorage.setItem('userId', result.data.userId);
        localStorage.setItem('ttl', result.data.ttl);
        localStorage.setItem('previousRoute', _this.$route.path);
        _this.saveAccountInfo(result.data.userId, result.data.id);
      }).catch(function (err) {
        console.error(err);
        if (err) {
          _this.loginError = true;
          _this.loading = false;
        }
      });
    },
    register: function register() {
      if (this.$route.path === '/checkout') {
        this.$parent.showSignupForm = true;
      } else {
        this.$router.push('/signup');
      }
    },
    saveAccountInfo: function saveAccountInfo(userId, token) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__services_account_services__["a" /* HTTP */].get('/accounts/' + userId + '?access_token=' + token).then(function (result) {
        console.log('Result', result.data);
        localStorage.setItem('firstName', result.data.firstName);
        localStorage.setItem('lastName', result.data.lastName);
        localStorage.setItem('username', result.data.username);
        localStorage.setItem('email', result.data.email);
        localStorage.setItem('phoneNumber', result.data.phoneNumber);
        localStorage.setItem('avatarUrl', result.data.avatarUrl || '');
        __WEBPACK_IMPORTED_MODULE_0__services_account_services__["c" /* accountService */].$emit(__WEBPACK_IMPORTED_MODULE_3__events__["b" /* LOGIN_SUCCESSFUL */], result.data.avatarUrl);
        _this2.$router.push({ path: '/checkout' });
        location.reload();
      }).catch(function (error) {
        console.error(error);
      });
    },
    switchForgetPass: function switchForgetPass() {
      this.login = false;
      this.forgetPass = true;
    },
    switchLoging: function switchLoging() {
      this.forgetPass = false;
      this.login = true;
    },
    resetPass: function resetPass() {
      var _this3 = this;

      this.loading1 = true;
      var email = this.credentials.email;
      __WEBPACK_IMPORTED_MODULE_0__services_account_services__["a" /* HTTP */].get('/accounts/forgotPassword?email=' + email).then(function (result) {
        _this3.loading1 = false;
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Success !', 'A link has been send to ' + email + ' to reset your Password !', 'success');
      }).catch(function (error) {
        _this3.loading1 = false;
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Hoops !', 'Some thing is wrong :' + error, 'error');
      });
    }
  },
  props: ['loggedIn', 'progress']
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row pt0 pb50",class:{'pt30': _vm.$route.path === '/login'}},[_c('div',{staticClass:"col-md-4 col-lg-2 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-8 col-lg-8 border-box"},[_c('div',{staticClass:"row pb10"},[_c('div',{staticClass:"col-xs-12 col-md-12"},[(_vm.$route.path === '/checkout')?_c('button',{staticClass:"btn btn-xs pull-left mt25 mr20",on:{"click":function($event){$event.preventDefault();_vm.previousStep($event)}}},[_vm._v("← Back")]):_vm._e(),_vm._v(" "),_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.login),expression:"login"}],staticClass:"form-signin-heading",staticStyle:{"margin-top":"18px"}},[_vm._v("Please sign in")]),_vm._v(" "),_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgetPass),expression:"forgetPass"}],staticClass:"form-signin-heading",staticStyle:{"margin-top":"18px"}},[_vm._v("Reset your password")])])]),_vm._v(" "),(_vm.loginError)?_c('div',{staticClass:"row alert alert-danger"},[_vm._m(0,false,false)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row border-top p10 pb10"},[_c('div',{staticClass:"col-md-8 col-lg-8 col-xs-12 no-spacing border-right"},[_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.login),expression:"login"}],staticClass:"form-signin",on:{"submit":function($event){$event.preventDefault();_vm.signin($event)}}},[_c('label',{attrs:{"for":"inputEmail"}},[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.email),expression:"credentials.email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputEmail","placeholder":"Email address","required":"","autofocus":""},domProps:{"value":(_vm.credentials.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"mt10",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPassword","placeholder":"Password","required":""},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"pull-right",staticStyle:{"margin-top":"6px","font-size":"13px","cursor":"pointer"},on:{"click":_vm.switchForgetPass}},[_vm._v("Forgot password?")]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('vue-ladda',{attrs:{"loading":_vm.loading,"data-style":"expand-right"}},[_vm._v("\n                  Sign in\n                ")])],1),_vm._v(" "),_c('form',{directives:[{name:"show",rawName:"v-show",value:(_vm.forgetPass),expression:"forgetPass"}],staticClass:"form-signin",on:{"submit":function($event){$event.preventDefault();_vm.resetPass($event)}}},[_c('label',{attrs:{"for":"inputEmail"}},[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.email),expression:"credentials.email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputEmail","placeholder":"Email address","required":"","autofocus":""},domProps:{"value":(_vm.credentials.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "email", $event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"pull-right",staticStyle:{"margin-top":"6px","font-size":"13px","cursor":"pointer"},on:{"click":_vm.switchLoging}},[_vm._v("Sign in")]),_vm._v(" "),_c('vue-ladda',{attrs:{"loading":_vm.loading1,"data-style":"expand-right"}},[_vm._v("\n                  Reset Password\n                ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-lg-4 col-xs-12 no-spacing center-content grey-box"},[_c('p',{staticClass:"pb10",staticStyle:{"text-align":"left"}},[_vm._v("Don't have an account yet? Create a free account now to get started.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-default btn-block",on:{"click":function($event){$event.preventDefault();_vm.register($event)}}},[_vm._v("\n              Create account\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 col-xs-12 col-md-12"},[_c('span',{staticClass:"glyphicon glyphicon-exclamation-sign",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Error:")]),_vm._v("\n            Incorrect Email or password\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{attrs:{"type":"checkbox","value":"remember-me"}}),_vm._v(" Remember me\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_account_services__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ladda__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ladda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ladda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password_strength_meter__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password_strength_meter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password_strength_meter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_phone_number_input__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_phone_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_phone_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);




// import VueRecaptcha from 'vue-recaptcha'



// import VueGrecaptcha from 'vue-grecaptcha'


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'vue-ladda': __WEBPACK_IMPORTED_MODULE_1_vue_ladda___default.a,
    // VueRecaptcha,
    Datepicker: __WEBPACK_IMPORTED_MODULE_2_vuejs_datepicker__["a" /* default */],
    Password: __WEBPACK_IMPORTED_MODULE_3_vue_password_strength_meter___default.a,
    VuePhoneNumberInput: __WEBPACK_IMPORTED_MODULE_4_vue_phone_number_input___default.a
  },
  data: function data() {
    return {
      formValid: false,
      passwordScore: 0,
      inputTypeLabel: 'Show password',
      selectedInputType: 'password',
      telInputData: {},
      telInputProps: {
        required: true,
        autocomplete: "off",
        enabledCountryCode: false,
        onlyCountries: ['HT', 'DO', 'CA', 'US', 'FR', 'CL', 'BR'],
        placeholder: 'Phone number',
        inputOtions: {
          showDialCode: false
        },
        validCharactersOnly: true
      },
      account: {
        gender: 'not-specified',
        birthDate: '1980-10-20',
        phoneNumber: ''
      },
      control: null,
      form: null,
      doneSignUp: false,
      signUpError: false,
      signUpSuccess: false,
      confirmPassword: '',
      loading: false,
      captchaResponse: ''
    };
  },

  methods: {
    toggleInputType: function toggleInputType() {
      if (this.selectedInputType !== 'password') {
        this.selectedInputType = 'password';
        this.inputTypeLabel = 'Show password';
      } else {
        this.selectedInputType = 'text';
        this.inputTypeLabel = 'Hide password';
      }
    },
    phoneChanged: function phoneChanged(data) {
      this.telInputData = data;
    },
    isFormValid: function isFormValid() {
      var isValid = true;
      if (this.account.firstName < 3) isValid = false;
      if (this.account.lastName < 3) isValid = false;
      if (this.passwordScore < 2) isValid = false;
      if (this.confirmPassword !== this.account.password) isValid = false;
      if (!this.account.birthDate) isValid = false;
      if (!this.telInputData.isValid) isValid = false;
      return isValid;
    },
    captchaCallback: function captchaCallback(response) {
      console.log(response);
    },
    captchaExecute: function captchaExecute(data) {},
    previousStep: function previousStep() {
      this.$parent.activeStep--;
    },
    signup: function signup() {
      var _this = this;

      this.loading = true;
      this.account.countryCode = this.telInputData.countryCode;
      this.account.phoneNumber = this.telInputData.formattedNumber.split('+')[1];
      Object(__WEBPACK_IMPORTED_MODULE_0__services_account_services__["e" /* register */])(this.account).then(function (result) {
        _this.signUpSuccess = true;
        _this.doneSignUp = true;
        _this.loading = false;
      }).catch(function (err) {
        if (err) _this.signUpError = true;
        _this.loading = false;
      });
    },
    login: function login() {
      if (this.$route.path === '/checkout') {
        this.$parent.showSignupForm = false;
      } else {
        this.$router.push('/login');
      }
    },
    goToMerchantSignup: function goToMerchantSignup() {
      this.$router.push('/merchant/signup');
    },
    showFeedback: function showFeedback(_ref) {
      var suggestions = _ref.suggestions,
          warning = _ref.warning;
    },
    showScore: function showScore(score) {
      this.passwordScore = score;
    }
  },
  mounted: function mounted() {
    // // $('#phone').intlTelInput()
    // let telInput = $('#phone')
    // let errorMsg = $('#error-msg')
    // let validMsg = $('#valid-msg')
    // // $('#phone').intlTelInput()
    // // initialise plugin
    // telInput.intlTelInput({
    //   utilsScript: '../../static/js/phone/utils.js'
    // })
    // const reset = function () {
    //   telInput.removeClass('error')
    //   errorMsg.addClass('hide')
    //   validMsg.addClass('hide')
    // }

    // // on blur: validate
    // telInput.blur(function () {
    //   reset()
    //   if ($.trim(telInput.val())) {
    //     if (telInput.intlTelInput('isValidNumber')) {
    //       validMsg.removeClass('hide')
    //     } else {
    //       telInput.addClass('error')
    //       errorMsg.removeClass('hide')
    //     }
    //   }
    // })
    // // on keyup / change flag: reset
    // telInput.on('keyup change', reset)
  }
});

/***/ }),
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 49,
	"./af.js": 49,
	"./ar": 50,
	"./ar-dz": 51,
	"./ar-dz.js": 51,
	"./ar-kw": 52,
	"./ar-kw.js": 52,
	"./ar-ly": 53,
	"./ar-ly.js": 53,
	"./ar-ma": 54,
	"./ar-ma.js": 54,
	"./ar-sa": 55,
	"./ar-sa.js": 55,
	"./ar-tn": 56,
	"./ar-tn.js": 56,
	"./ar.js": 50,
	"./az": 57,
	"./az.js": 57,
	"./be": 58,
	"./be.js": 58,
	"./bg": 59,
	"./bg.js": 59,
	"./bm": 60,
	"./bm.js": 60,
	"./bn": 61,
	"./bn.js": 61,
	"./bo": 62,
	"./bo.js": 62,
	"./br": 63,
	"./br.js": 63,
	"./bs": 64,
	"./bs.js": 64,
	"./ca": 65,
	"./ca.js": 65,
	"./cs": 66,
	"./cs.js": 66,
	"./cv": 67,
	"./cv.js": 67,
	"./cy": 68,
	"./cy.js": 68,
	"./da": 69,
	"./da.js": 69,
	"./de": 70,
	"./de-at": 71,
	"./de-at.js": 71,
	"./de-ch": 72,
	"./de-ch.js": 72,
	"./de.js": 70,
	"./dv": 73,
	"./dv.js": 73,
	"./el": 74,
	"./el.js": 74,
	"./en-SG": 75,
	"./en-SG.js": 75,
	"./en-au": 76,
	"./en-au.js": 76,
	"./en-ca": 77,
	"./en-ca.js": 77,
	"./en-gb": 78,
	"./en-gb.js": 78,
	"./en-ie": 79,
	"./en-ie.js": 79,
	"./en-il": 80,
	"./en-il.js": 80,
	"./en-nz": 81,
	"./en-nz.js": 81,
	"./eo": 82,
	"./eo.js": 82,
	"./es": 83,
	"./es-do": 84,
	"./es-do.js": 84,
	"./es-us": 85,
	"./es-us.js": 85,
	"./es.js": 83,
	"./et": 86,
	"./et.js": 86,
	"./eu": 87,
	"./eu.js": 87,
	"./fa": 88,
	"./fa.js": 88,
	"./fi": 89,
	"./fi.js": 89,
	"./fo": 90,
	"./fo.js": 90,
	"./fr": 91,
	"./fr-ca": 92,
	"./fr-ca.js": 92,
	"./fr-ch": 93,
	"./fr-ch.js": 93,
	"./fr.js": 91,
	"./fy": 94,
	"./fy.js": 94,
	"./ga": 95,
	"./ga.js": 95,
	"./gd": 96,
	"./gd.js": 96,
	"./gl": 97,
	"./gl.js": 97,
	"./gom-latn": 98,
	"./gom-latn.js": 98,
	"./gu": 99,
	"./gu.js": 99,
	"./he": 100,
	"./he.js": 100,
	"./hi": 101,
	"./hi.js": 101,
	"./hr": 102,
	"./hr.js": 102,
	"./hu": 103,
	"./hu.js": 103,
	"./hy-am": 104,
	"./hy-am.js": 104,
	"./id": 105,
	"./id.js": 105,
	"./is": 106,
	"./is.js": 106,
	"./it": 107,
	"./it-ch": 108,
	"./it-ch.js": 108,
	"./it.js": 107,
	"./ja": 109,
	"./ja.js": 109,
	"./jv": 110,
	"./jv.js": 110,
	"./ka": 111,
	"./ka.js": 111,
	"./kk": 112,
	"./kk.js": 112,
	"./km": 113,
	"./km.js": 113,
	"./kn": 114,
	"./kn.js": 114,
	"./ko": 115,
	"./ko.js": 115,
	"./ku": 116,
	"./ku.js": 116,
	"./ky": 117,
	"./ky.js": 117,
	"./lb": 118,
	"./lb.js": 118,
	"./lo": 119,
	"./lo.js": 119,
	"./lt": 120,
	"./lt.js": 120,
	"./lv": 121,
	"./lv.js": 121,
	"./me": 122,
	"./me.js": 122,
	"./mi": 123,
	"./mi.js": 123,
	"./mk": 124,
	"./mk.js": 124,
	"./ml": 125,
	"./ml.js": 125,
	"./mn": 126,
	"./mn.js": 126,
	"./mr": 127,
	"./mr.js": 127,
	"./ms": 128,
	"./ms-my": 129,
	"./ms-my.js": 129,
	"./ms.js": 128,
	"./mt": 130,
	"./mt.js": 130,
	"./my": 131,
	"./my.js": 131,
	"./nb": 132,
	"./nb.js": 132,
	"./ne": 133,
	"./ne.js": 133,
	"./nl": 134,
	"./nl-be": 135,
	"./nl-be.js": 135,
	"./nl.js": 134,
	"./nn": 136,
	"./nn.js": 136,
	"./pa-in": 137,
	"./pa-in.js": 137,
	"./pl": 138,
	"./pl.js": 138,
	"./pt": 139,
	"./pt-br": 140,
	"./pt-br.js": 140,
	"./pt.js": 139,
	"./ro": 141,
	"./ro.js": 141,
	"./ru": 142,
	"./ru.js": 142,
	"./sd": 143,
	"./sd.js": 143,
	"./se": 144,
	"./se.js": 144,
	"./si": 145,
	"./si.js": 145,
	"./sk": 146,
	"./sk.js": 146,
	"./sl": 147,
	"./sl.js": 147,
	"./sq": 148,
	"./sq.js": 148,
	"./sr": 149,
	"./sr-cyrl": 150,
	"./sr-cyrl.js": 150,
	"./sr.js": 149,
	"./ss": 151,
	"./ss.js": 151,
	"./sv": 152,
	"./sv.js": 152,
	"./sw": 153,
	"./sw.js": 153,
	"./ta": 154,
	"./ta.js": 154,
	"./te": 155,
	"./te.js": 155,
	"./tet": 156,
	"./tet.js": 156,
	"./tg": 157,
	"./tg.js": 157,
	"./th": 158,
	"./th.js": 158,
	"./tl-ph": 159,
	"./tl-ph.js": 159,
	"./tlh": 160,
	"./tlh.js": 160,
	"./tr": 161,
	"./tr.js": 161,
	"./tzl": 162,
	"./tzl.js": 162,
	"./tzm": 163,
	"./tzm-latn": 164,
	"./tzm-latn.js": 164,
	"./tzm.js": 163,
	"./ug-cn": 165,
	"./ug-cn.js": 165,
	"./uk": 166,
	"./uk.js": 166,
	"./ur": 167,
	"./ur.js": 167,
	"./uz": 168,
	"./uz-latn": 169,
	"./uz-latn.js": 169,
	"./uz.js": 168,
	"./vi": 170,
	"./vi.js": 170,
	"./x-pseudo": 171,
	"./x-pseudo.js": 171,
	"./yo": 172,
	"./yo.js": 172,
	"./zh-cn": 173,
	"./zh-cn.js": 173,
	"./zh-hk": 174,
	"./zh-hk.js": 174,
	"./zh-tw": 175,
	"./zh-tw.js": 175
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 273;

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row pt0 pb50",class:{'pt30': _vm.$route.path === '/signup'}},[_c('div',{staticClass:"col-md-3 col-lg-2 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-9 col-lg-8 border-box"},[_c('div',{staticClass:"row pb10"},[_c('div',{staticClass:"col-xs-12 col-md-12"},[(_vm.$route.path === '/checkout')?_c('button',{staticClass:"btn btn-xs pull-left mt25 mr20",on:{"click":function($event){$event.preventDefault();_vm.previousStep($event)}}},[_vm._v("← Back")]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"btn btn-sm btn-primary pull-right mt25",staticStyle:{"color":"#fff !important","margin-top":"15px","border-radius":"2px"},attrs:{"href":"https://haitipay.netlify.com/merchant/signup"}},[_vm._v("Create merchant account")]),_vm._v(" "),_c('h3',{staticClass:"form-signin-heading",staticStyle:{"margin-top":"18px"}},[_vm._v("Create account")])])]),_vm._v(" "),(_vm.signUpError)?_c('div',{staticClass:"row alert alert-danger"},[_vm._m(0,false,false)]):_vm._e(),_vm._v(" "),(_vm.signUpSuccess)?_c('div',{staticClass:"row alert alert-success"},[_c('div',{staticClass:"col-lg-12 col-xs-12 col-md-12"},[_c('span',{staticClass:"glyphicon glyphicon-ok-circle",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Success:")]),_vm._v(" "),_c('a',{staticClass:"pull-right",on:{"click":function($event){$event.preventDefault();_vm.login($event)}}},[_vm._v("Login")]),_vm._v("\n            Account created successfuly\n          ")])]):_vm._e(),_vm._v(" "),(!_vm.doneSignUp)?_c('div',{staticClass:"row border-top p10 pb10"},[_c('div',{staticClass:"col-md-8 col-lg-8 col-xs-12 no-spacing border-right"},[_c('form',{staticClass:"form-signin",on:{"submit":function($event){$event.preventDefault();_vm.signup($event)}}},[_c('label',{attrs:{"for":"inputFullname"}},[_vm._v("First name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.firstName),expression:"account.firstName"}],staticClass:"form-control",attrs:{"type":"text","id":"firstname","placeholder":"Firstname","required":"","autofocus":"true","autocomplete":"false"},domProps:{"value":(_vm.account.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "firstName", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"inputFullname"}},[_vm._v("Last name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.lastName),expression:"account.lastName"}],staticClass:"form-control",attrs:{"type":"text","id":"lastname","placeholder":"Lastname","required":"","autocomplete":"false"},domProps:{"value":(_vm.account.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "lastName", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone number")]),_vm._v(" "),_c('VuePhoneNumberInput',{class:_vm.form-_vm.control,attrs:{"only-countries":_vm.telInputProps.onlyCountries,"default-country-code":_vm.telInputProps.onlyCountries[0]},on:{"update":function($event){_vm.phoneChanged($event)}},model:{value:(_vm.account.phoneNumber),callback:function ($$v) {_vm.$set(_vm.account, "phoneNumber", $$v)},expression:"account.phoneNumber"}}),_vm._v(" "),_c('label',{attrs:{"for":"inputDOB"}},[_vm._v("Birthdate")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.birthDate),expression:"account.birthDate"}],staticClass:"form-control",attrs:{"type":"date","placeholder":"MM/DD/YYYY"},domProps:{"value":(_vm.account.birthDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "birthDate", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"inputGender"}},[_vm._v("Gender")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.gender),expression:"account.gender"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.account, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"not-specified"}},[_vm._v("Rather not say")]),_vm._v(" "),_c('option',{attrs:{"value":"male"}},[_vm._v("Male")]),_vm._v(" "),_c('option',{attrs:{"value":"female"}},[_vm._v("Female")])]),_vm._v(" "),_c('label',{attrs:{"for":"inputEmail"}},[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.email),expression:"account.email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputEmail","placeholder":"Email address","required":"true","autocomplete":"true"},domProps:{"value":(_vm.account.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "email", $event.target.value)}}}),_vm._v(" "),_c('label',{attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('label',{staticStyle:{"cursor":"pointer","float":"right","font-size":"12px","font-weight":"normal"},on:{"click":_vm.toggleInputType}},[_vm._v(_vm._s(_vm.inputTypeLabel))]),_vm._v(" "),_c('div',[((_vm.selectedInputType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.password),expression:"account.password"}],staticClass:"form-control",attrs:{"placeholder":"Password","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.account.password)?_vm._i(_vm.account.password,null)>-1:(_vm.account.password)},on:{"change":function($event){var $$a=_vm.account.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.account.password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.account.password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.$set(_vm.account, "password", $$c)}}}}):((_vm.selectedInputType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.password),expression:"account.password"}],staticClass:"form-control",attrs:{"placeholder":"Password","type":"radio"},domProps:{"checked":_vm._q(_vm.account.password,null)},on:{"change":function($event){_vm.$set(_vm.account, "password", null)}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.password),expression:"account.password"}],staticClass:"form-control",attrs:{"placeholder":"Password","type":_vm.selectedInputType},domProps:{"value":(_vm.account.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "password", $event.target.value)}}}),_vm._v(" "),_c('password',{attrs:{"toggle":true,"badge":false,"strength-meter-only":true},on:{"score":_vm.showScore,"feedback":_vm.showFeedback},model:{value:(_vm.account.password),callback:function ($$v) {_vm.$set(_vm.account, "password", $$v)},expression:"account.password"}})],1),_vm._v(" "),_c('label',{staticStyle:{"margin-top":"-10px"},attrs:{"for":"inputPasswordConfirm"}},[_vm._v("Confirm password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.confirmPassword),expression:"confirmPassword"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPasswordConfirm","placeholder":"Confirm password","required":""},domProps:{"value":(_vm.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.confirmPassword=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary btn-block mt30 mb30",staticStyle:{"border-radius":"2px"},attrs:{"type":"submit","disabled":!_vm.isFormValid()}},[_vm._v("Create account")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-lg-4 col-xs-12 no-spacing center-content grey-box"},[_c('p',{staticClass:"pb10",staticStyle:{"text-align":"left"}},[_vm._v("\n              Already have an account? Click the button below to signin to your account."),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success btn-block mt10",on:{"click":function($event){$event.preventDefault();_vm.login($event)}}},[_vm._v("Login\n              ")])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row mt-30"},[_c('div',{staticClass:"col-md-3 col-lg-3 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-6 col-lg-6"},[_c('p',[_vm._v("By signin up you agree to the "),_c('router-link',{attrs:{"to":"/tos"}},[_vm._v("Term of Use")]),_vm._v(" and our "),_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 col-xs-12 col-md-12"},[_c('span',{staticClass:"glyphicon glyphicon-exclamation-sign",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Error:")]),_vm._v("\n            Error creating your account. Try different email and phone number.\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_Redirect_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d97e91e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Redirect_vue__ = __webpack_require__(277);
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_Redirect_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d97e91e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Redirect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      console.log('Redirecting to', _this.$props.redirectUrl);
      window.location.href = _this.$props.redirectUrl;
    }, 5000);
  },

  props: ['redirectUrl']
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_vm._m(0,false,false),_c('p'),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Still here? "),_c('a',{attrs:{"href":_vm.redirectUrl}},[_vm._v("Click this link")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n    Your payment has been processed successfully "),_c('br'),_vm._v("\n    You are being redirected to the merchant store\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main has-submenu",staticStyle:{"margin":"auto"},attrs:{"id":"top"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-lg-12 col-md-10 content"},[_c('div',{staticClass:"panel panel-info",staticStyle:{"padding-right":"10px","padding-left":"10px"}},[_c('div',{staticClass:"wrapper",staticStyle:{"padding":"0"}},[_c('div',{staticClass:"row",staticStyle:{"padding":"0em","margin-top":"3em"}},[_c('div',{staticClass:"col-xs-12 col-md-10 col-lg-12"},[_c('step-indicator',{attrs:{"shouldCheckCartItems":true,"steps":_vm.steps,"activeStep":_vm.activeStep,"labels":_vm.stepLabels,"showLabel":_vm.showLabel,"cartItems":_vm.cartItems}})],1)]),_vm._v(" "),(_vm.activeStep === 1)?_c('div',[_c('transaction-summary')],1):_vm._e(),_vm._v(" "),(_vm.activeStep === 2)?_c('div',[(!_vm.showSignupForm)?_c('login'):_vm._e(),_vm._v(" "),(_vm.showSignupForm)?_c('signup'):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.activeStep === 3)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-lg-1 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-lg-10"},[_c('payment-methods')],1)])]):_vm._e(),_vm._v(" "),(_vm.activeStep === 4)?_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-1 col-lg-1 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-md-10 col-lg-10"},[_c('redirect',{attrs:{"redirectUrl":_vm.redirectUrl}})],1)])]):_vm._e()])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_PageNotFound_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d2269d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(282);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(1)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d2269d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_PageNotFound_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d2269d7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  // TODO: Add JS here
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container-fluid pt80 pb40"},[_c('div',{staticClass:"row pr40"},[_c('div',{staticClass:"col-lg-3 col-md-3 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-lg-8 col-xs-12 border-box"},[_c('h1',{staticClass:"pt20",staticStyle:{"font-size":"4em"}},[_vm._v("404 · Not Found")]),_vm._v(" "),_c('p',{staticClass:"pt20"},[_vm._v("Sorry, the page you are looking for cannot be found.")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5d47e92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__ = __webpack_require__(320);
function injectStyle (ssrContext) {
  __webpack_require__(284)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d5d47e92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5d47e92_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_account_services_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_filters___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Account',
  components: {
    // ContactsList
  },
  data: function data() {
    return {
      active: true,
      account: {},
      paymentMethods: {},
      hasNoWallet: false,
      hasNoCard: false,
      hasNoBank: false,
      hasNoGift: false,
      loading: true,
      ballanceht: 0,
      ballanceus: 0,
      stripeID: '',
      avatarUrl: null
      // avatarUrl: localStorage.getItem('avatarUrl') === 'undefined' ? '../../../static/img/default_avatar.png' : localStorage.getItem('avatarUrl') + '&access_token=' + localStorage.getItem('authToken')
    };
  },

  methods: {
    getPaymentMethod: function getPaymentMethod() {
      var app = this;
      var userId = localStorage.getItem('userId');
      var token = localStorage.getItem('authToken');
      if (!app.loading) app.loading = true;
      __WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["a" /* HTTP */].get('/accounts/' + userId + '/paymentMethods?access_token=' + token).then(function (response) {
        app.paymentMethods = response.data;
        // console.log(response.data)
        // localStorage.setItem('phone', response.data.wallets.phoneNumber)
        // console.log(response.data.wallets[0].phoneNumber)
        if (response.data.wallets.length === 0) {
          app.hasNoWallet = true;
        }
        if (response.data.cards.length === 0) {
          app.hasNoCard = true;
        }
        // if (response.data.banks.length === 0) {
        //   app.hasNoBank = true
        // }
        if (response.data.gifts.length === 0) {
          app.hasNoGift = true;
        }
        if (!app.hasNoGift) {
          var gifts = response.data.gifts;
          gifts.forEach(function (merchant) {
            var merchantName = merchant.merchantName.toLowerCase();
            merchant.slug = merchant.merchantName.split(' ').join('').toLowerCase();
            if (merchantName.match('rouge')) merchant.slug = 'celerirouge';
            if (merchantName.match('domino')) merchant.slug = 'dominospizza';
          });
        }
        if (!app.hasNoWallet) {
          response.data.wallets.forEach(function (wallet) {
            var phone = wallet.phoneNumber;
            wallet.last4 = phone.substr(7, phone.length);
          });
        }
        app.loading = false;
        // console.log(response.data)
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteWallet: function deleteWallet(id) {
      var _this = this;

      var token = localStorage.getItem('authToken');
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Are you sure who want to delete this wallet ?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            setTimeout(function () {
              resolve(__WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["a" /* HTTP */].delete('/wallet/' + id + '?access_token=' + token).then(function (response) {
                // Do nothing
              }));
            }, 1500);
          });
        },
        allowOutsideClick: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'success',
          title: 'Wallet delete successfully',
          html: 'The Wallet has been deleted !'
        });
        _this.getPaymentMethod();
      });
    },
    deleteCard: function deleteCard(id) {
      var _this2 = this;

      var userId = localStorage.getItem('userId');
      var token = localStorage.getItem('authToken');
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Are you sure who want to delete this Card ?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            setTimeout(function () {
              resolve(__WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["a" /* HTTP */].delete('/accounts/' + userId + '/cards/' + id + '?access_token=' + token).then(function (response) {
                console.log(response);
              }));
            }, 1500);
          });
        },
        allowOutsideClick: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'success',
          title: 'Wallet delete successfully',
          html: 'The Wallet has been deleted !'
        });
        _this2.getPaymentMethod();
      });
    },
    deleteBank: function deleteBank(id) {
      var _this3 = this;

      var userId = localStorage.getItem('userId');
      var token = localStorage.getItem('authToken');
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Are you sure who want to delete this bank account ?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            setTimeout(function () {
              resolve(__WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["a" /* HTTP */].delete('/accounts/' + userId + '/banks/' + id + '?access_token=' + token).then(function (response) {
                console.log(response);
              }));
            }, 1500);
          });
        },
        allowOutsideClick: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'success',
          title: 'Wallet delete successfully',
          html: 'The Wallet has been deleted !'
        });
        _this3.getPaymentMethod();
      });
    },
    deleteGift: function deleteGift(id) {
      var _this4 = this;

      // let userId = localStorage.getItem('userId')
      var self = this;
      var token = localStorage.getItem('authToken');
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Are you sure who want to delete this gift card ?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            setTimeout(function () {
              resolve(__WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["a" /* HTTP */].delete('/vouchers/' + id + '?access_token=' + token).then(function (response) {
                // console.log(response)
                self.getPaymentMethod();
              }));
            }, 1500);
          });
        },
        allowOutsideClick: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'success',
          title: 'Wallet delete successfully',
          html: 'The Wallet has been deleted !'
        });
        _this4.getPaymentMethod();
      });
    }
  },
  mounted: function mounted() {
    // console.log(this.avatarUrl)
    this.$scrollTo('#top', 1000);
    this.getPaymentMethod();
    var app = this;
    var userId = localStorage.getItem('userId');
    var authToken = localStorage.getItem('authToken');
    Object(__WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["b" /* account */])(userId, authToken).then(function (response) {
      console.log('Result', response.data);
      app.account = response;
    }).catch(function (e) {
      console.log('Error', e);
      // if the the token is expired log out the user
      localStorage.removeItem('authToken');
      localStorage.removeItem('userId');
      localStorage.removeItem('ttl');
      localStorage.removeItem('avatarUrl');
      // location.reload()
    });
  },
  beforeMount: function beforeMount() {
    if (!localStorage.getItem('authToken')) {
      return this.$router.push('/login');
    }

    var avatarUrl = localStorage.getItem('avatarUrl');
    var defaultAvatarUrl = '/static/img/default_avatar.png';

    if (!avatarUrl) {
      this.avatarUrl = defaultAvatarUrl;
    } else {
      this.avatarUrl = avatarUrl;
    }
  },

  // computed(){
  //   giftUrl(){
  //     return '../../../static/img/wallets/lajanCash.png'
  //   }
  // },
  props: ['loggedIn']
  // computed: {
  //   filterContacts: function () {
  //     return this.contacts.filter((element) => {
  //       return element.match(this.filterSearch)
  //     })
  //   }
  // }
});

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main has-submenu",staticStyle:{"margin":"auto"},attrs:{"id":"top"}},[(_vm.loading)?_c('div',{staticClass:"panel-body row-fluid",staticStyle:{"text-align":"center","margin-top":"150px"},attrs:{"id":"loading"}},[_c('svg',{staticClass:"spinner",attrs:{"width":"45px","height":"45px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_c('div',{staticClass:"mainbody container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"padding-top":"50px"}}),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 hidden-sm"},[_c('div',{staticClass:"panel panel-default",staticStyle:{"margin-top":"0"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"media"},[_c('div',{attrs:{"align":"center"}},[_c('img',{staticClass:"img-responsive avatar img-circle img-thumbnail",staticStyle:{"width":"150px","height":"150px"},attrs:{"src":_vm.avatarUrl}}),_vm._v(" "),_c('h1',{staticClass:"panel-title pull-center",staticStyle:{"font-size":"20px"}},[_vm._v(_vm._s(_vm.account.firstName)+" "+_vm._s(_vm.account.lastName)+" ")])]),_vm._v(" "),_c('div',{staticClass:"media-body"},[_c('div',{staticClass:"list-group"},[_c('router-link',{staticClass:"list-group-item",staticStyle:{"margin-right":"0px"},attrs:{"to":"/account/verification"}},[_c('i',{staticClass:"fa fa-envelope",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.account.email)+" "),_c('div',{staticClass:"pull-right"},[(_vm.account.emailVerified)?_c('i',{staticClass:"fa fa-check-circle ok",staticStyle:{"color":"#30ab1c"},attrs:{"title":"Email verified","aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"color":"rgb(247, 139, 6)"},attrs:{"title":"Email unverified","aria-hidden":"true"}})])]),_vm._v(" "),_c('router-link',{staticClass:"list-group-item",staticStyle:{"margin-right":"0px"},attrs:{"to":"/account/verification"}},[_c('i',{staticClass:"fa fa-mobile",staticStyle:{"font-size":"25px"},attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.account.phoneNumber)+" "),_c('div',{staticClass:"pull-right"},[(_vm.account.phoneNumberVerified)?_c('i',{staticClass:"fa fa-check-circle ok",staticStyle:{"color":"#30ab1c"},attrs:{"title":"Phone verified","aria-hidden":"true"}}):_c('i',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"color":"rgb(247, 139, 6)"},attrs:{"title":"Phone unverified","aria-hidden":"true"}})])]),_vm._v(" "),_c('a',{staticClass:"list-group-item",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-flag",attrs:{"aria-hidden":"true"}}),_vm._v(_vm._s(_vm.account.country))]),_vm._v(" "),_c('a',{staticClass:"list-group-item",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-calendar",attrs:{"aria-hidden":"true"}}),_vm._v("Register: "+_vm._s(new Date(_vm.account.created).toLocaleDateString('fr-FR')))]),_vm._v(" "),_c('router-link',{staticClass:"list-group-item",attrs:{"to":"/account/edit"}},[_c('i',{staticClass:"fa fa-pencil",attrs:{"aria-hidden":"true"}}),_vm._v("Edit profile")])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-md-9 col-sm-12 col-xs-12"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"panel-heading"},[_c('h1',{staticClass:"panel-title",staticStyle:{"font-size":"22px"}},[_vm._v("My Account\n                            "),(_vm.account.emailVerified && _vm.account.phoneNumberVerified)?_c('router-link',{attrs:{"to":{path:'/account/link'}}},[_c('button',{staticClass:"btn btn-info btn-circle btn-lg",staticStyle:{"margin-top":"5px","float":"right"},attrs:{"type":"button","title":"Add new acount"}},[_c('i',{staticClass:"fa fa-plus"})])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"padding":"0","text-align":"center"}},[_c('div',{staticClass:"tab_container",staticStyle:{"margin-top":"16px","padding":"0","width":"96%"}},[_c('input',{attrs:{"id":"tab1","type":"radio","name":"tabs","checked":""}}),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('input',{attrs:{"id":"tab2","type":"radio","name":"tabs"}}),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('input',{attrs:{"id":"tab4","type":"radio","name":"tabs"}}),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('section',{staticClass:"tab-content",attrs:{"id":"content1"}},[_c('ul',{staticClass:"list-group"},_vm._l((_vm.paymentMethods.wallets),function(wallet){return _c('li',{key:wallet.id,staticClass:"list-group-item"},[_c('div',{staticClass:"segments",attrs:{"id":"wallets"}},[_vm._m(3,true,false),_vm._v(" "),_c('div',{staticClass:"item"},[_c('p',{staticStyle:{"margin-top":"16px","font-size":"16px"}},[_vm._v("(509) **** "+_vm._s(wallet.last4))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red","font-size":"18px"},on:{"click":function($event){$event.preventDefault();_vm.deleteWallet(wallet.id)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"card-box tilebox-two tilebox-primary",staticStyle:{"border-left-color":"#188ae2"}},[_c('a',{staticClass:"pull-right",attrs:{"href":"#","title":"Add money to Lajancash wallet"}},[_c('svg',{staticClass:"add-money-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 32","width":"65px","height":"45px","fill":"#20BFD6"}},[_c('g',[_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M34.41,2.57a6.1,6.1,0,0,0-6.13,6.06,6.14,6.14,0,0,0,12.27,0A6.1,6.1,0,0,0,34.41,2.57Zm0,11.11a5.1,5.1,0,0,1-5.13-5.06,5.14,5.14,0,0,1,10.27,0A5.1,5.1,0,0,1,34.41,13.68Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M36.85,8.12H34.91V6.18a.5.5,0,0,0-1,0V8.12H32a.5.5,0,0,0,0,1h1.94v1.94a.5.5,0,0,0,1,0V9.12h1.94a.5.5,0,0,0,0-1Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M33.25,23.82a.5.5,0,0,0-1,.12c0,.12,0,.38,0,.71-4.71-.44-9.35.21-13.84.85s-9.1,1.29-13.75.83l-.5-12.26L4.58,14a.5.5,0,1,0-.16-1l-.81.15a.5.5,0,0,0-.39.51l.53,13.11a.48.48,0,0,0,0,.08.5.5,0,0,0,.43.4,33.6,33.6,0,0,0,3.8.21,75.81,75.81,0,0,0,10.62-1c4.59-.65,9.33-1.32,14.08-.79l.16,0a.5.5,0,0,0,.48-.5s0,0,0,0C33.3,24.57,33.28,24,33.25,23.82Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M33.19,16.5a.5.5,0,0,0-.5.5v4.33c-.46-.09-1.12-.19-2.07-.32a59.87,59.87,0,0,0-14.06.31,34.33,34.33,0,0,1-8.86.26V9.48a24.74,24.74,0,0,0,6.77.13L16,9.51c.09,0,9.06-.82,10-.84a.5.5,0,1,0,0-1c-.94,0-9.67.81-10,.85l-1.51.1A22.27,22.27,0,0,1,7.3,8.38a.5.5,0,0,0-.61.49V22a.5.5,0,0,0,.41.49,18,18,0,0,0,3.38.29,58.59,58.59,0,0,0,6.18-.46A59.15,59.15,0,0,1,30.5,22c1.77.25,3.15.84,3.21-.09l0-4.91A.5.5,0,0,0,33.19,16.5Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M16.9,15.27A3.11,3.11,0,1,0,20,12.16,3.11,3.11,0,0,0,16.9,15.27Zm5.22,0A2.11,2.11,0,1,1,20,13.17,2.11,2.11,0,0,1,22.11,15.27Z"}})])])]),_vm._v(" "),_c('h6',{staticClass:"text-primary text-uppercase"},[_vm._v("Balance HTG Availlable")]),_vm._v(" "),(wallet.balance)?_c('h2',{staticClass:"m-b-10 ballance"},[_c('span',{attrs:{"data-plugin":"counterup"}},[_vm._v(_vm._s(_vm._f("currency")(wallet.balance.htg,'HTG ')))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"card-box tilebox-two tilebox-success",staticStyle:{"border-left-color":"#4bd396"}},[_c('a',{staticClass:"pull-right",attrs:{"href":"#","title":"Add money to Lajancash wallet"}},[_c('svg',{staticClass:"add-money-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 32","width":"65px","height":"45px","fill":"#20BFD6"}},[_c('g',[_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M34.41,2.57a6.1,6.1,0,0,0-6.13,6.06,6.14,6.14,0,0,0,12.27,0A6.1,6.1,0,0,0,34.41,2.57Zm0,11.11a5.1,5.1,0,0,1-5.13-5.06,5.14,5.14,0,0,1,10.27,0A5.1,5.1,0,0,1,34.41,13.68Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M36.85,8.12H34.91V6.18a.5.5,0,0,0-1,0V8.12H32a.5.5,0,0,0,0,1h1.94v1.94a.5.5,0,0,0,1,0V9.12h1.94a.5.5,0,0,0,0-1Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M33.25,23.82a.5.5,0,0,0-1,.12c0,.12,0,.38,0,.71-4.71-.44-9.35.21-13.84.85s-9.1,1.29-13.75.83l-.5-12.26L4.58,14a.5.5,0,1,0-.16-1l-.81.15a.5.5,0,0,0-.39.51l.53,13.11a.48.48,0,0,0,0,.08.5.5,0,0,0,.43.4,33.6,33.6,0,0,0,3.8.21,75.81,75.81,0,0,0,10.62-1c4.59-.65,9.33-1.32,14.08-.79l.16,0a.5.5,0,0,0,.48-.5s0,0,0,0C33.3,24.57,33.28,24,33.25,23.82Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M33.19,16.5a.5.5,0,0,0-.5.5v4.33c-.46-.09-1.12-.19-2.07-.32a59.87,59.87,0,0,0-14.06.31,34.33,34.33,0,0,1-8.86.26V9.48a24.74,24.74,0,0,0,6.77.13L16,9.51c.09,0,9.06-.82,10-.84a.5.5,0,1,0,0-1c-.94,0-9.67.81-10,.85l-1.51.1A22.27,22.27,0,0,1,7.3,8.38a.5.5,0,0,0-.61.49V22a.5.5,0,0,0,.41.49,18,18,0,0,0,3.38.29,58.59,58.59,0,0,0,6.18-.46A59.15,59.15,0,0,1,30.5,22c1.77.25,3.15.84,3.21-.09l0-4.91A.5.5,0,0,0,33.19,16.5Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M16.9,15.27A3.11,3.11,0,1,0,20,12.16,3.11,3.11,0,0,0,16.9,15.27Zm5.22,0A2.11,2.11,0,1,1,20,13.17,2.11,2.11,0,0,1,22.11,15.27Z"}})])])]),_vm._v(" "),_c('h6',{staticClass:"text-success text-uppercase"},[_vm._v("Balance USD Availlable")]),_vm._v(" "),(wallet.balance)?_c('h2',{staticClass:"m-b-10 ballance"},[_c('span',{attrs:{"data-plugin":"counterup"}},[_vm._v(_vm._s(_vm._f("currency")(wallet.balance.usd,'USD ')))])]):_vm._e()])])])])})),_vm._v(" "),(!_vm.account.emailVerified || !_vm.account.phoneNumberVerified)?_c('div',{staticClass:"alert alert-warning fade in"},[_vm._v("\n                                  Account not verified"),_c('br'),_vm._v("Please verify your phone number and your email address to add wallets.\n                                ")]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNoWallet),expression:"hasNoWallet"}],staticClass:"alert alert-info fade in",staticStyle:{"text-align":"center"}},[_vm._v("\n                                  Link a wallet to your account and use it as a payment method to pay bills\n                                ")])]),_vm._v(" "),_c('section',{staticClass:"tab-content",attrs:{"id":"content2"}},[_c('ul',{staticClass:"list-group"},_vm._l((_vm.paymentMethods.cards),function(creditCard){return _c('li',{key:creditCard.id,staticClass:"list-group-item"},[_c('div',{staticClass:"segments",attrs:{"id":"wallets"}},[_c('div',{staticClass:"item"},[(creditCard.brand == 'MasterCard')?_c('img',{staticClass:"img-responsive",staticStyle:{"display":"inline"},attrs:{"src":__webpack_require__(26),"width":"90","height":"60"}}):_c('img',{staticClass:"img-responsive",staticStyle:{"display":"inline","padding":"5px"},attrs:{"src":__webpack_require__(27),"width":"90","height":"60"}}),_vm._v("\n                                        *********"),_c('span',[_vm._v(" "+_vm._s(creditCard.last4))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_vm._v(_vm._s(creditCard.number))]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red","font-size":"18px","margin-right":"0"},on:{"click":function($event){$event.preventDefault();_vm.deleteCard(creditCard.id)}}})])])])])})),_vm._v(" "),(!_vm.account.emailVerified || !_vm.account.phoneNumberVerified)?_c('div',{staticClass:"alert alert-warning fade in"},[_vm._v("\n                                  Account not verified."),_c('br'),_vm._v("Please verify your phone number and your email address to add credit cards"),_c('br')]):_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNoCard),expression:"hasNoCard"}],staticClass:"alert alert-info fade in",staticStyle:{"text-align":"center"}},[_c('i',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"font-size":"23px","float":"left"},attrs:{"aria-hidden":"true"}}),_vm._v("\n                                  Link a Credit or debit card to your account and use it as a payment method to pay bills"),_c('br')])]),_vm._v(" "),_c('section',{staticClass:"tab-content",attrs:{"id":"content4"}},[(_vm.hasNoGift)?_c('div',{staticClass:"alert alert-info fade in"},[_vm._v("\n                                  Vouchers you received will appear in this section"),_c('br')]):_c('ul',{staticClass:"list-group"},_vm._l((_vm.paymentMethods.gifts),function(giftCard){return _c('li',{key:giftCard.id,staticClass:"list-group-item"},[_c('div',{staticClass:"segments",attrs:{"id":"wallets"}},[_c('div',{staticClass:"item"},[_c('img',{staticClass:"img-responsive",staticStyle:{"margin-left":"-10px","margin-top":"20px"},attrs:{"src":'../../../static/img/gifts/thumbnail/'+giftCard.slug+'.png',"width":"100","height":"70"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_vm._v(" "),_c('span',[_c('strong',[_vm._v(_vm._s(giftCard.merchantName.toUpperCase())+" Voucher")])]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v("\n                                          "+_vm._s(_vm._f("currency")(giftCard.price,'HTG '))+"\n                                        ")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("+"+_vm._s(giftCard.phoneNumber))]),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red","font-size":"18px"},on:{"click":function($event){$event.preventDefault();_vm.deleteGift(giftCard.id)}}})])])])])}))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"tab1"}},[_c('i',{staticClass:"fa fa-money"}),_c('span',[_vm._v("Wallet")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"tab2"}},[_c('i',{staticClass:"fa fa-credit-card"}),_c('span',[_vm._v("Cards")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"tab4"}},[_c('i',{staticClass:"fa fa-gift"}),_c('span',[_vm._v("e-Vouchers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('img',{staticClass:"img-responsive",staticStyle:{"margin-left":"-14px","float":"left"},attrs:{"src":__webpack_require__(13),"width":"90","height":"60"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e0be724_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__ = __webpack_require__(325);
function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e0be724"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e0be724_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clip__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ladda__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ladda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_ladda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_clip___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProfile',
  components: {
    'vue-ladda': __WEBPACK_IMPORTED_MODULE_3_vue_ladda___default.a
  },
  data: function data() {
    return {
      account: {},
      hasError: false,
      isSuccess: false,
      displayProgressBar: false,
      avatarImg: null,
      loading: false,
      loading1: false,
      credentials: {},
      error: false,
      errorMessage: 'Password mismatch!',
      options: {
        url: 'https://api.haitipay.com/v1/accounts/' + localStorage.getItem('userId') + '/avatar?access_token=' + localStorage.getItem('authToken') + '&authorization=J1DWJi6L4710H5opgtgFo40fqQhQTMgwITmOAdPFmj5V70E52cDg478DSdrTy10R',
        paramName: 'avatar',
        maxFiles: 1
      }
    };
  },

  methods: {
    onAddedFile: function onAddedFile() {
      if (!this.displayProgressBar) {
        this.displayProgressBar = true;
      }
    },
    onComplete: function onComplete(file, result) {
      var _this = this;

      if (result === 'success') {
        localStorage.setItem('avatarUrl', file.dataUrl);
        this.avatarImg = file.dataUrl;
        __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["c" /* accountService */].$emit(__WEBPACK_IMPORTED_MODULE_5__events__["a" /* AVATAR_IMG_UPDATED */]);
        this.isSuccess = true;
      }

      setTimeout(function () {
        _this.displayProgressBar = false;
        if (result !== 'success') {
          _this.hasError = true;
        }
        _this.isSuccess = false;
      }, 2500);
    },
    dismissErrorAlert: function dismissErrorAlert() {
      this.hasError = false;
    },
    getAccount: function getAccount() {
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      return __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].get('/accounts/' + userId + '?access_token=' + token);
    },
    editAccount: function editAccount() {
      var _this2 = this;

      this.loading = true;
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].put('/accounts/' + userId + '?access_token=' + token, {
        firstName: this.account.firstName,
        lastName: this.account.lastName,
        email: this.account.email
      }).then(function (response) {
        console.log(response);
        _this2.loading = false;
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('Success !', 'Your account has been updated!!', 'success');
      }).catch(function (e) {
        console.log(e);
      });
    },
    updatePass: function updatePass() {
      var _this3 = this;

      this.loading1 = true;
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      var oldPassword = this.credentials.oldPassword;
      var newPassword = this.credentials.newPassword;
      // let confirmPass = this.credentials.confirmPass
      // if (newPassword === confirmPass) {
      // console.log('Changing Pass ...')
      __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].post('/accounts/' + userId + '/changePassword?access_token=' + token, {
        oldPassword: oldPassword,
        newPassword: newPassword
      }).then(function (response) {
        _this3.loading1 = false;
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()('Success', 'Your Password has been updated!!', 'success');
      });
      this.loading1 = false;
    }
  },
  beforeMount: function beforeMount() {
    var _this4 = this;

    if (!localStorage.getItem('authToken')) {
      return this.$router.push('/login');
    }

    var avatarUrl = localStorage.getItem('avatarUrl');
    var defaultAvatarUrl = '/static/img/default_avatar.png';

    if (avatarUrl.length === 0) {
      this.avatarImg = defaultAvatarUrl;
    } else {
      this.avatarImg = avatarUrl;
    }

    this.getAccount().then(function (result) {
      _this4.account = result.data;
    });
  },
  mounted: function mounted() {
    this.$scrollTo('#top', 1000);
    this.getAccount();
  },

  props: ['loggedIn']
});

/***/ }),
/* 324 */,
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main has-submenu",staticStyle:{"margin":"auto"},attrs:{"id":"top"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 col-sm-6 col-xs-12"},[_c('vue-clip',{attrs:{"options":_vm.options,"onAddedFile":_vm.onAddedFile,"onComplete":_vm.onComplete},scopedSlots:_vm._u([{key:"clip-uploader-body",fn:function(props){return [(_vm.displayProgressBar)?_c('div',{staticClass:"progress progress-bar-striped progress-bar-animated",class:(props.files[0].status === 'error') ? 'bg-danger' : '',staticStyle:{"height":"4px","border-radius":"0"}},[_c('div',{staticClass:"progress-bar",style:({width: props.files[0].progress +'%'}),attrs:{"role":"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"}},[_c('span',{staticClass:"sr-only"},[_vm._v("{props.files[0].progress}% complete")])])]):_vm._e(),_vm._v(" "),(_vm.hasError)?_c('div',{staticClass:"alert alert-danger alert-dismissable"},[_c('a',{staticClass:"panel-close close",on:{"click":function($event){$event.preventDefault();_vm.dismissErrorAlert($event)}}},[_c('i',{staticClass:"fa fa-times"})]),_vm._v(" "),_c('p',[_vm._v("Image upload failed, please try again later.")])]):_vm._e(),_vm._v(" "),(_vm.isSuccess)?_c('div',{staticClass:"alert alert-success"},[_c('p',[_vm._v("Image upload successful")])]):_vm._e()]}}])},[_c('template',{slot:"clip-uploader-action"},[_c('div',{staticClass:"fancy-dropzone"},[_c('img',{staticClass:"img-response avatar img-circle",attrs:{"src":_vm.avatarImg,"alt":"avatar"}}),_vm._v(" "),_c('div',{staticClass:"dz-message upload-drop-zone img-responsive avatar img-circle img-thumbnail",class:(_vm.displayProgressBar) ? 'blurred': '',attrs:{"id":"drop-zone","disabled":_vm.displayProgressBar}},[_c('label',[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Change picture\n                ")])])])])],2)],1),_vm._v(" "),_c('div',{staticClass:"col-md-8 col-sm-6 col-xs-12 personal-info"},[_c('h3',[_vm._v("Personal info")]),_vm._v(" "),_c('form',{staticClass:"form-horizontal form",attrs:{"role":"form"},on:{"submit":function($event){$event.preventDefault();_vm.editAccount($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-lg-3 control-label"},[_vm._v("First name:")]),_vm._v(" "),_c('div',{staticClass:"col-lg-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.firstName),expression:"account.firstName"}],staticClass:"form-control",attrs:{"required":"","type":"text"},domProps:{"value":(_vm.account.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "firstName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-lg-3 control-label"},[_vm._v("Last name:")]),_vm._v(" "),_c('div',{staticClass:"col-lg-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.lastName),expression:"account.lastName"}],staticClass:"form-control",attrs:{"required":"","type":"text"},domProps:{"value":(_vm.account.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "lastName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-lg-3 control-label"},[_vm._v("Phone:")]),_vm._v(" "),_c('div',{staticClass:"col-lg-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.phoneNumber),expression:"account.phoneNumber"}],staticClass:"form-control",attrs:{"required":"","type":"text","disabled":""},domProps:{"value":(_vm.account.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "phoneNumber", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-lg-3 control-label"},[_vm._v("Email:")]),_vm._v(" "),_c('div',{staticClass:"col-lg-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.account.email),expression:"account.email"}],staticClass:"form-control",attrs:{"required":"","type":"text"},domProps:{"value":(_vm.account.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.account, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('vue-ladda',{attrs:{"loading":_vm.loading,"data-style":"expand-right"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(" Save change")])])],1)])]),_vm._v(" "),_c('h3',[_vm._v("Change Password")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticClass:"alert alert-danger alert-dismissable",staticStyle:{"margin-right":"20px"}},[_c('a',{staticClass:"panel-close close",attrs:{"data-dismiss":"alert"}},[_vm._v("×")]),_vm._v(" "),_c('i',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"font-size":"25px"}}),_vm._v("\n          "+_vm._s(_vm.errorMessage)+"\n      ")]),_vm._v(" "),_c('form',{staticClass:"form-horizontal form",on:{"submit":function($event){$event.preventDefault();_vm.updatePass($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Old Password:")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.oldPassword),expression:"credentials.oldPassword"}],staticClass:"form-control",attrs:{"value":"","required":"","type":"password"},domProps:{"value":(_vm.credentials.oldPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "oldPassword", $event.target.value)}}}),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("New Password:")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.newPassword),expression:"credentials.newPassword"}],staticClass:"form-control",attrs:{"required":"","type":"password"},domProps:{"value":(_vm.credentials.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "newPassword", $event.target.value)}}}),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"},[_vm._v("Confirm Password:")]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.confirmPassword),expression:"credentials.confirmPassword"}],staticClass:"form-control",attrs:{"required":"","type":"password"},domProps:{"value":(_vm.credentials.confirmPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "confirmPassword", $event.target.value)}}}),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"col-md-3 control-label"}),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('vue-ladda',{attrs:{"loading":_vm.loading1,"data-style":"expand-right"}},[_c('span',[_vm._v("Change Password")])])],1)])])])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkAccount_vue__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bd94ea1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkAccount_vue__ = __webpack_require__(337);
function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bd94ea1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LinkAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bd94ea1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LinkAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cards_Cards_vue__ = __webpack_require__(190);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Stripe */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LinkAccount',
  components: {
    card: __WEBPACK_IMPORTED_MODULE_2__Cards_Cards_vue__["a" /* default */]
  },
  data: function data() {
    return {
      country: '',
      currency: 0,
      name: '',
      accountType: '',
      routing: '',
      number: '',
      account: {},
      stripeID: '',
      firstName: localStorage.getItem('firstName'),
      lastName: localStorage.getItem('lastName')
    };
  },

  methods: {
    addBank: function addBank() {
      $('#add_bank').modal();
    },
    addNewBank: function addNewBank() {
      console.log('Add bank account...');
      var name = this.name;
      var number = this.number;
      var country = this.country;
      var currency = this.currency;
      var accountType = this.accountType;
      var routing = this.routing;
      var token = localStorage.getItem('authToken');
      var accountID = localStorage.getItem('userId');
      var url = '/accounts/' + accountID + '/banks?access_token=' + token;
      __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].post(url, {
        object: 'bank_account',
        account_number: number,
        account_holder_name: name,
        country: country,
        currency: currency,
        account_holder_type: accountType,
        routing_number: routing
      }).then(function (response) {
        // this.router.push({ name: '/account'})
        this.$route.go('/account');
        $('#add_bank').modal('hide');
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()('Success !', 'Your Bank has been added succesfully!', 'success');
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  mounted: function mounted() {
    var app = this;
    Object(__WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["b" /* account */])().then(function (response) {
      app.stripeID = response.stripeCustomerId;
    }).catch(function (e) {
      console.log(e);
    });
    /* eslint brace-style: [2, "stroustrup"] */
    // Set your Stripe publishable API key here
    Stripe.setPublishableKey('pk_test_1gJfAA34FfdhB6fLqtsJfNCi');
    $(function () {
      var $form = $('#payment-form');
      $form.submit(function (event) {
        // Clear any errors
        $form.find('.has-error').removeClass('has-error');
        // Disable the submit button to prevent repeated clicks:
        $form.find('.submit').prop('disabled', true).html("<i class='fa fa-spinner fa-spin'></i> Adding Bank account");
        // Request a token from Stripe:
        Stripe.bankAccount.createToken($form, stripeResponseHandler);
        // Prevent the form from being submitted:
        return false;
      });
      // Switch or hide 'routing number' depending on currency
      $('#currency').change(function () {
        $('#routing_number_div').show();
        $('#account_number_label').text('Account Number').next('input').attr('placeholder', '');
        $('#routing_number').attr('data-stripe', 'routing_number');
        switch (this.value) {
          case 'usd':
            $('#routing_number_label').text('Routing Number').next('input').attr('placeholder', '111000000');
            break;
          case 'eur':
            // No routing number needed
            $('#routing_number_div').hide();
            $('#routing_number').removeAttr('data-stripe');
            $('#account_number_label').text('IBAN').next('input').attr('placeholder', 'XX9828737432389');
            break;
          case 'cad':
            $('#routing_number_label').text('Transit & Institution Number');
            break;
          case 'gbp':
            $('#routing_number_label').text('Sort Code').next('input').attr('placeholder', '12-34-56');
            break;
          case 'mxn':
            $('#routing_number_label').text('CLABE');
            break;
          case 'aud':case 'nzd':
            $('#routing_number_label').text('BSB').next('input').attr('placeholder', '123456');
            break;
          case 'sgd':case 'jpy':case 'brl':case 'hkd':
            $('#routing_number_label').text('Bank / Branch Code');
            break;
        }
      });
    });
    function stripeResponseHandler(status, response) {
      var $form = $('#payment-form');
      if (response.error) {
        // Show the errors on the form
        $form.find('.errors').text(response.error.message).addClass('alert alert-danger');
        $form.find('.' + response.error.param).parent('.form-group').addClass('has-error');
        $form.find('button').prop('disabled', false).text('Pay $20');
      } else {
        // Token was created!
        $form.find('.submit').html("<i class='fa fa-check'></i> Account added");

        // Get the token ID:
        var token = response.id;
        // Insert the token and name into the form so it gets submitted to the server:
        $form.append($('<input type="hidden" name="stripeToken" />').val(token));
        // Submit the form:
        $form.get(0).submit();
      }
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;

    if (!localStorage.getItem('authToken')) {
      return this.$router.push('/login');
    }
    setTimeout(function () {
      _this.loading = false;
    }, 2000);
  },

  props: ['loggedIn']
});

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_account_services_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Cards',
  components: {
    card: __WEBPACK_IMPORTED_MODULE_0__Card__["a" /* default */]
  },
  data: function data() {
    return {
      cardNumber: '',
      cardExpiry: '',
      cardCVC: '',
      name: '',
      address_city: '',
      address_country: '',
      address_line1: '',
      address_line2: '',
      address_state: '',
      address_zip: '',
      stripeID: '',
      account: {}
    };
  },

  methods: {
    resetFormData: function resetFormData() {
      $('input[name=cardNumber]').value('');
      $('input[name=cardExpiry]').value('');
      $('input[name=name]').value('');
      // this.cardNumber = ''
      // this.cardExpiry = ''
      // this.cardCVC = ''
      // this.name = ''
      // this.address_city = ''
      // this.address_country = ''
      // this.address_line1 = ''
      // this.address_line2 = ''
      // this.address_state = ''
      // this.address_zip = ''
    },
    addCards: function addCards() {
      $('#add_creditcards').modal();
    },
    addCreditCard: function addCreditCard() {
      var _this = this;

      var $form = $('#payment-form');
      var expiry = $form.find('[name=cardExpiry]').payment('cardExpiryVal');
      var cardNumber = this.cardNumber.replace(/\s/g, '');
      // let cardExpiry = String(this.cardExpiry.toString)
      var month = String('0' + expiry.month);
      var year = String(expiry.year);
      var cvc = this.cardCVC;
      var name = this.name;
      var addressCity = this.address_city;
      var addressCountry = this.address_country;
      var addressLine1 = this.address_line1;
      var addressLine2 = this.address_line2;
      var addressState = this.address_state;
      var addressZip = this.address_zip;
      var token = localStorage.getItem('authToken');
      var accountID = localStorage.getItem('userId');
      var url = '/accounts/' + accountID + '/cards?access_token=' + token;
      __WEBPACK_IMPORTED_MODULE_2__services_account_services_js__["a" /* HTTP */].post(url, {
        object: 'card',
        exp_month: month,
        exp_year: year,
        number: cardNumber,
        cvc: cvc,
        name: name,
        address_city: addressCity,
        address_country: addressCountry,
        address_line1: addressLine1,
        address_line2: addressLine2,
        address_state: addressState,
        address_zip: addressZip
      }).then(function (response) {
        console.log(response);
        $('#add_creditcards').modal('hide');
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()('Success !', 'Your card has been added succesfully!', 'success').then(function (result) {
          _this.$router.push('/account');
        });
      }).catch(function (e) {
        console.error(e);
        __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()('Error', 'Your card was declined. Please contact your provider for more details.', 'error').then(function (result) {
          _this.$router.push('/account/link');
          $('#add_creditcards').modal('hide');
          _this.resetFormData();
        });
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (!localStorage.getItem('authToken')) {
      return this.$router.push('/login');
    }
    setTimeout(function () {
      _this2.loading = false;
    }, 2000);
  },
  mounted: function mounted() {
    var app = this;
    Object(__WEBPACK_IMPORTED_MODULE_2__services_account_services_js__["b" /* account */])().then(function (response) {
      app.stripeID = response.stripeCustomerId;
    }).catch(function (e) {
      console.error(e);
    });
    /* global Stripe */
    var $form = $('#payment-form');
    $form.find('.subscribe').on('click', payWithStripe);
    /* If you're using Stripe for payments */
    function payWithStripe(e) {
      e.preventDefault();

      var validator = void 0;

      validator = $form.validate({
        rules: {
          cardNumber: {
            required: true,
            cardNumber: true
          },
          cardExpiry: {
            required: true,
            cardExpiry: true
          },
          cardCVC: {
            required: true,
            cardCVC: true
          }
        },
        highlight: function highlight(element) {
          $(element).closest('.form-control').removeClass('success').addClass('error');
        },
        unhighlight: function unhighlight(element) {
          $(element).closest('.form-control').removeClass('error').addClass('success');
        },
        errorPlacement: function errorPlacement(error, element) {
          $(element).closest('.form-group').append(error);
        }
      });

      /* Abort if invalid form data */
      if (!validator.form()) {
        return;
      }

      /* Visual feedback */
      $form.find('.subscribe').html('Validating <i class="fa fa-spinner fa-pulse"></i>').prop('disabled', true);

      var PublishableKey = 'pk_test_1gJfAA34FfdhB6fLqtsJfNCi';
      Stripe.setPublishableKey(PublishableKey);
    }

    /* Fancy restrictive input formatting via jQuery.payment library */
    $('input[name=cardNumber]').payment('formatCardNumber');
    $('input[name=cardCVC]').payment('formatCardCVC');
    $('input[name=cardExpiry').payment('formatCardExpiry');

    /* Form validation using Stripe client-side validation helpers */
    jQuery.validator.addMethod('cardNumber', function (value, element) {
      return this.optional(element) || Stripe.card.validateCardNumber(value);
    }, 'Please specify a valid credit card number.');

    jQuery.validator.addMethod('cardExpiry', function (value, element) {
      /* Parsing month/year uses jQuery.payment library */
      value = $.payment.cardExpiryVal(value);
      return this.optional(element) || Stripe.card.validateExpiry(value.month, value.year);
    }, 'Invalid expiration date.');

    jQuery.validator.addMethod('cardCVC', function (value, element) {
      return this.optional(element) || Stripe.card.validateCVC(value);
    }, 'Invalid CVC.');

    var paymentFormReady = void 0;
    paymentFormReady = function paymentFormReady() {
      if ($form.find('[name=cardNumber]').hasClass('success') && $form.find('[name=cardExpiry]').hasClass('success') && $form.find('[name=cardCVC]').val().length > 1) {
        return true;
      } else {
        return false;
      }
    };

    $form.find('.subscribe').prop('disabled', true);
    var readyInterval = setInterval(function () {
      if (paymentFormReady()) {
        $form.find('.subscribe').prop('disabled', false);
        clearInterval(readyInterval);
      }
    }, 250);
  },

  props: ['loggedIn']
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f693eec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__(334);
function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f693eec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_account_services_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_filters___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  // name: 'wallet',
  components: {},
  data: function data() {
    return {
      active: true,
      account: {},
      paymentMethods: {},
      hasNoCard: false,
      stripeID: '',
      loading: true
    };
  },

  methods: {
    getPaymentMethod: function getPaymentMethod() {
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      var app = this;
      __WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["a" /* HTTP */].get('/accounts/' + userId + '/paymentMethods?access_token=' + token).then(function (response) {
        app.paymentMethods = response.data;
        console.log(response.data);
        // localStorage.setItem('phone', response.data.wallets.phoneNumber)
        // console.log(response.data.wallets[0].phoneNumber)
        if (response.data.wallets.length === 0) {
          app.hasNoWallet = true;
        }
        if (response.data.cards.length === 0) {
          app.hasNoCard = true;
        }
        if (response.data.banks.length === 0) {
          app.hasNoBank = true;
        }
        if (response.data.gifts.length === 0) {
          app.hasNoGift = true;
        }
        app.loading = false;
        console.log(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteCard: function deleteCard(id) {
      var _this = this;

      console.log('Deleting card id', id);
      var userId = localStorage.getItem('userId');
      var token = localStorage.getItem('authToken');
      __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
        title: 'Are you sure who want to delete this Card ?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm(id) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            var url = '/accounts/' + userId + '/cards/' + id + '\'?access_token=' + token;
            console.log('Delete card at URL', url);
            setTimeout(function () {
              resolve(__WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["a" /* HTTP */].delete(url).then(function (response) {
                console.log(response);
              }));
            }, 1500);
          });
        }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default()({
          type: 'success',
          title: 'Wallet delete successfully',
          html: 'The Wallet has been deleted !'
        });
        _this.getPaymentMethod();
      });
    }
  },
  mounted: function mounted() {
    this.getPaymentMethod();
    var app = this;
    Object(__WEBPACK_IMPORTED_MODULE_4__services_account_services_js__["b" /* account */])().then(function (response) {
      app.account = response;
      app.stripeID = app.account.stripeCustomerId;
      // console.log(app.stripeID)
      console.log(app.account.stripeCustomerId);
    });
  }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"list-group"},[_vm._l((_vm.paymentMethods.cards),function(creditCard){return _c('li',{key:creditCard.id,staticClass:"list-group-item"},[_c('div',{staticClass:"segments",attrs:{"id":"wallets"}},[_c('div',{staticClass:"item"},[(creditCard.brand == 'MasterCard')?_c('img',{staticClass:"img-responsive",staticStyle:{"display":"inline"},attrs:{"src":__webpack_require__(26),"width":"90","height":"60"}}):_c('img',{staticClass:"img-responsive",staticStyle:{"display":"inline","padding":"5px"},attrs:{"src":__webpack_require__(27),"width":"90","height":"60"}}),_vm._v("\n            **** ****"),_c('span',[_vm._v(" "+_vm._s(creditCard.last4))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_vm._v(_vm._s(creditCard.number))]),_vm._v(" "),_vm._m(0,true,false),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red","font-size":"18px","margin-right":"0"},on:{"click":function($event){$event.preventDefault();_vm.deleteCard(creditCard.id)}}})])])])])}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"panel-body row-fluid",staticStyle:{"text-align":"center","margin-bottom":"50px"},attrs:{"id":"loading"}},[_c('svg',{staticClass:"spinner",attrs:{"width":"45px","height":"45px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNoCard),expression:"hasNoCard"}],staticClass:"alert alert-info fade in",staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert"}},[_vm._v("×")]),_vm._v(" "),_c('i',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"font-size":"23px","float":"left"},attrs:{"aria-hidden":"true"}}),_vm._v("\n    Link a Credit or debit card to your account and use it as a payment method to pay bills"),_c('br'),_vm._v(" "),_c('router-link',{staticClass:"btn btn-info btn-circle btn-lg",attrs:{"to":"/account/link/cards","type":"button","title":"Link a credt card"}},[_c('i',{staticClass:"fa fa-plus"})])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('br'),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-heart",staticStyle:{"color":"pink","font-size":"18px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main has-submenu",class:{ fullwidth : !_vm.loggedIn }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"banner"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Your Cards")]),_vm._v(" "),_c('card'),_vm._v(" "),_c('div',{staticClass:"floating-button action-button",attrs:{"title":"Add a new Cards"},on:{"click":_vm.addCards}},[_vm._v("\n            +\n            ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"add_creditcards","data-easein":"pulse","tabindex":"-1","role":"dialog","aria-labelledby":"addbankLabel","aria-hidden":"false"}},[_c('div',{staticClass:"payment panel panel-default credit-card-box"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('form',{attrs:{"role":"form","id":"payment-form","method":"POST","action":"javascript:void(0);"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cardNumber"}},[_vm._v("CARD NUMBER")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardNumber),expression:"cardNumber",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"tel","name":"cardNumber","placeholder":"Valid Card Number","autocomplete":"cc-number","required":"","autofocus":""},domProps:{"value":(_vm.cardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cardNumber=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}}),_vm._v(" "),_vm._m(1,false,false)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_vm._m(2,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardExpiry),expression:"cardExpiry",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"tel","name":"cardExpiry","placeholder":"MM / YY","autocomplete":"cc-exp","required":""},domProps:{"value":(_vm.cardExpiry)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cardExpiry=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6 col-md-4 pull-right"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"cardCVC"}},[_vm._v("CV CODE")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.cardCVC),expression:"cardCVC",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"tel","name":"cardCVC","placeholder":"CVC","autocomplete":"cc-csc","required":""},domProps:{"value":(_vm.cardCVC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cardCVC=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("NAME")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.name),expression:"name",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"name","placeholder":"NAME","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address_city"}},[_vm._v("CITY")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address_city),expression:"address_city",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"address_city","placeholder":"CITY","required":""},domProps:{"value":(_vm.address_city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_city=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address_country"}},[_vm._v("COUNTRY")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address_country),expression:"address_country",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"address_country","placeholder":"COUNTRY","required":""},domProps:{"value":(_vm.address_country)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_country=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address_line1"}},[_vm._v("Adress 1")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address_line1),expression:"address_line1",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"address_line1","placeholder":"Adress 1","required":""},domProps:{"value":(_vm.address_line1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_line1=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address_line2"}},[_vm._v("Adress 2")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address_line2),expression:"address_line2",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"address_line2","placeholder":"Adress 2","required":""},domProps:{"value":(_vm.address_line2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_line2=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address_line1"}},[_vm._v("State")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address_state),expression:"address_state",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"text","name":"address_state","placeholder":"address_state","required":""},domProps:{"value":(_vm.address_state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_state=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"address_zip"}},[_vm._v("ZIP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address_zip),expression:"address_zip",modifiers:{"trim":true}}],staticClass:"form-control",attrs:{"type":"tel","name":"address_line2","placeholder":"ZIP","required":""},domProps:{"value":(_vm.address_zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.address_zip=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"subscribe btn btn-success btn-lg btn-block",attrs:{"type":"button"},on:{"click":_vm.addCreditCard}},[_vm._v("Add Card")])])]),_vm._v(" "),_vm._m(3,false,false)])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading display-table"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("X")]),_vm._v(" "),_c('div',{staticClass:"row display-tr"},[_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v("Add credit / debit card")]),_vm._v(" "),_c('div',[_c('img',{staticClass:"img-responsive",staticStyle:{"margin-left":"auto","margin-right":"auto"},attrs:{"src":__webpack_require__(336)}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-addon"},[_c('i',{staticClass:"fa fa-credit-card"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"cardExpiry"}},[_c('span',{staticClass:"hidden-xs"},[_vm._v("EXPIRATION")]),_c('span',{staticClass:"visible-xs-inline"},[_vm._v("EXP")]),_vm._v(" DATE")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"display":"none"}},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"payment-errors"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main has-submenu",class:{ fullwidth : !_vm.loggedIn }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticStyle:{"margin-bottom":"16px"}},[_c('div',{staticClass:"welcome"},[_c('h3',[_vm._v("Welcome, "+_vm._s(_vm.firstName)+" "+_vm._s(_vm.lastName))]),_vm._v(" "),_c('h4',[_vm._v("Topup, pay bills, send and receive LajanCash online, easily and securely")]),_vm._v(" "),_c('h4',[_vm._v("Link your wallet or debit/credit card to get started")])])]),_vm._v(" "),_c('div',{staticClass:"banner"},[_c('div',{staticClass:"addSection"},[_c('router-link',{staticStyle:{"margin-bottom":"20px"},attrs:{"to":"/account/link/wallets"}},[_c('span',{staticClass:"link",attrs:{"id":"linkLajancash"}},[_c('img',{staticClass:"img-responsive",staticStyle:{"margin-top":"10px"},attrs:{"src":__webpack_require__(338)}}),_vm._v(" "),_c('p',{staticStyle:{"padding-top":"5px"}},[_vm._v("Link your wallets account")])])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/account/link/cards"}},[_c('span',{staticClass:"link"},[_c('svg',{staticClass:"generic-card-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 46 32","width":"100px","height":"100px","fill":"#009CDE"}},[_c('path',{staticClass:"generic-card-icon-stroke",attrs:{"d":"M36.62,23.13H32.29a1.38,1.38,0,0,1-1.38-1.38V18.54a1.38,1.38,0,0,1,1.38-1.38h4.33A1.39,1.39,0,0,1,38,18.54v3.21A1.39,1.39,0,0,1,36.62,23.13Zm-4.33-5a.38.38,0,0,0-.38.38v3.21a.39.39,0,0,0,.38.38h4.33a.39.39,0,0,0,.38-.38V18.54a.38.38,0,0,0-.38-.38Z"}}),_c('path',{staticClass:"generic-card-icon-stroke",attrs:{"d":"M41.51,30H4.13A2.14,2.14,0,0,1,2,27.85V4.66A2.14,2.14,0,0,1,4.13,2.5H41.51a2.14,2.14,0,0,1,2.13,2.16V6.45a.5.5,0,1,1-1,0V4.66A1.14,1.14,0,0,0,41.51,3.5H4.13A1.14,1.14,0,0,0,3,4.66V27.85A1.14,1.14,0,0,0,4.13,29H41.51a1.14,1.14,0,0,0,1.13-1.16V11h-35a.5.5,0,1,1,0-1H43.13a.5.5,0,0,1,.5.5V27.85A2.14,2.14,0,0,1,41.51,30Z"}}),_c('path',{staticClass:"generic-card-icon-stroke",attrs:{"d":"M25.9,17.15H7.57a.5.5,0,0,1,0-1H25.9a.5.5,0,0,1,0,1Z"}})]),_vm._v(" "),_c('p',{staticClass:"svg"},[_vm._v("Link your credit card")])])])],1)])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172920cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__(346);
function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-172920cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172920cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_account_services_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__History_vue__ = __webpack_require__(342);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import RequestMoney from '../Sendmoney/RequestMoney.vue'



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_filters___default.a);
// import {HTTP} from '../../services/request-services.js'
// import axios from 'axios'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Transactions',
  components: {
    // RequestMoney
    History: __WEBPACK_IMPORTED_MODULE_3__History_vue__["a" /* default */]
  },
  data: function data() {
    return {
      histories: {},
      formSubmitted: false,
      lastStep: false,
      loading: true,
      noHistory: false,
      hasNoCardHistory: false,
      hasNoBankHistory: false,
      hasNoWalletHistory: false
    };
  },

  methods: {
    getHistory: function getHistory() {
      var _this = this;

      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      console.log('History');
      __WEBPACK_IMPORTED_MODULE_1__services_account_services_js__["a" /* HTTP */].get('/accounts/' + userId + '/history?limit=10&access_token=' + token).then(function (response) {
        if (response.data.data.lenght === 0) {
          _this.noHistory = true;
          _this.loading = false;
        } else {
          _this.histories = response.data.data;
          _this.loading = false;
          console.log(response.data);
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    if (!localStorage.getItem('authToken')) {
      return this.$router.push('/login');
    }
    setTimeout(function () {
      _this2.loading = false;
    }, 2000);
  },
  mounted: function mounted() {
    // this.getHistory()
  },

  props: ['loggedIn']
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e3c01d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__(345);
function injectStyle (ssrContext) {
  __webpack_require__(343)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63e3c01d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63e3c01d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'History',
  data: function data() {
    return {
      count: 0, // initial transaction count
      limit: 20, // amount per page
      skip: 0, // page indexer
      numberOfPages: 0,
      currentPage: 1,
      histories: {},
      noHistory: false,
      loading: true
    };
  },

  methods: {
    getTransactionCount: function getTransactionCount() {
      var userId = localStorage.getItem('userId');
      var token = localStorage.getItem('authToken');
      return __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].get('/purchases/' + userId + '/count?access_token=' + token);
    },
    setCurrentPage: function setCurrentPage(action) {
      if (action === 'INC') {
        this.skip = this.skip + this.limit;
        this.currentPage = this.currentPage + 1;
      }
      if (action === 'DEC') {
        this.skip = this.skip - this.limit;
        this.currentPage = this.currentPage - 1;
      }
      this.getHistory();
    },
    normalizePaymentMethod: function normalizePaymentMethod(paymentMethod) {
      if (!paymentMethod) return;
      return paymentMethod.split('_').join(' ');
    },

    // Set payment method only for records where the field
    // `paymentMethod` is missing in the dataset returned by the API
    injectPaymentMethod: function injectPaymentMethod(records) {
      records.forEach(function (record) {
        if (!record.payment.paymentMethod) {
          if (record.payment.phoneNumber) record.payment.paymentMethod = 'mobile_wallet';else record.payment.paymentMethod = 'credit_card';
        }
      });
    },
    getHistory: function getHistory() {
      var _this = this;

      this.loading = true;
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      var filter = '&filter[limit]=' + this.limit + '&filter[skip]=' + this.skip + '&filter[order]=created%20DESC';
      __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].get('/purchases?filter[where][accountId]=' + userId + filter + '&access_token=' + token).then(function (response) {
        if (response.data.length === 0) {
          _this.loading = false;
          _this.noHistory = true;
        } else {
          _this.histories = response.data;
          _this.injectPaymentMethod(_this.histories);
          _this.loading = false;
          _this.noHistory = false;
          // console.log(response.data)
        }
      }).catch(function (e) {
        console.error(e.message);
      });
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.getHistory();
    this.getTransactionCount().then(function (result) {
      _this2.count = result.data.count;
      _this2.numberOfPages = Math.ceil(_this2.count / _this2.limit);
    });
  }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq"},[_vm._l((_vm.histories),function(history,index){return _c('div',{key:index},[_c('input',{staticClass:"questions",attrs:{"type":"checkbox","id":index,"name":"q"}}),_vm._v(" "),_c('div',{staticClass:"plus"},[_vm._v("+")]),_vm._v(" "),_c('label',{staticClass:"question",attrs:{"for":index}},[_vm._v("\n     "+_vm._s(_vm.normalizePaymentMethod(history.payment.paymentMethod))+" payment ( ***"+_vm._s(history.payment.phoneNumber ? history.payment.phoneNumber.substring(7) : history.payment.last4)+" ) "+_vm._s(history.total)+" "+_vm._s(history.currency)+"\n     "),_c('span',[_vm._v(_vm._s(new Date(history.created).toLocaleDateString('fr-FR')))])]),_vm._v(" "),_c('div',{staticClass:"answers"},[_c('table',{staticClass:"table table-hover"},[_vm._m(0,true,false),_vm._v(" "),_c('tbody',_vm._l((history.items),function(item,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(item.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.refId || 'N/A'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(item.currency.toUpperCase())+" "+_vm._s(item.price))]),_vm._v(" "),_c('td',[(item.refId)?_c('span',[_vm._v("Payment successful")]):_vm._e(),_vm._v(" "),(!item.refId)?_c('span',[_vm._v("\n           Payment failed\n           "),(item.result)?_c('label',{staticStyle:{"color":"red","font-style":"italic"}},[_vm._v(" ("+_vm._s(item.result)+")")]):_vm._e()]):_vm._e()])])}))])])])}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"panel-body row-fluid",staticStyle:{"text-align":"center","margin-bottom":"50px"},attrs:{"id":"loading"}},[_c('svg',{staticClass:"spinner",attrs:{"width":"45px","height":"45px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_vm._e(),_vm._v(" "),(_vm.noHistory)?_c('div',{staticClass:"alert alert-info fade in",staticStyle:{"text-align":"center"}},[_vm._m(1,false,false)]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.noHistory)?_c('div',{staticStyle:{"float":"right","margin-top":"24px"}},[_c('label',{staticStyle:{"font-style":"italic"}},[_vm._v("\n       Page "+_vm._s(_vm.currentPage)+" of "+_vm._s(_vm.numberOfPages)+"\n     ")])]):_vm._e(),_vm._v(" "),(!_vm.loading && !_vm.noHistory)?_c('div',{staticClass:"btn-group pagination",attrs:{"role":"group"}},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","disabled":_vm.currentPage === 1},on:{"click":function($event){_vm.setCurrentPage('DEC')}}},[_vm._v("\n       Prev\n     ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","disabled":_vm.currentPage === _vm.numberOfPages},on:{"click":function($event){_vm.setCurrentPage('INC')}}},[_vm._v("\n       Next\n     ")])]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Product")]),_vm._v(" "),_c('th',[_vm._v("Ref")]),_vm._v(" "),_c('th',[_vm._v("Price")]),_vm._v(" "),_c('th',[_vm._v("Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"font-size":"16px"}},[_vm._v("No data found."),_c('br'),_vm._v("The purchases you made will be displayed here")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main has-submenu",class:{ fullwidth : !_vm.loggedIn }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"panel panel-info",staticStyle:{"margin-top":"0"}},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row placeholders",staticStyle:{"margin-bottom":"0"}},[_c('div',{staticClass:"col-sm-3 placeholder"},[_c('router-link',{staticClass:"btn btn-sq-lg btn-primary",attrs:{"to":"/account/transfer"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__(347),"alt":"Send money"}})]),_vm._v(" "),_vm._m(1,false,false)],1),_vm._v(" "),_c('div',{staticClass:"col-sm-3 placeholder"},[_c('router-link',{staticClass:"btn btn-sq-lg btn-primary",attrs:{"to":"/account/request"}},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__(348),"alt":"Request money"}})]),_vm._v(" "),_vm._m(2,false,false)],1)])]),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('h3',{staticClass:"font-size-normal history"},[_vm._v("Purchase History")]),_vm._v(" "),_c('history')],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title",staticStyle:{"font-size":"20px"}},[_vm._v("Transactions\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('a',{attrs:{"href":"","target":""}},[_vm._v("Send LajanCash")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('a',{attrs:{"href":"","target":""}},[_vm._v("Request LajanCash")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 347 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAACTCAMAAAC9O9snAAAAq1BMVEUAAAD+/v6UlJSIiIjw8PDl5eX+/v4AAADm5uatra2jo6P7+/ugoKDLy8uMjIyPj4/09PTV1dWzs7Obm5v6+vq4uLioqKiFhYX39/e2traYmJiRkZH9/f3d3d27u7vZ2dnIyMjFxcWrq6uHh4f4+Pjf39/T09OwsLDv7+/t7e3r6+vp6enOzs7Dw8PAwMClpaXy8vLX19e9vb3R0dH19fXi4uLKysrY2Nj///91LEPuAAAAOHRSTlMA/SgQ4Mr8BcxaRfdAlxcd6KllNvVwTwrubC8i+rt2s4+JVQ3xv6Vg3trX0ZyFgUnjrnqj68WTsXBcqTIAAAQPSURBVHja7dnZctowGIbhTzhYAS/s+76HPaVJ+t//lZUmHmSIlVLbUtwZPWcJB7yDjfRbwDAMwzAMwzAMwzD+O6XtwkXGTIioUkKmeHTmHFrIEI/ePReQHR4FXmvICo8udj6ywSNhPuT4BlZhXHl9qjsXNoWtm9DMbyz6jL42yEGj2d5h9Hf2mwVdOmW6U7sILawB3W/DoUFuTf9gr6PJbdM9dC7pvTuTNG591obuo3FEGFCYM5o0CsLVi48u9FhRyPO0Jd1bXqocevAHEnYz6X7Xn8ygS4Muykf5HjzKQZtWW1wbH7KmTREaTcUeN4Wkqd3h0GkpvuaIcmTM86EVn1OgLHnnbgmaFRkFOsiKxqUpO89wEwpskRk/xR2eGQMKjJEZNTeQndvJCOErL9+nVPXzXoEjvu4jKZHvIq5VnxRxCoinVydl5iXEwRek0IAjhhqpZNcSTLYCS+JTUyf+fibYVhJjuvETMeRvm3zEx5d04xUxPNK1NlJtyqfRNEASDRVNbAK5brN6OFSbXUi5KpraPqLx5q5MgbJ35Ig0K6ffxAqIVnigK5spIjVTb2JviFTb3r3DLtNtYuUmIq0cilCfIkJrnFpT21kvG77s0UXigCjulp0lb7KLkBqSVAeRrGJjtVfZ1CS5fhEyBYVNX49Xbf87mn7Sl7xvaOpSFCauXk97E/9BEZzmQAwj2ptm/aikIvglas61NLXcztHCu2l0EtBa0Af7iHfWseNyZU3NMhHVO2Ie+px0ZrXpww5nfOgQ0fNRSZNYj04A+IYu2DP9UXfxB69Q4BFne/pQVNEkpg2nFz7MJFb1N1FJVAaQs+nDA1fR5FLArp4DQ0mAv45IIpuHxku7q6KpSqFDsN7lvVY4K23dzyuE7YPvLn8UVDQVw49mFgXKpYhFS3xOJ/GMqaLJqtMH1gW4Q4EnEcV/UdhL+GF63lLRhGqQ5AHgTySiPieJ8+Dg4rGVovVp6DBizOMA+IiuosS/hCXOWjtixOoNZet4r/rW6IoPTURFJdnTYGRvjKslLfudTyHr0iVJcGba54LFVVRvRLdG+ucnl8L6dIvV9DdhQF/6gW9o6tr0BSensUnokBxbQWeT4MmTxlDYRI/5ytDlspk8GltCwi/WOomahLzk7thHJ50QqVd5TvNcxalKLkSbbsgPPKr1VM965OfZ1sS5LqofZtIDj5SbaN1CtNIpzxgLDtBfh750jU2/iU6Q8gvDcaUyHk59yLSeVDSNkESRVDSVkcRJ0pTwdwQL8fEfqTRVbpt4kqYF3agghiHdeEjCoWv2EDG4pJLtIobWhhTacsRRY6RMv4Z49qQKOyCu6QspIHbpWPzJYs5SNl/sLSTUy6WqB8MwDMMwDMMwDMMwDEOV38fBD/lQIUhkAAAAAElFTkSuQmCC"

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAACTCAMAAAC9O9snAAAC/VBMVEUAAADx8fH6+vr4+PjQ0NB8fHzw8PDExMTd3d09PT3h4eHv7+/l5eXPz8/+/v4TExP39/fFxcXg4OAcHBz5+fkAAAD19fXCwsK1tbV6enrz8/Ps7Ozj4+O8vLyWlpa4uLioqKi3t7eZmZn09PTu7u7x8fHk5OTY2NjPz8+8vLzNzc27u7vGxsaamprd3d36+vr19fXz8/P7+/vr6+v39/fq6urn5+fl5eXj4+Pl5eXe3t7Hx8ff39+/v7/X19fCwsKcnJywsLDS0tJ0dHRnZ2cmJib5+fn9/f38/Pz39/f6+vr09PTu7u719fXq6urz8/Pq6urr6+vw8PDf39/n5+ft7e309PTn5+fd3d3S0tLc3NzCwsLIyMjc3NysrKyxsbGhoaGpqamzs7Pp6enh4eGHh4eJiYm+vr6Tk5Pr6+t/f3+pqan19fX8/Pz9/f3v7+/v7+/6+vrz8/P5+fnr6+v09PTu7u729vbo6Ojs7Ozu7u7k5OTf39/t7e3m5ubq6urZ2dnW1tbe3t7Nzc3g4ODl5eXZ2dnQ0NDIyMjOzs7T09PMzMzAwMDMzMy1tbXDw8O1tbXMzMy8vLysrKzf39/W1tb4+PjFxcWQkJAnJydXV1fy8vLx8fH4+Pj7+/vr6+v6+vro6Oj6+vr6+vrh4eH09PTr6+v09PTj4+PR0dHi4uLR0dHo6Oj19fXc3Nzg4ODX19fT09PZ2dnd3d3Hx8fGxsbl5eXv7+/i4uK6urra2trz8/PHx8ebm5vExMTOzs68vLyHh4ecnJyqqqpkZGSoqKhGRka1tbWBgYHv7+/29vbm5ubv7+/5+fnk5OT09PTj4+P6+vrp6en4+Pja2tr5+fnv7+/X19fNzc3v7+/Pz8/8/Pz19fXo6Oj29vbJycnU1NTW1tb8/Pzq6uqAgIDo6OjCwsJ3d3f09PTc3Nzc3NzW1tbW1tb9/f37+/u1tbXS0tK6urqtra339/e/v7/////9/f3+/v76+vr7+/v4+Pj8/Pz19fXz8/P39/f+rcxPAAAA9XRSTlMA3yCejSj1QrALivQ5NP0F/WyfA/cI7glFD+Ddw0IiHxYQC+Pi262Mf1tRTTwsJfn4+Oji3t3Z0c+enX93ZllXMSogHRkS/fz29fHp6dnY0srEvLu5taifhHdpaU5KSj8/OjczJyQcGBUSCgX8+fPx7ezs6Ojm1tPT0svHwLq2saifkod+eXd0c25pYV9ZVVJKSUhEQT8yLicOCvb28O7a2NDHvbOtqKOblpWQj4qKhoWCfn16cGhnXVVRTUY3NTIwLicjIRsXFRP27+XSzsrEtLGjm5uXl5eOjYh8cnBrZmJfWC0qKSclyKyopqKBeG1kOTAZFV/OTzAAAAeESURBVHja7dplcBNhEAbgFy/WBFJvaalQAUqhtJRSgRaKu7u7u7u7u7u7u7u7u7tvLtIyXJKm5QIMkbuUH/f820wmeWe/y+7dTCASiUQikUgkEolEIpFIZKGvaxbZkulK9V7nAYEEdCVzpXKCIHLMI/P1iIEAvJaTBZhwGfgXm570OtoYZ/ASW9ILKwH+NWNIb6FzRqPY+ytIr/Ms8C8LJekDI41Skd6ZrGAJl+kWDLVuPjPLzOanYWCaHellFjZT/qbgmlG7XwElKee7Dc8LjjnnrZQpoR443FcnkF76tS2580NqjUzx/euDwykX/ULe8wt+1aCQ4Jn8srxwBsdkB9KwcxvST3fxOHDPr1WDu8MqM0JmioKBoyFEpKySo42jzLFNjr5qtsp1DAaKyIXMlA1cshoMUenaEujY+2l65QsD2a2aaVIZIvUosNwPtgDLX0UUNC1FM9VkI1WXAIG1KnYqVItN1bYKkbxGimTaU3NVQwCzXYm6FAOKVSSNXO6AkwNRiGa3FV21ysmambaUkcsXjAH2JhAtZusapMM2yL4S0bzJwKYycvWCsdbLFNOBWAtzYpeSGF+2TeVIpwt7eleIpJ9x4CyxOsdaLdNE0rBthPtEcn/2mPKTTln2QNcrSRWJKN0Ab2a1TE0ZYind8ZAheRGgsQPpdDwCrJDTj7porG1lfD6rZWrnSyw2zO4fRBeAjJUY0jovg2QpUf6ikFxmS/WtdlbLBOfaYYUj57IN60wUfBKYpCANRQbgSHki73RA682FC4/0sup8ypkTLNkAolJrAeR2sWVsXacACJcTLdO/JUVmZqRCe1KAp1NUI08A0VIi5ZgUneNxPTWjcir06vuwdSWJVTNFwUBuFRHFZzqqu0kYqq0mW3cHRxyHga0MsUIHbXiwYVAosRR1YGiooJkccl2qVRwc21SkwagY0ogfCY4SdWpeqWAr8P240nuKwfH5MKTHuOYBx7gQFcNY4bnFxwMczv4hZUsq1cqSZSuM8jK4v7Kz0rMUDYOhxqM3hm/ccQAG2vYia2WqAiM1LCPsc3AzShIMI42RJvfpEPiXLz/plc5knNp95aRXyB388+xHSRRGYiiJrwQCiFaQ+do3gBAkflIyV4EREMiTAa7pzZB5UY36EIxsdgYz5GgBUQrzTG0+Lwii0UWl3EyMqtphCKBVQbJEFU/wL18CWaJQcfCv3XWygHKTDAJwzH17XVrzrBu23xEi0a8y1r2WxlzXxkkggLlrpGQ2Jn4bEv1H8yn0BPj3PYwswCzPCAFMuZTKbLmq5oUw0j1PZ57nxyEyyquJdRrK8P9o5zH69cKSUpcd+F+0qm9TmhhpBf8T7cCa2+oUUpZz1pGhREzXqgHQOhRpU7B7hDN4JDnZolhg4OwSRi+KTwlE6kV3mkAr7/rMRPFVR7SEuexPvjrQ+Hhy2XhEzaqVXX18XF37VK15I3JaHP5t1iB5aN3Z0Jq2shORNHwGzFE8avWKZUsv9Krg0qOry9JR2pdGr+jVVUXJGJVDhWV+E4/Y/2txR3tAq+EAByL18ryyxO8I2FKvBIwl2xocpJRTkpJ+jo18g0vK6XdKuy7BvXzvRkRs3z56R7Z69aLGjw8I2DMxT57JTk5NPRyRxDFPlbIMlao81SuxHBhspwjqNg5Gus4QVylvW4b+juGwTdYnD3ROTahsS6SqND6xzL0k8QM75IBRJjHEF+kY3Z4MY9jkLlt1P4w50WGUpBqM0p/4M+8QWDc08cIDobW3upKSBcEo5YhHw8GaEE8X90LLaVA8/coVRulAPLKZCyDPueGtoRF41YG4ImCUHsSjwZpRcSwGGl6bz6qJg8l1DEbpTfyRj4SeZGpPhrjUPWfB+td491gkellERQYK1DJ6xQwm3njP0DdpZ3cyoKxeH0ZbQ3xQJ5Tvt0l/NE0GKMhAaF17GC+CLKD0XlLtfdo6TxrMfPaytX57hjuQgfabPWCKbKZ2pHTHjt36Xh4yLFvRvM2/tfH0ksiQRObpVKSLmriCBsbANAFkErstTdzb4ncZW+VrNsF/cDmGIS5VpT0w1VQySX9wSOa0jMk6fd9OP5veBegPGJdt9jDZQTJJj+hiTRrtzx29e+fDj/fu1PJ1CyuYOV5Nf5GwOhBmiCXTtPcp32l+QoJUpWToH5iB02GWNqVJID6PnWFmJm8SgrysX06Yy7MP6fwICbEjvthVD4T5HN1Iq9vYuLjxLsQLZd8JsERbG9IoU1T/F2LLdY+Mg0UkQ0hjMTS8CpPFpGsPw0KytLpM9mC1tjgT45YXlvPXXZSPwMpdiiyidnnkCB6MJS2Hsc2bPy5HlpB3G3oavJiuJp38yRvrBzum5WQapvPKYuBJznNkyLvu7l33733YcPPm1ZUDq7tV7l2oYPlOBRKkCob+RlFxfRPwZ9wP4grKwdn8cSVausccPjhjeoN9T5/uejCi9sahRd7aVHMrzCadH69gVOkLVhu+zx28qtOeM4Lf7P/3ALHP6Hw65wmP2Hwvms18ls/DGbxr+q7ignIV3WyG3N5eLyC2LUQikUgkEolEIpFI9H/7CfntPlIRqGt8AAAAAElFTkSuQmCC"

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Verification_vue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663740d1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Verification_vue__ = __webpack_require__(352);
function injectStyle (ssrContext) {
  __webpack_require__(350)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-663740d1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Verification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663740d1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Verification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ladda__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ladda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ladda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditProfile',
  components: {
    'vue-ladda': __WEBPACK_IMPORTED_MODULE_1_vue_ladda___default.a
  },
  data: function data() {
    return {
      email: localStorage.getItem('email'),
      phone: localStorage.getItem('phone'),
      smsCode: '',
      loading: false,
      loading2: false,
      loading3: false,
      emailVerify: false,
      phoneVerify: false
    };
  },

  methods: {
    checkIfAccountIsVerify: function checkIfAccountIsVerify() {
      var app = this;
      Object(__WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["b" /* account */])().then(function (response) {
        app.emailVerify = response.emailVerified;
        app.phoneVerify = response.phoneNumberVerified;
      }).catch(function (e) {
        console.error(e);
      });
    },
    resetVerificationEmail: function resetVerificationEmail() {
      var _this = this;

      this.loading = true;
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].post('/accounts/' + userId + '/resetVerificationToken?access_token=' + token, {
        id: userId,
        token: 'email'
      }).then(function (response) {
        console.log(response);
        _this.loading = false;
        if (response.data.message === 'success') {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Success', 'A verification link has been send to ' + _this.email + '. Please check your inbox.', 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Hoops', 'An error has occurred please try again', 'error');
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    resetVerificationPhone: function resetVerificationPhone() {
      var _this2 = this;

      this.loading2 = true;
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].post('/accounts/' + userId + '/resetVerificationToken?access_token=' + token, {
        id: userId,
        token: 'phoneNumber'
      }).then(function (response) {
        console.log(response);
        if (response.data.message === 'success') {
          _this2.loading2 = false;
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Success !', 'A verification code has been send to ' + _this2.phone + ' Please check it out !', 'success');
        } else {
          _this2.loading2 = false;
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Hoops !!', 'An error has occurred please try again !', 'error');
        }
      }).catch(function (e) {
        _this2.loading2 = false;
        console.log(e);
      });
    },
    verifySmsCode: function verifySmsCode() {
      var _this3 = this;

      this.loading3 = true;
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      console.log(this.smsCode);
      __WEBPACK_IMPORTED_MODULE_0__services_account_services_js__["a" /* HTTP */].post('/accounts/' + userId + '/verifyPhoneNumber?access_token=' + token, {
        id: userId,
        token: this.smsCode
      }).then(function (response) {
        console.log(response);
        _this3.checkIfAccountIsVerify();
        if (response.data.success === true) {
          _this3.loading3 = false;
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Success !', 'Your phone number has been verified, thank you !!', 'success');
        } else {
          _this3.loading3 = false;
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Hoops !!', 'An error has occurred please try again !', 'error');
        }
      }).catch(function (e) {
        _this3.loading3 = false;
        console.log(e);
      });
    }
  },
  beforeMount: function beforeMount() {
    if (!localStorage.getItem('authToken')) {
      return this.$router.push('/login');
    }
  },
  mounted: function mounted() {
    this.checkIfAccountIsVerify();
  },

  props: ['loggedIn']
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main has-submenu",class:{ fullwidth : !_vm.loggedIn }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 verification"},[_vm._m(0,false,false),_vm._v(" "),(_vm.emailVerify)?_c('span',{staticClass:"font-size-normal text-success"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Your email address was verified!")]):[_c('div',{staticClass:"alert alert-info alert-dismissable"},[_c('a',{staticClass:"panel-close close",attrs:{"data-dismiss":"alert"}},[_vm._v("×")]),_vm._v(" "),_c('i',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"font-size":"20px","float":"left","padding-right":"5px"}}),_vm._v("\n              Your "),_c('strong',[_vm._v("email adress")]),_vm._v(" still not verified. Please use button to send verification email "),_c('strong',[_vm._v(_vm._s(_vm.email))]),_vm._v(" to process account activation.\n          ")]),_vm._v(" "),_c('vue-ladda',{attrs:{"loading":_vm.loading,"data-style":"expand-right"},on:{"click":_vm.resetVerificationEmail}},[_c('i',{staticClass:"fa fa-reply"}),_vm._v(" "),_c('span',[_vm._v(" Send Verification Email")])])],_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),(_vm.phoneVerify)?_c('span',{staticClass:"font-size-normal text-success"},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Your mobile number was verified!")]):[_c('div',{staticClass:"alert alert-info alert-dismissable"},[_c('a',{staticClass:"panel-close close",attrs:{"data-dismiss":"alert"}},[_vm._v("×")]),_vm._v(" "),_c('i',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"font-size":"20px","float":"left","padding-right":"5px"}}),_vm._v("\n            Click on button "),_c('strong',[_vm._v("\"Send SMS Code\"")]),_vm._v(" to send verification code to your number "),_c('strong',[_vm._v(_vm._s(_vm.phone))])]),_vm._v(" "),_c('form',{attrs:{"method":""},on:{"submit":function($event){$event.preventDefault();_vm.verifySmsCode($event)}}},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("SMS code:")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smsCode),expression:"smsCode"}],staticClass:"form-control",attrs:{"type":"text","required":"required"},domProps:{"value":(_vm.smsCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.smsCode=$event.target.value}}})])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('vue-ladda',{attrs:{"loading":_vm.loading3,"data-style":"expand-right"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(" Verify SMS code")])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('vue-ladda',{attrs:{"loading":_vm.loading2,"type":"button","data-style":"expand-right"},on:{"click":_vm.resetVerificationPhone}},[_c('i',{staticClass:"fa fa-reply"}),_vm._v(" "),_c('span',{staticClass:"font-size-normal"},[_vm._v("Resend SMS Code")])])]],2)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"font-size-normal"},[_c('i',{staticClass:"fa fa-envelope-o"}),_vm._v(" Email Verification ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"font-size-normal"},[_c('i',{staticClass:"fa fa-mobile"}),_vm._v(" Mobile Verification ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallets_vue__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7495a38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallets_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7495a38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7495a38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_account_services_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Wallet__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ladda__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ladda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_ladda__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Wallets',
  components: {
    wallet: __WEBPACK_IMPORTED_MODULE_2__Wallet__["a" /* default */],
    'vue-ladda': __WEBPACK_IMPORTED_MODULE_3_vue_ladda___default.a
  },
  data: function data() {
    return {
      lcphone: '',
      lcpin: '',
      LCwallet: {},
      isActive: false,
      loading: true
    };
  },

  methods: {
    LajanCashform: function LajanCashform() {
      $('#add_lajancash').modal();
    },
    MonCashform: function MonCashform() {
      $('#add_moncash').modal();
    },
    checkStatus: function checkStatus() {
      var _this = this;

      /* eslint brace-style: [2, "stroustrup"] */
      var url = '/wallet/status?phoneNumber=' + '509' + this.lcphone + '&pincode=' + this.lcpin;
      __WEBPACK_IMPORTED_MODULE_1__services_account_services_js__["a" /* HTTP */].get(url
      // {
      //   // 'apiKey': '2d0baa3840e9ea900d9a556eb1922d14',
      //   'client': '509' + this.lcphone, // '50944405183',
      //   'currency': 'htg',
      //   'credentials': {
      //     'pincode': this.lcpin // '5183'
      //   }
      ).then(function (response) {
        console.log('Response', response);
        if (response.data.data.status === 'active') {
          _this.addLajanCash();
          console.log(response.data.message);
        } else {
          $('#add_lajancash').modal('hide');
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('Error !', 'This Lajan Cash account is not valid !', 'error');
        }
      });
    },
    addLajanCash: function addLajanCash() {
      var _this2 = this;

      console.log('Linking the account ...');
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      var firstName = localStorage.getItem('firstName');
      var lastName = localStorage.getItem('lastName');
      var url = '/wallet?access_token=' + token;
      var data = {
        phoneNumber: '509' + this.lcphone,
        firstName: firstName,
        lastName: lastName,
        pincode: this.lcpin,
        provider: 'lajancash',
        accountId: parseInt(userId)
      };
      console.log('Add LajanCash data', data);
      __WEBPACK_IMPORTED_MODULE_1__services_account_services_js__["a" /* HTTP */].post(url, data).then(function (response) {
        console.log('Add lajan cash reponse:', response);
        $('#add_lajancash').modal('hide');
        if (response.data.message) {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('Success!', 'Your LajanCash wallet has been successfully linked!', 'success');
        } else {
          __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('Error', 'Wallet link error', 'error');
        }
        _this2.$router.push('/account');
      }).catch(function (response) {
        console.error(response);
        __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()('Error', 'Something went wrong', 'error');
      });
    },
    addMonCash: function addMonCash() {
      $('#add_moncash').modal();
    }
  },
  beforeMount: function beforeMount() {
    var _this3 = this;

    setTimeout(function () {
      _this3.loading = false;
    }, 2000);
  },
  mounted: function mounted() {
    $('form').submit(function () {
      $('.blueButton').on('click', function () {
        var $this = $(this);
        $this.button('loading');
        setTimeout(function () {
          $this.button('reset');
        }, 500);
      });
    });
    var transitionTime = 0.3;
    $(document).on('click', function (e) {
      var button = document.querySelector('.action-button.is-open');
      if (button) closeActions(button);
    });
    $('.action-button').on('click', function (e) {
      e.stopPropagation();
      var target = e.currentTarget;
      if ($(target).hasClass('is-open')) return;
      openActions(target);
    });
    function closeActions(button) {
      var list = button.querySelector('.action-list');
      $('.action-list').css('display', 'none');
      var dimensions = {
        width: list.clientWidth,
        height: list.clientHeight
      };
      button.classList.remove('is-open');
      requestAnimationFrame(morphList);

      function moveButton() {
        // var buttonPosition = 0

        list.style.transition = 'margin-right ' + transitionTime / 2 + 's ease';
        button.style.transition = 'margin-right ' + transitionTime / 2 + 's ease';

        list.style.marginRight = '';
        button.style.marginRight = '';
      }

      function morphList() {
        var buttonPosition = dimensions.width / 2;

        button.style.transition = 'all ' + transitionTime + 's ease';
        list.style.transition = 'all ' + transitionTime + 's ease';

        button.style.marginRight = buttonPosition + 'px';
        list.style.marginRight = -buttonPosition + 'px';

        button.style.width = '';
        button.style.height = '';
        button.style.borderRadius = '';
        button.style.backgroundColor = '';

        list.style.opacity = '';

        $(list).one('transitionend', moveButton);
      }
    }

    function openActions(button) {
      var list = button.querySelector('.action-list');
      $('.action-list').css('display', 'unset');
      var dimensions = {
        width: list.clientWidth,
        height: list.clientHeight
      };

      button.classList.add('is-open');
      requestAnimationFrame(moveButton);

      function moveButton() {
        var buttonPosition = dimensions.width / 2 - 30;
        list.style.transition = 'margin-right ' + transitionTime / 2 + 's ease';
        button.style.transition = 'margin-right ' + transitionTime / 2 + 's ease';

        list.style.marginRight = -buttonPosition + 'px';
        button.style.marginRight = buttonPosition + 'px';

        $(button).one('transitionend', morphButton);
      }

      function morphButton() {
        button.style.transition = 'all ' + transitionTime + 's ease';
        list.style.transition = 'all ' + transitionTime + 's ease';

        button.style.marginRight = '0px';
        list.style.marginRight = '0px';

        button.style.width = dimensions.width + 'px';
        button.style.height = dimensions.height + 'px';
        button.style.borderRadius = '0';
        button.style.backgroundColor = 'rgba(255, 152, 0, 0)';

        list.style.opacity = '1';
      }
    }
  },

  props: ['loggedIn']
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78487df1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__ = __webpack_require__(359);
function injectStyle (ssrContext) {
  __webpack_require__(357)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78487df1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_account_services_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sweetalert2__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue2_filters___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  // name: 'wallet',
  components: {},
  data: function data() {
    return {
      active: true,
      account: {},
      paymentMethods: {},
      hasNoWallet: false,
      loading: true
    };
  },

  methods: {
    getPaymentMethod: function getPaymentMethod() {
      var token = localStorage.getItem('authToken');
      var userId = localStorage.getItem('userId');
      var app = this;
      __WEBPACK_IMPORTED_MODULE_3__services_account_services_js__["a" /* HTTP */].get('/accounts/' + userId + '/paymentMethods?access_token=' + token).then(function (response) {
        app.paymentMethods = response.data;
        // console.log(response.data)
        // localStorage.setItem('phone', response.data.wallets.phoneNumber)
        // console.log(response.data.wallets[0].phoneNumber)
        if (response.data.wallets.length === 0) {
          app.hasNoWallet = true;
        }
        if (response.data.cards.length === 0) {
          app.hasNoCard = true;
        }
        if (response.data.banks.length === 0) {
          app.hasNoBank = true;
        }
        if (response.data.gifts.length === 0) {
          app.hasNoGift = true;
        }
        app.loading = false;
        console.log(response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deleteWallet: function deleteWallet(id) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
        title: 'Are you sure who want to delete this wallet ?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        showLoaderOnConfirm: true,
        preConfirm: function preConfirm() {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            setTimeout(function () {
              resolve(__WEBPACK_IMPORTED_MODULE_3__services_account_services_js__["a" /* HTTP */].delete('/wallet/' + id).then(function (response) {
                // console.log(response)
              }));
            }, 1500);
          });
        },
        allowOutsideClick: false
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_4_sweetalert2___default()({
          type: 'success',
          title: 'Wallet delete successfully',
          html: 'The Wallet has been deleted !'
        });
        _this.getPaymentMethod();
      });
    }
  },
  mounted: function mounted() {
    this.getPaymentMethod();
  }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"list-group"},[_vm._l((_vm.paymentMethods.wallets),function(wallet){return _c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"segments",attrs:{"id":"wallets"}},[_vm._m(0,true,false),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_vm._v(_vm._s(wallet.phoneNumber))]),_vm._v(" "),_vm._m(1,true,false),_vm._v(" "),_c('div',{staticClass:"item"},[_c('br'),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"color":"red","font-size":"18px"},on:{"click":function($event){$event.preventDefault();_vm.deleteWallet(wallet.id)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"card-box tilebox-two tilebox-primary",staticStyle:{"border-left-color":"#188ae2"}},[_c('a',{staticClass:"pull-right",attrs:{"href":"#","title":"Add money to Lajancash wallet"}},[_c('svg',{staticClass:"add-money-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 32","width":"65px","height":"45px","fill":"#20BFD6"}},[_c('g',[_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M34.41,2.57a6.1,6.1,0,0,0-6.13,6.06,6.14,6.14,0,0,0,12.27,0A6.1,6.1,0,0,0,34.41,2.57Zm0,11.11a5.1,5.1,0,0,1-5.13-5.06,5.14,5.14,0,0,1,10.27,0A5.1,5.1,0,0,1,34.41,13.68Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M36.85,8.12H34.91V6.18a.5.5,0,0,0-1,0V8.12H32a.5.5,0,0,0,0,1h1.94v1.94a.5.5,0,0,0,1,0V9.12h1.94a.5.5,0,0,0,0-1Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M33.25,23.82a.5.5,0,0,0-1,.12c0,.12,0,.38,0,.71-4.71-.44-9.35.21-13.84.85s-9.1,1.29-13.75.83l-.5-12.26L4.58,14a.5.5,0,1,0-.16-1l-.81.15a.5.5,0,0,0-.39.51l.53,13.11a.48.48,0,0,0,0,.08.5.5,0,0,0,.43.4,33.6,33.6,0,0,0,3.8.21,75.81,75.81,0,0,0,10.62-1c4.59-.65,9.33-1.32,14.08-.79l.16,0a.5.5,0,0,0,.48-.5s0,0,0,0C33.3,24.57,33.28,24,33.25,23.82Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M33.19,16.5a.5.5,0,0,0-.5.5v4.33c-.46-.09-1.12-.19-2.07-.32a59.87,59.87,0,0,0-14.06.31,34.33,34.33,0,0,1-8.86.26V9.48a24.74,24.74,0,0,0,6.77.13L16,9.51c.09,0,9.06-.82,10-.84a.5.5,0,1,0,0-1c-.94,0-9.67.81-10,.85l-1.51.1A22.27,22.27,0,0,1,7.3,8.38a.5.5,0,0,0-.61.49V22a.5.5,0,0,0,.41.49,18,18,0,0,0,3.38.29,58.59,58.59,0,0,0,6.18-.46A59.15,59.15,0,0,1,30.5,22c1.77.25,3.15.84,3.21-.09l0-4.91A.5.5,0,0,0,33.19,16.5Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M16.9,15.27A3.11,3.11,0,1,0,20,12.16,3.11,3.11,0,0,0,16.9,15.27Zm5.22,0A2.11,2.11,0,1,1,20,13.17,2.11,2.11,0,0,1,22.11,15.27Z"}})])])]),_vm._v(" "),_c('h6',{staticClass:"text-primary text-uppercase"},[_vm._v("Balance HTG Availlable")]),_vm._v(" "),_c('h2',{staticClass:"m-b-10 ballance"},[_c('span',{attrs:{"data-plugin":"counterup"}},[_vm._v(_vm._s(_vm._f("currency")(wallet.balance.htg,'HTG ')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-6 col-md-6"},[_c('div',{staticClass:"card-box tilebox-two tilebox-success",staticStyle:{"border-left-color":"#4bd396"}},[_c('a',{staticClass:"pull-right",attrs:{"href":"#","title":"Add money to Lajancash wallet"}},[_c('svg',{staticClass:"add-money-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 32","width":"65px","height":"45px","fill":"#20BFD6"}},[_c('g',[_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M34.41,2.57a6.1,6.1,0,0,0-6.13,6.06,6.14,6.14,0,0,0,12.27,0A6.1,6.1,0,0,0,34.41,2.57Zm0,11.11a5.1,5.1,0,0,1-5.13-5.06,5.14,5.14,0,0,1,10.27,0A5.1,5.1,0,0,1,34.41,13.68Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M36.85,8.12H34.91V6.18a.5.5,0,0,0-1,0V8.12H32a.5.5,0,0,0,0,1h1.94v1.94a.5.5,0,0,0,1,0V9.12h1.94a.5.5,0,0,0,0-1Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M33.25,23.82a.5.5,0,0,0-1,.12c0,.12,0,.38,0,.71-4.71-.44-9.35.21-13.84.85s-9.1,1.29-13.75.83l-.5-12.26L4.58,14a.5.5,0,1,0-.16-1l-.81.15a.5.5,0,0,0-.39.51l.53,13.11a.48.48,0,0,0,0,.08.5.5,0,0,0,.43.4,33.6,33.6,0,0,0,3.8.21,75.81,75.81,0,0,0,10.62-1c4.59-.65,9.33-1.32,14.08-.79l.16,0a.5.5,0,0,0,.48-.5s0,0,0,0C33.3,24.57,33.28,24,33.25,23.82Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M33.19,16.5a.5.5,0,0,0-.5.5v4.33c-.46-.09-1.12-.19-2.07-.32a59.87,59.87,0,0,0-14.06.31,34.33,34.33,0,0,1-8.86.26V9.48a24.74,24.74,0,0,0,6.77.13L16,9.51c.09,0,9.06-.82,10-.84a.5.5,0,1,0,0-1c-.94,0-9.67.81-10,.85l-1.51.1A22.27,22.27,0,0,1,7.3,8.38a.5.5,0,0,0-.61.49V22a.5.5,0,0,0,.41.49,18,18,0,0,0,3.38.29,58.59,58.59,0,0,0,6.18-.46A59.15,59.15,0,0,1,30.5,22c1.77.25,3.15.84,3.21-.09l0-4.91A.5.5,0,0,0,33.19,16.5Z"}}),_vm._v(" "),_c('path',{staticClass:"add-money-icon-stroke",attrs:{"d":"M16.9,15.27A3.11,3.11,0,1,0,20,12.16,3.11,3.11,0,0,0,16.9,15.27Zm5.22,0A2.11,2.11,0,1,1,20,13.17,2.11,2.11,0,0,1,22.11,15.27Z"}})])])]),_vm._v(" "),_c('h6',{staticClass:"text-success text-uppercase"},[_vm._v("Balance USD Availlable")]),_vm._v(" "),_c('h2',{staticClass:"m-b-10 ballance"},[_c('span',{attrs:{"data-plugin":"counterup"}},[_vm._v(_vm._s(_vm._f("currency")(wallet.balance.usd,'US ')))])])])])])])}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"panel-body row-fluid",staticStyle:{"text-align":"center","margin-bottom":"50px"},attrs:{"id":"loading"}},[_c('svg',{staticClass:"spinner",attrs:{"width":"45px","height":"45px","viewBox":"0 0 66 66","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{staticClass:"path",attrs:{"fill":"none","stroke-width":"6","stroke-linecap":"round","cx":"33","cy":"33","r":"30"}})])]):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasNoWallet),expression:"hasNoWallet"}],staticClass:"alert alert-info fade in",staticStyle:{"text-align":"center"}},[_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert"}},[_vm._v("×")]),_vm._v(" "),_c('i',{staticClass:"fa fa-exclamation-triangle",staticStyle:{"font-size":"23px","float":"left"},attrs:{"aria-hidden":"true"}}),_vm._v("\n     Click on the + button to Link a wallet to your account and use it as a payment method to pay bills\n    ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('img',{staticClass:"img-responsive",staticStyle:{"margin-left":"-14px"},attrs:{"src":__webpack_require__(13),"width":"90","height":"60"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('br'),_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-heart",staticStyle:{"color":"pink","font-size":"18px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container main has-submenu",class:{ fullwidth : !_vm.loggedIn }},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"panel panel-info"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"banner"},[_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("Your wallets")]),_vm._v(" "),_c('div',{staticClass:"wallet"},[_c('wallet')],1),_vm._v(" "),_c('div',{staticClass:"floating-button action-button",attrs:{"title":"Add a new Wallet","data-toast-delay":"5"}},[_vm._v("\n                +\n                  "),_c('ul',{staticClass:"action-list"},[_c('li',{staticClass:"action-list-item",staticStyle:{"margin-top":"0"},on:{"click":_vm.LajanCashform}},[_vm._m(0,false,false)])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"add_lajancash","data-easein":"pulse","tabindex":"-1","role":"dialog","aria-labelledby":"addbankLabel","aria-hidden":"false"}},[_c('form',{staticClass:"payment",attrs:{"id":"form","name":"form"},on:{"submit":function($event){$event.preventDefault();_vm.addLajanCash($event)}}},[_vm._m(1,false,false),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"phone"}},[_vm._v("PHONE NUMBER")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"selectflag"}),_vm._v(" "),_c('div',{staticClass:"intl-tel-input allow-dropdown separate-dial-code iti-sdc-4",staticStyle:{"max-width":"480px"}},[_vm._m(2,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lcphone),expression:"lcphone"}],staticClass:"form-control",staticStyle:{"height":"40px","text-align":"left"},attrs:{"type":"tel","autocomplete":"off","id":"phone1","name":"phone","placeholder":" 3410 1234","required":"required","maxlength":"8","minlength":"8"},domProps:{"value":(_vm.lcphone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lcphone=$event.target.value}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"pin"}},[_vm._v("YOUR PIN")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lcpin),expression:"lcpin"}],staticClass:"form-control",staticStyle:{"height":"40px","max-width":"480px"},attrs:{"type":"password","id":"pin","name":"pin","placeholder":"****","required":"required","maxlength":"4","minlength":"4"},domProps:{"value":(_vm.lcpin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lcpin=$event.target.value}}}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(3,false,false)])]),_vm._v(" "),_vm._m(4,false,false)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{staticClass:"img-responsive",staticStyle:{"margin-top":"0px"},attrs:{"src":__webpack_require__(13)}}),_vm._v("LajanCash")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header",staticStyle:{"text-align":"center","margin-top":"0"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("X")]),_vm._v(" "),_c('img',{staticClass:"img-responsive",staticStyle:{"margin-left":"auto","margin-right":"auto","margin-top":"0"},attrs:{"src":__webpack_require__(13),"width":"120","height":"80"}}),_vm._v(" "),_c('h2',{staticClass:"panel-title"},[_vm._v("Add lajan cash wallet")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flag-container"},[_c('div',{staticClass:"selected-flag",attrs:{"tabindex":"0","title":"Haiti: +509"}},[_c('div',{staticClass:"iti-flag ht"}),_vm._v(" "),_c('div',{staticClass:"selected-dial-code",staticStyle:{"font-size":"18","color":"#636363"}},[_vm._v("+509")]),_vm._v(" "),_c('div',{staticClass:"iti-arrow"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"blueButton",staticStyle:{"margin-right":"7%"},attrs:{"data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"blueButton",staticStyle:{"float":"right"},attrs:{"type":"submit","id":"load","data-loading-text":"<i class='fa fa-spinner fa-spin' ></i> Linking your account..."}},[_vm._v("Link account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",attrs:{"id":"add_moncash","data-easein":"pulse","tabindex":"-1","role":"dialog","aria-labelledby":"addbankLabel","aria-hidden":"false"}},[_c('form',{staticClass:"payment"},[_c('div',{staticClass:"modal-header",staticStyle:{"text-align":"center","margin-top":"0"}},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("X")]),_vm._v(" "),_c('img',{staticClass:"img-responsive",staticStyle:{"margin-left":"auto","margin-right":"auto","margin-top":"0"},attrs:{"src":__webpack_require__(361),"width":"120","height":"100"}}),_vm._v(" "),_c('h2',{staticClass:"panel-title"},[_vm._v("Add Mon cash wallet")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"phone"}},[_vm._v("PHONE NUMBER")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"size":"60","type":"tel","id":"phone","name":"phone","placeholder":" 37 00 02 41","required":"required","maxlength":"8","minlength":"8"}}),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('label',{attrs:{"for":"pin"}},[_vm._v("YOUR PIN")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"password","id":"pin","name":"pin","placeholder":"****","required":"required","maxlength":"4","minlength":"4"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"blueButton",staticStyle:{"margin-right":"7%"},attrs:{"data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("Cancel")]),_vm._v(" "),_c('button',{staticClass:"blueButton",staticStyle:{"float":"right"},attrs:{"type":"submit"}},[_vm._v("Link account")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f0da5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__ = __webpack_require__(366);
function injectStyle (ssrContext) {
  __webpack_require__(363)
}
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16f0da5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResetPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16f0da5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResetPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_account_services__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ladda__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ladda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ladda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_getParameter__ = __webpack_require__(365);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ResetPassword',
  components: {
    'vue-ladda': __WEBPACK_IMPORTED_MODULE_1_vue_ladda___default.a
  },
  data: function data() {
    return {
      credentials: {},
      loginError: false,
      loading: false
    };
  },
  beforeMount: function beforeMount() {
    var prevRoute = localStorage.getItem('previousRoute');
    if (prevRoute === '/login') {
      this.$router.push('/checkout');
    }
  },

  methods: {
    previousStep: function previousStep() {
      this.$parent.activeStep--;
    },
    resetPass: function resetPass() {
      var _this = this;

      this.loading = true;
      var token = Object(__WEBPACK_IMPORTED_MODULE_3__services_getParameter__["a" /* getQueryString */])('token');
      console.log(token);
      if (this.credentials.password === this.credentials.passwordConfirm) {
        __WEBPACK_IMPORTED_MODULE_0__services_account_services__["a" /* HTTP */].post('/accounts/passwordReset', {
          email: this.credentials.email,
          password: this.credentials.password,
          token: token
        }).then(function (result) {
          console.log(result);
          _this.loading = false;
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Success !', 'Your password has been reset !', 'success');
          _this.$router.push('/login');
        }).catch(function (err) {
          console.log(err);
          _this.loading = false;
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()('Hoops !', 'Some thing is wrong :' + err, 'error');
        });
      }
    },
    register: function register() {
      if (this.$route.path === '/checkout') {
        this.$parent.showSignupForm = true;
      } else {
        this.$router.push('/signup');
      }
    }
  },
  props: ['loggedIn',
  // 'loading',
  'progress']
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getQueryString; });
/**
 * Get the value of a querystring
 * @param  {String} field The field to get the value of
 * @param  {String} url   The URL to get the value from (optional)
 * @return {String}       The field value
 */
var getQueryString = function getQueryString(field, url) {
  var href = window.location.href;
  var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
  var string = reg.exec(href);
  return string ? string[1] : null;
};



/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row pt10 pb50",class:{'pt30': _vm.$route.path === '/login'}},[_c('div',{staticClass:"col-md-4 col-lg-2 hidden-xs"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-md-8 col-lg-8 border-box"},[_c('div',{staticClass:"row pb10"},[_c('div',{staticClass:"col-xs-12 col-md-12"},[(_vm.$route.path === '/checkout')?_c('button',{staticClass:"btn btn-xs pull-left mt25 mr20",on:{"click":function($event){$event.preventDefault();_vm.previousStep($event)}}},[_vm._v("← Back")]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"form-signin-heading",staticStyle:{"margin-top":"18px"}},[_vm._v("Reset your password")])])]),_vm._v(" "),(_vm.loginError)?_c('div',{staticClass:"row alert alert-danger"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorPassword),expression:"errorPassword"}],staticClass:"col-lg-12 col-xs-12 col-md-12"},[_c('span',{staticClass:"glyphicon glyphicon-exclamation-sign",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Error:")]),_vm._v("\n            Password mismatch !\n          ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row border-top p10 pb10"},[_c('div',{staticClass:"col-md-8 col-lg-8 col-xs-12 no-spacing border-right"},[_c('form',{staticClass:"form-signin",on:{"submit":function($event){$event.preventDefault();_vm.resetPass($event)}}},[_c('label',{staticClass:"sr-only",attrs:{"for":"inputEmail"}},[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.email),expression:"credentials.email"}],staticClass:"form-control",attrs:{"type":"email","id":"inputEmail","placeholder":"Email address","required":"","autofocus":""},domProps:{"value":(_vm.credentials.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "email", $event.target.value)}}}),_vm._v(" "),_c('br'),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPassword","placeholder":"Password","required":""},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"sr-only",attrs:{"for":"inputPassword"}},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.passwordConfirm),expression:"credentials.passwordConfirm"}],staticClass:"form-control",attrs:{"type":"password","id":"inputPassword","placeholder":"Confirm Password","required":""},domProps:{"value":(_vm.credentials.passwordConfirm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "passwordConfirm", $event.target.value)}}}),_vm._v(" "),_c('vue-ladda',{attrs:{"loading":_vm.loading,"data-style":"expand-right"}},[_vm._v("\n                  Submit\n                ")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-lg-4 col-xs-12 no-spacing center-content grey-box"},[_c('p',{staticClass:"pb10",staticStyle:{"text-align":"left"}},[_vm._v("Don't have an account yet? Create a free account now to get started.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-default btn-block",on:{"click":function($event){$event.preventDefault();_vm.register($event)}}},[_vm._v("\n              Create account\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42f719d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoockiesPolicy_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42f719d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42f719d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoockiesPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Cookies and Similar Technologies")]),_vm._v(" "),_c('p',[_vm._v("Last updated: September, 2018")]),_vm._v(" "),_c('p',[_vm._v("Cookies are small text files that are stored in a computer’s web browser memory. They help website providers with things like understanding how people use a website, remembering a User’s login details, and storing website preferences. This page explains how we use cookies and other similar technologies to help us ensure that our Services function properly, prevent fraud and other harm, and analyze and improve the Services in accordance with our "),_c('a',{attrs:{"href":"https://app.haiitpay.com/privacy-policy"}},[_vm._v("Privacy Policy")]),_vm._v(". Any capitalized term used and not otherwise defined below has the meaning assigned to it in the Privacy Policy.")]),_vm._v(" "),_c('p',[_vm._v("1. How We Use Cookies."),_c('br'),_vm._v("\n    Cookies play an important role in helping us provide personal, effective and safe Services. We use cookies on our website. We change the cookies periodically as we improve or add to our Services, but we generally use cookies for the following purposes:"),_c('br'),_vm._v("\n    a. To Operate Our Services. Some cookies are essential to the operation of our website and Services. We use those cookies in a number of different ways, including:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Authentication. We use cookies to remember Your login state so You don’t have to login as You navigate through our site and Your dashboard. For example, when You log into Your Stripe dashboard account, we use a cookie so that You don’t have to login again as You navigate throughout the website.")]),_vm._v(" "),_c('li',[_vm._v("Fraud Prevention and Detection. Cookies and similar technologies that we deploy through websites and the Services help us learn things about computers and web browsers used to access the Services. This information helps us monitor for and detect potentially harmful or illegal use of our Services.")]),_vm._v(" "),_c('li',[_vm._v("Site Features and Services. We use cookies to remember how You prefer to use our Services so that You don’t have to reconfigure Your settings each time You log into Your account. For example, You can customize Your "),_c('a',{attrs:{"href":"https://app.haitipay.com/checkout"}},[_vm._v("HaitiPay Checkout")]),_vm._v(" experience by using the “Remember Me” feature to store Your payment details for faster checkout with participating merchants. A cookie helps us associate Your device with the payment details You provide when You sign up for the “Remember Me” feature.")])]),_vm._v(" "),_c('p',[_vm._v("b. To Analyze and Improve Our Services. Cookies help us understand how to make our website and Services work better for You. Cookies tell us how people reach our website and our Users’ websites and they give us insights into improvements or enhancements we need to make to our website and Services."),_c('br'),_vm._v("\n    c. For Better Advertising. Cookies can help us provide more effective advertising on our website. For example, we might use a cookie to help prevent You from seeing the same advertisement multiple times or to measure how many times an advertisement is viewed or clicked on.")]),_vm._v(" "),_c('p',[_vm._v("2. How We Use Other Technologies"),_c('br'),_vm._v("\n    a. Pixel tags. Pixel tags (also known as web beacons and clear GIFs) may be used in connection with some Services to, among other things, track the actions of Users (such as email recipients), measure the success of our marketing campaigns and compile statistics about usage of the Services and response rates."),_c('br'),_vm._v("\n    b. Third Party Analytics. We use Google Analytics, which uses cookies and similar technologies, to collect and analyze information about use of the Services and report on activities and trends. This service may also collect information regarding the use of other websites, apps and online resources. You can learn about Google’s practices on the "),_c('a',{attrs:{"href":"https://www.google.com/policies/privacy/partners/"}},[_vm._v("Google website")]),_vm._v(". Please refer to the table below for more on how we use third party analytics."),_c('br'),_vm._v("\n    c. Flash Cookies. We may use Adobe Flash and other technologies to, among other things, collect and store information about Your use of the Services. If You want to block or control flash cookies, You can adjust Your settings.")]),_vm._v(" "),_c('p',[_vm._v("3. How To Manage Cookies"),_c('br'),_vm._v("\n    Your web browser may allow You to change Your cookie preferences, including to delete and disable Stripe cookies. Please consult the help section of Your web browser or follow the links below to understand Your options, but please note that if You choose to disable the cookies, some features of our website or Services may not operate as intended.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Chrome: "),_c('a',{attrs:{"href":"https://support.google.com/chrome/answer/95647?hl=en"}},[_vm._v("https://support.google.com/chrome/answer/95647?hl=en")])]),_vm._v(" "),_c('li',[_vm._v("Explorer: "),_c('a',{attrs:{"href":"https://support.microsoft.com/en-us/products/windows?os=windows-10"}},[_vm._v("https://support.microsoft.com/en-us/products/windows?os=windows-10")])]),_vm._v(" "),_c('li',[_vm._v("Safari: "),_c('a',{attrs:{"href":"https://support.apple.com/kb/PH21411"}},[_vm._v("https://support.apple.com/kb/PH21411")])]),_vm._v(" "),_c('li',[_vm._v("Firefox: "),_c('a',{attrs:{"href":"https://support.mozilla.org/products/firefox/cookies"}},[_vm._v("https://support.mozilla.org/products/firefox/cookies")])]),_vm._v(" "),_c('li',[_vm._v("Opera: "),_c('a',{attrs:{"href":"http://www.opera.com/help/tutorials/security/cookies/"}},[_vm._v("http://www.opera.com/help/tutorials/security/cookies/")])])]),_vm._v(" "),_c('p',[_vm._v(" ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_817c2b9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(372);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-817c2b9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_817c2b9e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("FINTECA CORPORATION - Global Privacy Policy "),_c('br'),_vm._v("\n  For HaitiPay.com and Mobegift.com WebSites")]),_vm._v(" "),_c('p',[_vm._v("Effective date: 1 September 2018")]),_vm._v(" "),_c('p',[_vm._v("Welcome to Finteca Corporation"),_c('br'),_vm._v("\n  Finteca Corporation doing business on the Internet and in Mobile Apps under the Label MobeGift.com and/or HaitiPay.com, (collectively “Finteca”, “HaitiPay.com”,  “MobeGift.com”, “we” and “us”) respect your privacy. We offer services that enable platforms and merchants to run businesses, and to safely conduct online payment transactions."),_c('br'),_vm._v("\n  This Global Privacy Policy describes the types of Personal Data we collect through our payments products and services (“Services”) and via our online presence, which include our main websites such as mobegift.com and app.haitipay.com as well as services and websites that we enable Internet users to access, such as "),_c('a',{attrs:{"href":"https://app.haitipay.com"}},[_vm._v("HaitiPay Market Place  ")]),_vm._v(", the HaitiPay App on Google Play store   and  the HaitiPay App on IOs Store (collectively, our “Sites”). This policy also describes how we use Personal Data, with whom we share it, your rights and choices, and how you can contact us about our privacy practices. This policy does not apply to third-party websites, products, or services, even if they link to our Services or Sites, and you should consider the privacy practices of those third-parties carefully."),_c('u'),_c('br'),_vm._v("\n  This Privacy Policy is provided in a layered format. Click through to jump to a specific section.")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#overview"}},[_vm._v("Overview")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#personal-data-definition"}},[_vm._v("Personal Data We Collect")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#how-we-use-personal-data"}},[_vm._v("How We Use Personal Data")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#how-we-disclose-personal-data"}},[_vm._v("How We Disclose Personal Data")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#your-rights-and-choices"}},[_vm._v("Your Rights and Choices")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#security-and-retention"}},[_vm._v("Security and Retention")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#international-data-transfers"}},[_vm._v("International Data Transfers")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#use-by-minors"}},[_vm._v("Use by Minors")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#updates-to-this-privacy-policy-and-notifications"}},[_vm._v("Updates To this Privacy Policy")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#links-to-other-websites"}},[_vm._v("Links To Other Websites")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://app.haitipay.com/privacy-policy#jurisdiction-specific-provisions"}},[_vm._v("Jurisdiction-specific Provisions")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"id":"#contact-us"}},[_vm._v("Contact Us")])])]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('a',{attrs:{"href":"overview"}}),_vm._v(" "),_c('p',[_vm._v("1. Overview"),_c('br'),_vm._v("\n  HaitiPay.com obtains Personal Data about you from various sources to provide our Services and to manage our Sites. “You” may be a visitor to one of our websites, a user of one or more of our Services (“User” or  HaitiPay.com  User”), or a customer of a User (“Customer”). If you are a Customer, HaitiPay.com will generally not collect your Personal Data directly from you. Your agreement with the relevant HaitiPay.com User should explain how the HaitiPay.com User shares your Personal Data with HaitiPay.com, and if you have questions about this sharing, then you should direct those questions to the HaitiPay.com User."),_c('br'),_vm._v("\n  Learn more")]),_vm._v(" "),_c('a',{attrs:{"href":"personal-data-definition"}}),_vm._v(" "),_c('p',[_vm._v("2. Personal Data We Collect"),_c('br'),_vm._v("\n  a. Personal Data that we collect about you. "),_c('br'),_vm._v("\n  Personal Data is any information that relates to an identified or identifiable individual. The Personal Data that you provide directly to us through our Sites will be apparent from the context in which you provide the data. In particular:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("When you register for a HaitiPay.com account we collect your full name, email address, and account log-in credentials.")]),_vm._v(" "),_c('li',[_vm._v("When you fill-in our online form to contact our sales team, we collect your full name, work email, country, and anything else you tell us about your project, needs and timeline.")]),_vm._v(" "),_c('li',[_vm._v("When you use the “Remember Me” feature of HaitiPay.com Checkout, we collect your email address, payment card number, CVC code and expiration date.")])]),_vm._v(" "),_c('p',[_vm._v("When you respond to HaitiPay.com emails or surveys we collect your email address, name and any other information you choose to include in the body of your email or responses. If you contact us by phone, we will collect the phone number you use to call HaitiPay.com. If you contact us by phone as a HaitiPay.com User, we may collect additional information in order to verify your identity."),_c('br'),_vm._v("\n  If you are a HaitiPay.com User, you will provide your contact details, such as name, postal address, telephone number, and email address. As part of your business relationship with us, we may also receive financial and personal information about you, such as your date of birth and government identifiers associated with you and your organization (such as your social security number, tax number, or Employer Identification Number)."),_c('br'),_vm._v("\n  If you are a Customer, when you make payments or conduct transactions through a HaitiPay.com  User’s website or application, we will receive your transaction information. Depending on how the HaitiPay.com User implements our Services, we may receive this information directly from you, or from the HaitiPay.com User or third parties. The information that we collect will include payment method information (such as credit or debit card number, or bank account information), purchase amount, date of purchase, and payment method. Different payment methods may require the collection of different categories of information. The HaitiPay.com User will determine the payment methods that it enables you to use, and the payment method information that we collect will depend upon the payment method that you choose to use from the list of available payment methods that are offered to you by the HaitiPay.com User."),_c('br'),_vm._v("\n  When we conduct fraud monitoring, prevention and detection activities, we may also receive Personal Data about you from our business partners, financial service providers, identity verification services, and publicly available sources (e.g., name, address, phone number, country), as necessary to confirm your identity and prevent fraud. Our fraud monitoring, detection and prevention services may use technology that helps us assess the risk associated with an attempted transaction that is enabled on the HaitiPay.com User’s website or the application that collects information."),_c('br'),_vm._v("\n  You may also choose to submit information to us via other methods, including: (i) in response to marketing or other communications, (ii) through social media or online forums, (iii) through participation in an offer, program or promotion, (iv) in connection with an actual or potential business relationship with us, or (v) by giving us your business card or contact details at trade shows or other events."),_c('br'),_vm._v("\n  b. Information that we collect automatically on our Sites. "),_c('br'),_vm._v("\n  Our Sites use cookies and other technologies to function effectively. These technologies record information about your use of our Sites, including:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Browser and device data, such as IP address, device type, operating system and Internet browser type, screen resolution, operating system name and version, device manufacturer and model, language, plug-ins, add-ons and the language version of the Sites you are visiting;")]),_vm._v(" "),_c('li',[_vm._v("Usage data, such as time spent on the Sites, pages visited, links clicked, language preferences, and the pages that led or referred you to our Sites.")])]),_vm._v(" "),_c('p',[_vm._v("We also may collect information about your online activities on websites and connected devices over time and across third-party websites, devices, apps and other online features and services. We use Google Analytics on our Sites to help us analyze Your use of our Sites and diagnose technical issues."),_c('br'),_vm._v("\n  To learn more about the cookies that may be served through our Sites and how You can control our use of cookies and third-party analytics, please see our "),_c('a',{attrs:{"href":"https://app.haitipay.com/cookies-policy/"}},[_vm._v("Cookie Policy")]),_vm._v(".")]),_vm._v(" "),_c('a',{attrs:{"href":"how-we-use-personal-data"}}),_vm._v(" "),_c('p',[_vm._v("3. How We Use Personal Data"),_c('br'),_vm._v("\n  a. Our products and services. "),_c('br'),_vm._v("\n  We rely upon a number of legal grounds to ensure that our use of your Personal Data is compliant with applicable law. We use Personal Data to facilitate the business relationships we have with our Users, to comply with our financial regulatory and other legal obligations, and to pursue our legitimate business interests. We also use Personal Data to complete payment transactions and to provide payment-related services to our Users.")]),_vm._v(" "),_c('p',[_vm._v("b. Marketing and events-related communications. "),_c('br'),_vm._v("\n  We may send you email marketing communications about HaitiPay.com  products and services, invite you to participate in our events or surveys, or otherwise communicate with you for marketing purposes, provided that we do so in accordance with the consent requirements that are imposed by applicable law. When we collect your business contact details through our participation at trade shows or other events, we may use the information to follow-up with you regarding an event, send you information that you have requested on our products and services and, with your permission, include you on our marketing information campaigns.")]),_vm._v(" "),_c('p',[_vm._v("c. Interest-based advertising. "),_c('br'),_vm._v("\n  When you visit our Sites or online services, both we and certain third parties collect information about your online activities over time and across different sites to provide you with advertising about products and services tailored to your individual interests (this type of advertising is called “interest-based advertising”). These third parties may place or recognize a unique cookie or other technology on your browser (including the use of pixel tags). Where required by applicable law, we will obtain your consent prior to processing of your information for the purpose of interest-based advertising."),_c('br'),_vm._v("\n  You may see our ads on other websites or mobile apps because we participate in advertising networks. Ad networks allow us to target our messaging to users based on a range of factors, including demographic data, users’ inferred interests and browsing context (for example, the time and date of your visit to our Sites, the pages that you viewed, and the links that you clicked on). This technology also helps us track the effectiveness of our marketing efforts and understand if you have seen one of our advertisements."),_c('br'),_vm._v("\n  We work with Google AdWords, Facebook Ads and other advertising networks. To learn how to opt out of behavioral advertising delivered by Network Advertising Initiative member companies, please visit the "),_c('a',{attrs:{"href":"http://www.networkadvertising.org/managing/opt_out.asp"}},[_vm._v("Network Advertising Initative")]),_vm._v(" and "),_c('a',{attrs:{"href":"http://www.aboutads.info/"}},[_vm._v("Digital Advertising Alliance")]),_vm._v(". You may download the "),_c('a',{attrs:{"href":"http://youradchoices.com/appchoices"}},[_vm._v("AppChoices app")]),_vm._v(" to opt out in mobile apps. If you opt out from interest-based advertising, you may see advertising that is not relevant to you. At present, there is no industry standard for recognizing Do Not Track browser signals, so we do not respond to them.")]),_vm._v(" "),_c('a',{attrs:{"href":"how-we-disclose-personal-data"}}),_vm._v(" "),_c('p',[_vm._v("4. How We Disclose Personal Data."),_c('br'),_vm._v("\n  HaitiPay.com  does not sell or rent Personal Data to marketers or unaffiliated third parties. We share your Personal Data with trusted entities, as outlined below.")]),_vm._v(" "),_c('p',[_vm._v("a. HaitiPay.com . We share Personal Data with other HaitiPay.com  entities in order to provide our Services and for internal administration purposes.")]),_vm._v(" "),_c('p',[_vm._v("b. Service providers. We share Personal Data with a limited number of our service providers. We have service providers that provide services on our behalf, such as identity verification services, website hosting, data analysis, information technology and related infrastructure, customer service, email delivery, and auditing services. These service providers may need to access Personal Data to perform their services. We authorize such service providers to use or disclose the Personal Data only as necessary to perform services on our behalf or comply with legal requirements. We require such service providers to contractually commit to protect the security and confidentiality of Personal Data they process on our behalf. Our service providers are predominantly located in the European Union and the United States of America."),_c('br'),_vm._v("\n  c. Business partners. We share Personal Data with third party business partners when this is necessary to provide our Services to our Users. Examples of third parties to whom we may disclose Personal Data for this purpose are banks and payment method providers (such as credit card networks) when we provide payment processing services. "),_c('br'),_vm._v("\n  d. Our Users and third parties authorized by our Users. We share Personal Data with Users as necessary to maintain a User account and provide the Services. We share data with parties directly authorized by a User to receive Personal Data, such as when a User authorizes a third party application provider to access the User’s HaitiPay.com  account. The use of Personal Data by an authorized third party is subject to the third party’s privacy policy."),_c('br'),_vm._v("\n  e. Corporate transactions. In the event that we enter into, or intend to enter into, a transaction that alters the structure of our business, such as a reorganization, merger, sale, joint venture, assignment, transfer, change of control, or other disposition of all or any portion of our business, assets or stock, we may share Personal Data with third parties for the purpose of facilitating and completing the transaction."),_c('br'),_vm._v("\n  f. Compliance and harm prevention. We share Personal Data as we believe necessary: (i) to comply with applicable law, or payment method rules; (ii) to enforce our contractual rights; (iii) to protect the rights, privacy, safety and property of HaitiPay.com , you or others; and (iv) to respond to requests from courts, law enforcement agencies, regulatory agencies, and other public and government authorities, which may include authorities outside your country of residence."),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"your-rights-and-choices"}}),_vm._v("\n    5. Your Rights and Choices."),_c('br'),_vm._v("\n  You have choices regarding our use and disclosure of your Personal Data:"),_c('br'),_vm._v("\n  a. Opting out of receiving electronic communications from us. If you no longer want to receive marketing-related emails from us, you may opt-out via the unsubscribe link included in such emails. We will try to comply with your request(s) as soon as reasonably practicable. Please note that if you opt-out of receiving marketing-related emails from us, we may still send you important administrative messages that are required to provide you with our Services."),_c('br'),_vm._v("\n  b. How you can see or change your account Personal Data. If You would like to review, correct, or update Personal Data that You have previously disclosed to us, You may do so by signing in to your HaitiPay.com  account or by "),_c('a',{attrs:{"href":"https://app.haitipay.com/contact-us"}},[_vm._v("contacting us")]),_vm._v("."),_c('br'),_vm._v("\n  c. Your data protection rights. Depending on your location and subject to applicable law, you may have the following rights with regard to the Personal Data we control about you:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("The right to request confirmation of whether HaitiPay.com  processes Personal Data relating to you, and if so, to request a copy of that Personal Data;")]),_vm._v(" "),_c('li',[_vm._v("The right to request that HaitiPay.com  rectifies or updates your Personal Data that is inaccurate, incomplete or outdated;")]),_vm._v(" "),_c('li',[_vm._v("The right to request that HaitiPay.com  erase your Personal Data in certain circumstances provided by law;")]),_vm._v(" "),_c('li',[_vm._v("The right to request that HaitiPay.com  restrict the use of your Personal Data in certain circumstances, such as while HaitiPay.com  considers another request that you have submitted (including a request that HaitiPay.com  make an update to your Personal Data); and")]),_vm._v(" "),_c('li',[_vm._v("The right to request that we export to another company, where technically feasible, your Personal Data that we hold in order to provide Services to you.")])]),_vm._v(" "),_c('p',[_vm._v("Where the processing of your Personal Data is based on your previously given consent, you have the right to withdraw your consent at any time. You may also have the right to object to the processing of your Personal Data on grounds relating to your particular situation."),_c('br'),_vm._v("\n  d. Process for exercising data protection rights. In order to exercise your data protection rights, you may contact HaitiPay.com  as described in the "),_c('u',[_c('a',{attrs:{"href":"https://app.haitipay.com/contact-us"}},[_vm._v("Contact Us Section")])]),_vm._v(" below. We take each request seriously. We will comply with your request to the extent required by applicable law. We will not be able to respond to a request if we no longer hold your Personal Data. If you feel that you have not received a satisfactory response from us, you may consult with the data protection authority in your country."),_c('br'),_vm._v("\n  For your protection, we may need to verify your identity before responding to your request, such as verifying that the email address from which you send the request matches your email address that we have on file. If we no longer need to process Personal Data about you in order to provide our Services or our Sites, we will not maintain, acquire or process additional information in order to identify you for the purpose of responding to your request."),_c('br'),_vm._v("\n  If you are a Customer of a HaitiPay.com User, please direct your requests directly to the User. For example, if you are making, or have made, a purchase from a merchant using HaitiPay.com  as a payment processor, and you have a request that is related to the payment information that you provided as part of the purchase transaction, then you should address your request directly to the merchant.")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('a',{attrs:{"href":"security-and-retention"}}),_vm._v(" "),_c('p',[_vm._v("6. Security and Retention.")]),_vm._v(" "),_c('p',[_vm._v("We make reasonable efforts to ensure a level of security appropriate to the risk associated with the processing of Personal Data. We maintain organizational, technical and administrative measures designed to protect Personal Data within our organization against unauthorized access, destruction, loss, alteration or misuse. Your Personal Data is only accessible to a limited number of personnel who need access to the information to perform their duties. Unfortunately, no data transmission or storage system can be guaranteed to be 100% secure. If you have reason to believe that your interaction with us is no longer secure (for example, if you feel that the security of your account has been compromised), please "),_c('u',[_c('a',{attrs:{"href":"https://app.haitipay.com/contact-us"}},[_vm._v("contact us ")])]),_vm._v("immediately."),_c('br'),_vm._v("\n  If you are a HaitiPay.com  User, we retain your Personal Data as long as we are providing the Services to you. We retain Personal Data after we cease providing Services to you, even if you close your HaitiPay.com  account, to the extent necessary to comply with our legal and regulatory obligations, and for the purpose of fraud monitoring, detection and prevention. We also retain Personal Data to comply with our tax, accounting, and financial reporting obligations, where we are required to retain the data by our contractual commitments to our financial partners, and where data retention is mandated by the payment methods that we support. Where we retain data, we do so in accordance with any limitation periods and records retention obligations that are imposed by applicable law.")]),_vm._v("\n  #\n "),_c('a',{attrs:{"href":"international-data-transfers"}}),_vm._v(" "),_c('p',[_vm._v("7. International Data Transfers."),_c('br'),_vm._v("\n  We are a global business. Personal Data may be stored and processed in any country where we have operations or where we engage service providers. We may transfer Personal Data that we maintain about you to recipients in countries other than the country in which the Personal Data was originally collected, including to the United States. Those countries may have data protection rules that are different from those of your country. However, we will take measures to ensure that any such transfers comply with applicable data protection laws and that your Personal Data remains protected to the standards described in this Privacy Policy. In certain circumstances, courts, law enforcement agencies, regulatory agencies or security authorities in those other countries may be entitled to access your Personal Data."),_c('br'),_vm._v("\n  If you are located in the European Economic Area (“EEA”) or Switzerland, we comply with applicable laws to provide an adequate level of data protection for the transfer of your Personal Data to the US. HaitiPay.com  Inc. is certified under the EU-U.S. and the Swiss-U.S. Privacy Shield Framework and adheres to the Privacy Shield Principles. For more, see HaitiPay.com ’s Privacy Policy. In addition, we have implemented intra-group data transfer agreements which you may view upon request."),_c('br'),_vm._v("\n  Where applicable law requires us to ensure that an international data transfer is governed by a data transfer mechanism, we use one or more of the following mechanisms: EU Standard Contractual Clauses with a data recipient outside the EEA, verification that the recipient has implemented Binding Corporate Rules, or verification that the recipient adheres to the EU-US and Swiss-US Privacy Shield Framework.")]),_vm._v(" "),_c('a',{attrs:{"href":"#use-by-minors"}}),_vm._v(" "),_c('p',[_vm._v("8. Use by Minors."),_c('br'),_vm._v("\n  The Services are not directed to individuals under the age of thirteen (13), and we request that they not provide Personal Data through the Services.")]),_vm._v(" "),_c('a',{attrs:{"href":"#updates-to-this-privacy-policy-and-notifications"}}),_vm._v(" "),_c('p',[_vm._v("9. Updates To this Privacy Policy and Notifications."),_c('br'),_vm._v("\n  We may change this Privacy Policy from time to time to reflect new services, changes in our Personal Data practices or relevant laws. The “Last updated” legend at the top of this Privacy Policy indicates when this Privacy Policy was last revised. Any changes are effective when we post the revised Privacy Policy on the Services. We may provide you with disclosures and alerts regarding the Privacy Policy or Personal Data collected by posting them on our website and, if you are a User, by contacting you through your HaitiPay.com dashboard, email address and/or the physical address listed in your HaitiPay.com  account.")]),_vm._v(" "),_c('a',{attrs:{"href":"#links-to-other-websites"}}),_vm._v(" "),_c('p',[_vm._v("10. Links To Other Websites."),_c('br'),_vm._v("\n  The Services may provide the ability to connect to other websites. These websites may operate independently from us and may have their own privacy notices or policies, which we strongly suggest you review. If any linked website is not owned or controlled by us, we are not responsible for its content, any use of the website or the privacy practices of the operator of the website.")]),_vm._v(" "),_c('a',{attrs:{"id":"#jurisdiction-specific-provisions"}}),_vm._v(" "),_c('p',[_vm._v("11. Jurisdiction-specific Provisions."),_c('br'),_vm._v("\n  Residents of the European Economic Area (EEA) and Switzerland. The entity responsible for the collection and processing of Personal Data for residents of the EEA and Switzerland is HaitiPay.com  Payments Europe, Ltd., a company incorporated in Ireland and with offices at 1 Grand Canal Street Lower, Grand Canal Dock, Dublin. To exercise your rights, the Data Protection Officer may be contacted via "),_c('a',{attrs:{"href":""}},[_vm._v("dpo@HaitiPay.com")]),_vm._v("."),_c('br'),_vm._v("\n  California residents. If you are a California resident, then, subject to certain limits under California law, you may ask us to provide you with (i) a list of certain categories of Personal Data we have disclosed to third parties for their direct marketing purposes during the immediately preceding calendar year; and (ii) the identity of those third parties. To make this request, California residents may contact us as specified in the "),_c('a',{attrs:{"href":"https://app.haitipay.com/contact-us"}},[_vm._v("Contact Us")]),_vm._v(" section below."),_c('br'),_vm._v("\n  .")]),_vm._v(" "),_c('p',[_vm._v("12."),_c('a',{attrs:{"href":"#top"}},[_vm._v("Contact Us")]),_vm._v(" "),_c('br'),_vm._v("\n  If You have any questions or complaints about this Privacy Policy, please "),_c('a',{attrs:{"href":"https://app.haitipay.com/contact-us"}},[_vm._v("contact us")]),_vm._v("  electronically or send physical mail to:")]),_vm._v(" "),_c('p',[_vm._v("FINTECA CORPORATION"),_c('br'),_vm._v("\n  3479 NE 163 rd St. PMB#558"),_c('br'),_vm._v("\n  North Miami Beach, FL 33160, USA"),_c('br'),_vm._v("\n  Attention: HaitiPay.com ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d118bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__ = __webpack_require__(375);
function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var normalizeComponent = __webpack_require__(1)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55d118bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55d118bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("FINTECA CORPORATION - Global Privacy Policy "),_c('br'),_vm._v("\n  For HaitiPay.com and Mobegift.com WebSites")]),_vm._v(" "),_c('p',[_vm._v("Effective date: 1 September 2018")]),_vm._v(" "),_c('p',[_vm._v("Welcome to Finteca Corporation"),_c('br'),_vm._v("\n    Finteca Corporation doing business on the Internet and in Mobile Apps under the Label MobeGift.com and/or HaitiPay.com, (collectively “Finteca”, “HaitiPay.com”,  “MobeGift.com”, “we” and “us”). We offer services that enable platforms and merchants to run businesses, and to safely conduct online payment transactions. Please read carfully the following terms and conditions before using our services.")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Terms and Conditions of Use")]),_vm._v(" "),_c('br'),_vm._v("\n    Terms and conditions apply to the use of Mobegift.com and/or HaitiPay.com (hereinafter “Finteca”, “we”, “us” and/or “our”) Website(s) located at "),_c('a',{attrs:{"href":"https://app.haitipay.com"}},[_vm._v("https://app.haitipay.com")]),_vm._v(" and "),_c('a',{attrs:{"href":"https://www.mobegift.com/"}},[_vm._v("https://www.mobegift.com/")]),_vm._v(" all FINTECA CORPORATION associated Websites (“Website”). Each Finteca Website may have separate policies and procedures. THESE WEBSITES ARE THE PROPERTY OF FINTECA CORPORATION  BY USING  (hereinafter “User”, “you” and/or  “your”) ANY OF THESE FINTECA WEBSITES, YOU UNDERSTAND, ACKNOWLEDGE AND AGREE TO THE TERMS AND CONDITIONS OF USE CONTAINED IN THIS LEGAL NOTICE. DO NOT USE THESE WEBSITES IF YOU DO NOT AGREE TO THESE TERMS AND CONDITIONS OF USE OR ARE NOT OF SUFFICIENT LEGAL AGE TO PROVIDE INFORMATION. YOU ARE PROHIBITED FROM USING THIS WEBSITE OR SERVICES FOR ANY UNLAWFUL PURPOSE."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Void Where Prohibited By Law")]),_c('br'),_vm._v("\n    Any product, service, feature, or function offered on the Website is void where prohibited by law."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Downloading")]),_c('br'),_vm._v("\n    You may download material displayed on the Finteca Website for personal and non-commercial use only.  You are prohibited to distribute, modify, transmit, use, or reuse any of the contents of the Finteca Website for public or commercial purpose without the written consent of Finteca. All copyright, proprietary notices, and rules on downloaded and/or copied material must be retained."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Prohibited Activities")]),_c('br'),_vm._v("\n    Unauthorized access to any part of this Website is prohibited.  You may not copy, scan, probe, or breach the security measures of this Website or the systems that support it."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Copyright")]),_c('br'),_vm._v("\n    Finteca recognizes the trademarks of VISA ®, MASTERCARD ®.  DISCOVER ® and MAESTRO ® in accordance with the delivery of services to Finteca. Images displayed on "),_c('a',{attrs:{"href":"https://app.haitipay.com/"}},[_vm._v("https://app.haitipay.com/")]),_vm._v(" , or  "),_c('a',{attrs:{"href":"https://www.mobegift.com/"}},[_vm._v("https://www.mobegift.com/")]),_vm._v("  are property of, or used with permission by Finteca Corporation Use of these images by third parties is prohibited unless expressed on Finteca Websites. Any unauthorized use of these images may violate copyright, trademark, and laws of privacy and publicity."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Privacy")]),_c('br'),_vm._v("\n    By using this Website, you acknowledge and expressly authorize that Finteca may provide your personal information to appropriate financial institutions, processors, and third parties under contract with affiliates for providing a subset of the payment services (i.e.: credit authorization and fraud screening). Federal and state privacy laws govern the use of personally identifiable consumer information for financial institutions. For other third parties under contract with Finteca and/or subsidiary, the use and distribution of your personal information will be used by such entity for its internal use.  These transactions are treated as confidential and will be transferred between Finteca website and you via encrypted and secured connection. Merchant is permitted to place an order based on the personal information you provide. Use of your personal information should be governed by agreement with merchant. "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("NO WARRANTY")]),_c('br'),_vm._v("\n    USE OF SERVICE IS AT INDIVIDUAL'S RISK. FINTECA OR ITS AFFILIATES, EMPLOYEES, OR AGENTS DO NOT IN ANY WAY SHAPE OR FORM WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED AND/OR ERROR FREE. THE SERVICE PROVIDED IS \"AS IS” AND “AS AVAILABLE\" WITHOUT WARRANTIES OF ANY KIND INCLUDING TITLE, MERCHANTABILITY, PUBLISHING ERRORS, OR FITNESS FOR A PARTICULAR PURPOSE.  FINTECA WILL MAKE REASONABLE EFFORTS TO ENSURE THAT REQUESTS ARE PROCESSED IN A TIMELY MANNER WITHOUT WARRANTIES REGARDING THE AMOUNT OF TIME NEEDED TO COMPLETE PROCESSING. SERVICE IS SUBJECT TO DELAYS INVOLVING INTEGRATION, BANKING, INTERNET, AND/OR INTERNATIONAL MAIL SERVICES."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("LIMITATION OF LIABILITY")]),_c('br'),_vm._v("\n    FINTECA, ITS SUBSIDIARIES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS AND/OR AFFILIATES ARE NOT LIABLE FOR DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES FROM ANY USE OF THE FINTECA SERVICE. FINTECA, ITS SUBSIDIARIES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS AND/OR AFFILIATES ARE NOT RESPONSIBLE FOR ANY ACTS OR OMISSIONS OF THIRD PARTIES RELATED TO THE SERVICE.  MOREOVER, THE MAXIMUM AGGREGATE LIABILITY OF FINTECA ITS SUBSIDIARIES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS AND/OR AFFILIATES IS LIMITED TO THE TRANSACTION FEES PAID TO FINTECA IN THE TWELVE (12) MONTHS PRIOR TO ANY CLAIM."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("INDEMNIFY FINTECA FOR DAMAGES ")]),_c('br'),_vm._v("\n    You hereby agree to indemnify and defend Finteca and its subsidiaries, officers, directors, and employees, agents and affiliates of Finteca from liabilities, losses, damages, claims, and expenses (including attorney fees and costs), whether or not a lawsuit or proceeding is filed that in any way arises out of or relates to:"),_c('br'),_vm._v("\n    (i)   Violation of the Terms and Conditions of Service;"),_c('br'),_vm._v("\n    (ii)  Improper use of the service;"),_c('br'),_vm._v("\n    (iii) Violation of property or third party rights;"),_c('br'),_vm._v("\n    (iv) Refunds or charge-backs of fees initiated pursuant to your request;"),_c('br'),_vm._v("\n    (v)  Reversed credit card payments;"),_c('br'),_vm._v("\n    (vi) Debit card and/or credit card transactions following the closing of your Finteca Account; and/or"),_c('br'),_vm._v("\n    (vii) Negligence or misconduct."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n    In the event you fail to promptly indemnify and defend such claims and/or pay Finteca expenses, Finteca shall have the right to defend itself.  Any attorney fees, costs and damages incurred by Finteca in settling such claims shall be paid by you within thirty (30) days of each and every of Finteca’s written request(s) for reimbursement."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("GOVERNING LAW")]),_c('br'),_vm._v("\n    Local laws govern this agreement.  However, there is exclusive jurisdiction for any claims or disputes with Finteca in the courts of The United States of America.  Specifically, venue for any disputes between you and Finteca shall be exclusively in Broward County, Florida, U.S.A.  The language in this agreement shall be interpreted as to its fair meaning and not strictly for or against any party."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("REVISIONS")]),_c('br'),_vm._v("\n    Finteca has the right to add or modify the terms of this agreement and delivering amended terms to user via email or the Finteca Website(s). Use of service after the date such amended terms are delivered to user, shall be deemed to constitute acceptance of such amended terms. User agrees to review these amendments to be aware of such modifications. In the event that user does not agree to modifications made, they may cancel the Finteca Account and all services with Finteca."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("DISCLAIMER")]),_c('br'),_vm._v("\n    If Finteca is notified of potential violations, Finteca may take legal action including but not limited to self-help measures such as terminating, freezing and/or blocking any accounts of yours with Finteca and/or seeking injunctive relief to immediately stop the violative activity. Finteca has the discretion to determine which action is appropriate under the circumstances. Finteca is not liable for the security of communications transmitted over Finteca's facilities."),_c('br'),_vm._v("\n    Users are responsible for protecting the confidentiality of their respective passwords, usernames and user accounts. Users may not in any way share their respective passwords, usernames and user accounts with any other person even if such person is related to the User. Users may not transfer their respective account to anyone else without the prior written consent of Finteca.  If a username is misplaced or lost, the User should send an email to "),_c('u',[_c('a',{attrs:{"href":"mailto:admin@haitipay.com"}},[_vm._v("admin@haitipay.com")]),_vm._v(" or "),_c('a',{attrs:{"href":"mailto:admin@mobegift.com"}},[_vm._v("admin@mobegift.com")])]),_c('br'),_vm._v("\n    .  Users can use the “Forgot Your Password?” button on the Finteca Website for password assistance."),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("CONSEQUENCES OF PROHIBITED BEHAVIOR")]),_c('br'),_vm._v("\n    Violation of the policies and procedures described grants Finteca the authority to restrict, block, freeze or terminate access to services.  Criminal behavior(s) will be reported to relevant governmental authorities."),_c('br'),_vm._v("\n    Finteca reserves the right to collect administrative costs and fees regarding identifying offenders freezing Finteca Accounts and terminating access to services."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n    Updated April 20, 2018"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n    Copyrighted work of FINTECA CORPORATION © 2012-2018 all rights reserved.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[191]);


// WEBPACK FOOTER //
// static/js/app.2f6e0cb39a1cc4b1681b.js